var Zt = Object.defineProperty;
var ea = (e, r, a) => r in e ? Zt(e, r, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[r] = a;
var lt = (e, r, a) => ea(e, typeof r != "symbol" ? r + "" : r, a);
import { b as B, t as ft, a as ra, c as ht, d as bt, e as ta, f as aa, g as sa, h as na, i as ia, j as la, l as Cr, k as wr, m as oa, n as da, u as ca, o as ua, p as ma, q as pa, r as We, s as ga, v as va, w as fa, x as ha, y as ba, z as ya, A as xa, B as Na, C as Ia, D as Sa, E as qa, F as Ca, G as wa, H as Ra, I as Ea, J as Fa, K as Aa, L as Pa, M as La, N as Ta, O as ka, P as Da, Q as Ga, R as Ua, S as Ma, T as $a, U as Oa, V as _a, W as za, X as Ka, Y as Qa, Z as ja, _ as Ba, $ as Ha, a0 as Va, a1 as Wa, a2 as Ya, a3 as Ja, a4 as Xa, a5 as Za, a6 as es, a7 as rs, a8 as ts, a9 as z, aa as F, ab as Hr, ac as yt, ad as xt, ae as vr, af as Vr, ag as Xe, ah as Rr, ai as Er, aj as Oe, ak as as, al as Nt, am as Ze, an as je, ao as Re, ap as ss, aq as fr, ar as ir, as as lr, at as ns, au as is, av as ls, aw as pr, ax as Fr, ay as os, az as ds, aA as cs, aB as us, aC as ms, aD as ps, aE as gs, aF as vs, aG as fs, aH as hs, aI as bs } from "./shared/useDomainIdpMapping.js";
import { aJ as ao, aK as so, aL as no, aM as io, aN as lo, aO as oo, aP as co, aQ as uo, aR as mo, aS as po, aT as go, aU as vo, aV as fo, aW as ho, aX as bo, aY as yo, aZ as xo, a_ as No, a$ as Io, b0 as So, b1 as qo, b2 as Co, b3 as wo, b4 as Ro, b5 as Eo, b6 as Fo, b7 as Ao, b8 as Po, b9 as Lo, ba as To, bb as ko, bc as Do, bd as Go, be as Uo, bf as Mo, bg as $o, bh as Oo, bi as _o, bj as zo, bk as Ko, bl as Qo, bm as jo, bn as Bo, bo as Ho, bp as Vo, bq as Wo, br as Yo, bs as Jo, bt as Xo, bu as Zo, bv as ed, bw as rd, bx as td, by as ad, bz as sd, bA as nd, bB as id, bC as ld, bD as od, bE as dd, bF as cd, bG as ud, bH as md, bI as pd, bJ as gd, bK as vd, bL as fd, bM as hd, bN as bd } from "./shared/useDomainIdpMapping.js";
import { useMemo as re, useCallback as L, useState as U, useEffect as ne, useRef as Ie, Component as ys } from "react";
import { useQueryClient as W, useMutation as Z, useQuery as te, keepPreviousData as Pe, useQueries as xs } from "@tanstack/react-query";
import { jsxs as o, jsx as t, Fragment as Ce } from "react/jsx-runtime";
import { DataTable as Ae } from "primereact/datatable";
import { Column as X } from "primereact/column";
import { Tag as ce } from "primereact/tag";
import { Button as G } from "primereact/button";
import { InputText as me } from "primereact/inputtext";
import { ProgressSpinner as It } from "primereact/progressspinner";
import { Paginator as Ns } from "primereact/paginator";
import { Dialog as fe } from "primereact/dialog";
import { InputTextarea as _e } from "primereact/inputtextarea";
import { Checkbox as Ye } from "primereact/checkbox";
import { Dropdown as ge } from "primereact/dropdown";
import { Accordion as Is, AccordionTab as Ss } from "primereact/accordion";
import { Calendar as Wr } from "primereact/calendar";
import { MultiSelect as St } from "primereact/multiselect";
import { Chip as qs } from "primereact/chip";
function be(...e) {
  return e.filter((r) => !!r).join(" ");
}
function Dr(e) {
  return B(), {
    query: wr(e),
    querySerializer: Cr
  };
}
const hr = {
  list(e, r) {
    return la({
      path: { tenantId: e },
      ...Dr(r ? { filter: r } : void 0)
    });
  },
  getById(e, r, a) {
    return ia({
      path: { tenantId: e, id: r },
      ...Dr(a ? { filter: a } : void 0)
    });
  },
  count(e, r) {
    return na({
      path: { tenantId: e },
      ...Dr(r ? { where: r } : void 0)
    });
  },
  create(e, r) {
    return B(), sa({
      path: { tenantId: e },
      body: r
    });
  },
  update(e, r, a) {
    return B(), aa({
      path: { tenantId: e, id: r },
      body: a
    });
  },
  delete(e, r) {
    return B(), ta({
      path: { tenantId: e, id: r }
    });
  },
  listMembers(e, r, a) {
    return bt({
      path: { tenantId: e, groupId: r },
      ...Dr(a ? { filter: a } : void 0)
    });
  },
  addMember(e, r, a, s = "member") {
    return B(), ht({
      path: { tenantId: e, groupId: r, userId: a },
      body: { role: s }
    });
  },
  updateMemberRole(e, r, a, s) {
    return B(), ra({
      path: { tenantId: e, groupId: r, userId: a },
      body: { role: s }
    });
  },
  removeMember(e, r, a) {
    return B(), ft({
      path: { tenantId: e, groupId: r, userId: a }
    });
  }
};
function Gr(e) {
  return B(), {
    query: wr(e),
    querySerializer: Cr
  };
}
const or = {
  list(e, r) {
    return ma({
      path: { tenantId: e },
      ...Gr(r ? { filter: r } : void 0)
    });
  },
  getById(e, r, a) {
    return ua({
      path: { tenantId: e, id: r },
      ...Gr(a ? { filter: a } : void 0)
    });
  },
  count(e, r) {
    return ca({
      path: { tenantId: e },
      ...Gr(r ? { where: r } : void 0)
    });
  },
  create(e, r) {
    return B(), da({
      path: { tenantId: e },
      body: r
    });
  },
  getGroups(e, r) {
    return oa({
      path: { tenantId: e, userId: r },
      ...Gr()
    });
  }
};
function Cs(e) {
  return typeof e == "object" && e !== null && "group" in e && typeof e.group == "object" && e.group != null;
}
function ws(e) {
  return typeof e == "object" && e !== null && "id" in e && "name" in e && typeof e.id == "number" && typeof e.name == "string";
}
function Rs(e, r) {
  return Array.isArray(e) ? e.flatMap((a) => Cs(a) ? [a] : ws(a) ? [
    {
      id: a.id,
      userId: r,
      groupId: a.id,
      tenantId: a.tenantId,
      role: "member",
      expiryDate: null,
      createdOn: "",
      warnDate: null,
      group: a
    }
  ] : []) : [];
}
const er = {
  list(e, r, a) {
    return bt({
      path: { tenantId: e, groupId: r },
      ...We(a ? { filter: a } : void 0)
    });
  },
  add(e, r, a, s) {
    return B(), ht({
      path: { tenantId: e, groupId: r, userId: a },
      body: s
    });
  },
  addMultiple(e, r, a) {
    return B(), va({
      path: { tenantId: e, groupId: r },
      body: a
    });
  },
  update(e, r, a, s) {
    return B(), ga({
      path: { tenantId: e, groupId: r, userId: a },
      body: s
    });
  },
  remove(e, r, a) {
    return B(), ft({
      path: { tenantId: e, groupId: r, userId: a }
    });
  },
  count(e, r, a) {
    return pa({
      path: { tenantId: e, groupId: r },
      ...We(a ? { where: a } : void 0)
    });
  }
}, Ar = {
  list(e, r) {
    return ya({
      path: { tenantId: e },
      ...We(r ? { filter: r } : void 0)
    });
  },
  create(e, r) {
    return B(), ba({
      path: { tenantId: e },
      body: r
    });
  },
  update(e, r, a) {
    return B(), ha({
      path: { tenantId: e, id: r },
      body: a
    });
  },
  delete(e, r) {
    return B(), fa({
      path: { tenantId: e, id: r }
    });
  }
}, Es = {
  create(e, r) {
    return B(), Na({
      path: { tenantId: e },
      body: r
    });
  }
}, Fs = {
  /** Not in the OpenAPI snapshot — keep the handwritten self-service POST. */
  create(e, r) {
    return xa().post("/auth/user/selfService/access-invitation", {
      ...r,
      isInvite: !0,
      status: "pending"
    });
  }
};
function ot(e) {
  return B(), {
    query: wr(e),
    querySerializer: Cr
  };
}
const Br = {
  list(e, r) {
    return Sa({
      path: { tenantId: e },
      ...ot(r ? { filter: r } : void 0)
    });
  },
  getById(e, r, a) {
    return Ia({
      path: { tenantId: e, id: r },
      ...ot(a ? { filter: a } : void 0)
    });
  }
}, Ue = {
  list(e, r) {
    return Da({
      path: { tenantId: e },
      ...We(r ? { filter: r } : void 0)
    });
  },
  getById(e, r) {
    return B(), ka({
      path: { tenantId: e, id: r }
    });
  },
  count(e, r) {
    return Ta({
      path: { tenantId: e },
      ...We(r ? { where: r } : void 0)
    });
  },
  create(e, r) {
    return B(), La({
      path: { tenantId: e },
      body: r
    });
  },
  update(e, r, a) {
    return B(), Pa({
      path: { tenantId: e, id: r },
      body: a
    });
  },
  delete(e, r) {
    return B(), Aa({
      path: { tenantId: e, id: r }
    });
  },
  listPermissions(e, r) {
    return B(), Fa({
      path: { tenantId: e, accessRoleId: r }
    });
  },
  addPermission(e, r, a, s) {
    return B(), Ea({
      path: { tenantId: e, id: r, permissionId: a, accessRoleId: s }
    });
  },
  removePermission(e, r, a, s) {
    return B(), Ra({
      path: { tenantId: e, id: r, permissionId: a, accessRoleId: s }
    });
  },
  listForGroup(e, r) {
    return wa({
      path: { tenantId: e, groupId: r },
      ...We({ filter: {
        include: [{ relation: "resourceServerPermissions" }]
      } })
    });
  },
  addToGroup(e, r, a) {
    return B(), Ca({
      path: { tenantId: e, groupId: r, accessRoleId: a }
    });
  },
  removeFromGroup(e, r, a) {
    return B(), qa({
      path: { tenantId: e, groupId: r, accessRoleId: a }
    });
  }
};
function As(e) {
  const { managersGroupId: r, ...a } = e, s = {
    ...a,
    ...typeof r == "number" ? { managersGroupId: r } : {}
  };
  return r === null && Object.assign(s, { managersGroupId: null }), s;
}
const br = {
  list(e, r) {
    return _a({
      path: { tenantId: e },
      ...We(r ? { filter: r } : void 0)
    });
  },
  getById(e, r) {
    return B(), Oa({
      path: { tenantId: e, id: r }
    });
  },
  count(e, r) {
    return $a({
      path: { tenantId: e },
      ...We(r ? { where: r } : void 0)
    });
  },
  create(e, r) {
    return B(), Ma({
      path: { tenantId: e },
      body: r
    });
  },
  update(e, r, a) {
    return B(), Ua({
      path: { tenantId: e, id: r },
      body: As(a)
    });
  },
  delete(e, r) {
    return B(), Ga({
      path: { tenantId: e, id: r }
    });
  }
}, Ps = 100;
async function dt(e) {
  const r = [];
  let a = 0;
  for (; ; ) {
    const { data: s } = await e(a, Ps), n = s.data ?? [];
    if (r.push(...n), n.length === 0 || typeof s.totalResources != "number" || a + n.length >= s.totalResources)
      return r;
    a += n.length;
  }
}
const Be = {
  listForUser(e, r) {
    return B(), Wa({
      path: { tenantId: e, userId: r }
    });
  },
  listForGroup(e, r) {
    return B(), Va({
      path: { tenantId: e, groupId: r }
    });
  },
  listAllUserGrants(e) {
    return B(), dt(
      (r, a) => Ja({
        path: { tenantId: e },
        query: { first: r, rows: a }
      })
    );
  },
  listAllGroupGrants(e) {
    return B(), dt(
      (r, a) => Ya({
        path: { tenantId: e },
        query: { first: r, rows: a }
      })
    );
  },
  assignToUser(e, r) {
    return B(), Ha({
      path: { tenantId: e },
      body: { ...r }
    });
  },
  assignToGroup(e, r) {
    return B(), Ba({
      path: { tenantId: e },
      body: { ...r }
    });
  },
  updateUserGrant(e, r, a) {
    return B(), ja({
      path: { tenantId: e, id: r },
      body: { ...a }
    });
  },
  updateGroupGrant(e, r, a) {
    return B(), Qa({
      path: { tenantId: e, id: r },
      body: { ...a }
    });
  },
  revokeUserGrant(e, r) {
    return B(), Ka({
      path: { tenantId: e, id: r }
    });
  },
  revokeGroupGrant(e, r) {
    return B(), za({
      path: { tenantId: e, id: r }
    });
  }
};
function Ls(e) {
  return B(), {
    query: wr(e),
    querySerializer: Cr
  };
}
const qt = {
  list(e) {
    return es({
      ...Ls(e ? { filter: e } : void 0)
    });
  },
  getById(e) {
    return B(), Za({
      path: { id: e }
    });
  },
  listTenantProviders(e) {
    return B(), Xa({
      path: { tenantId: e }
    });
  }
};
function Ts(e) {
  return B(), {
    query: wr(e),
    querySerializer: Cr
  };
}
const Ct = {
  list(e, r) {
    return ts({
      path: { tenantId: e },
      ...Ts(r ? { filter: r } : void 0)
    });
  },
  create(e, r) {
    return B(), rs({
      path: { tenantId: e },
      body: r
    });
  }
}, ar = {
  all: (e) => ["requestableAccesses", e],
  list: (e, r) => [...ar.all(e), "list", r],
  forGroup: (e, r) => [...ar.all(e), "forGroup", r]
}, wt = {
  all: (e) => ["accessRequests", e]
};
function Rt(e) {
  const { numericTenantId: r } = z();
  return te({
    queryKey: ar.forGroup(r, e),
    queryFn: async () => {
      const a = { where: { groupId: e } };
      return (await Ar.list(F(r), a)).data[0] ?? null;
    },
    enabled: r !== null && e > 0
  });
}
function ks() {
  const { numericTenantId: e } = z(), r = W();
  return Z({
    onMutate: () => ({ tenantId: F(e) }),
    mutationFn: (a) => {
      const s = F(e);
      return Ar.create(s, a).then((n) => n.data);
    },
    onSuccess: (a, s, n) => {
      r.invalidateQueries({
        queryKey: ar.all(n.tenantId)
      });
    }
  });
}
function Ds() {
  const { numericTenantId: e } = z(), r = W();
  return Z({
    onMutate: () => ({ tenantId: F(e) }),
    mutationFn: ({ id: a, data: s }) => {
      const n = F(e);
      return Ar.update(n, a, s).then((d) => d.data);
    },
    onSuccess: (a, s, n) => {
      r.invalidateQueries({
        queryKey: ar.all(n.tenantId)
      });
    }
  });
}
function Gs() {
  const { numericTenantId: e } = z(), r = W();
  return Z({
    onMutate: () => ({ tenantId: F(e) }),
    mutationFn: (a) => {
      const s = F(e);
      return Ar.delete(s, a);
    },
    onSuccess: (a, s, n) => {
      r.invalidateQueries({
        queryKey: ar.all(n.tenantId)
      });
    }
  });
}
function xl() {
  const { numericTenantId: e } = z(), r = W();
  return Z({
    onMutate: () => ({ tenantId: F(e) }),
    mutationFn: (a) => {
      const s = F(e);
      return Es.create(s, a).then((n) => n.data);
    },
    onSuccess: (a, s, n) => {
      r.invalidateQueries({
        queryKey: wt.all(n.tenantId)
      });
    }
  });
}
function Us() {
  const { numericTenantId: e } = z(), r = W();
  return Z({
    onMutate: () => ({ tenantId: F(e) }),
    mutationFn: (a) => {
      const s = F(e);
      return Fs.create(s, a).then((n) => n.data);
    },
    onSuccess: (a, s, n) => {
      r.invalidateQueries({
        queryKey: wt.all(n.tenantId)
      });
    }
  });
}
const Ms = /* @__PURE__ */ new Set(["admins", "systemAdmins"]), ve = {
  all: (e) => ["groups", e],
  list: (e, r) => [...ve.all(e), "list", r],
  detail: (e, r, a) => [...ve.all(e), "detail", r, a],
  count: (e, r) => [...ve.all(e), "count", r]
};
function dr(e, r) {
  const { numericTenantId: a } = z();
  return te({
    queryKey: ve.list(a, e),
    queryFn: () => hr.list(F(a), e).then((s) => s.data),
    enabled: a !== null && ((r == null ? void 0 : r.enabled) ?? !0),
    placeholderData: Pe
  });
}
function Et(e, r) {
  const { numericTenantId: a } = z();
  return te({
    queryKey: ve.count(a, e),
    queryFn: () => hr.count(F(a), e).then((s) => s.data.count),
    enabled: a !== null && ((r == null ? void 0 : r.enabled) ?? !0),
    placeholderData: Pe
  });
}
function Ft(e, r, a) {
  const s = vr(), n = !s || !s.gateComponents || s.hasScope("auth.groups.list"), d = e != null, l = d && !n ? "missing-list-scope" : void 0, m = ((a == null ? void 0 : a.enabled) ?? !0) && n, v = d ? {
    where: { namespaceId: e },
    fields: { id: !0, name: !0, namespaceId: !0, isPrivileged: !0 },
    order: "id ASC",
    include: r ? [
      {
        relation: "defaultGroupClients",
        scope: { where: { clientId: r }, fields: { id: !0, clientId: !0 } }
      }
    ] : void 0
  } : {
    fields: { id: !0, name: !0, namespaceId: !0, isPrivileged: !0 },
    order: "name ASC"
  }, {
    data: i,
    isLoading: u,
    isError: h,
    isPlaceholderData: g
  } = dr(v, {
    enabled: m
  }), p = u || g, f = re(() => {
    if (!m || p) return [];
    const b = i ?? [];
    return d ? b.filter((q) => q.namespaceId === e && q.isPrivileged !== !0) : b;
  }, [i, m, p, d, e]), c = re(() => {
    var b;
    if (!(!d || !r || p))
      return (b = f.find(
        (q) => q.isPrivileged !== !0 && !Ms.has(q.name) && (q.defaultGroupClients ?? []).some((C) => C.clientId === r)
      )) == null ? void 0 : b.id;
  }, [d, r, p, f]);
  return {
    options: f,
    defaultGroupId: c,
    isLoading: m && p,
    isError: m && h,
    status: l ? "unavailable" : h ? "error" : m && !p ? "resolved" : "idle",
    unavailableReason: l
  };
}
function Nl(e, r) {
  return Ft(e, r);
}
function At(e, r) {
  const { numericTenantId: a } = z();
  return te({
    queryKey: ve.detail(a, e, r),
    queryFn: () => hr.getById(F(a), e, r).then((s) => s.data),
    enabled: a !== null && e > 0
  });
}
function $s() {
  const { numericTenantId: e } = z(), r = W(), { invitationApproveIn: a, invitationApproveInUnit: s } = Hr();
  return Z({
    onMutate: () => ({ tenantId: F(e) }),
    mutationFn: async ({ enableSelfRequests: n, ...d }) => {
      const l = F(e), m = await hr.create(l, d).then((v) => v.data);
      if (n)
        try {
          await Ar.create(l, {
            accessType: "RBAC",
            accessSubType: "GENERATED_CLIENT_ACCESS",
            name: m.name,
            groupId: m.id,
            enableSelfRequests: !0,
            approveIn: a ?? xt,
            approveInUnit: s ?? yt
          });
        } catch (v) {
          console.warn("Group created but requestable access creation failed", v);
        }
      return m;
    },
    onSuccess: (n, d, l) => {
      r.invalidateQueries({ queryKey: ve.all(l.tenantId) }), r.invalidateQueries({
        queryKey: ar.all(l.tenantId)
      });
    }
  });
}
function Os() {
  const { numericTenantId: e } = z(), r = W();
  return Z({
    onMutate: () => ({ tenantId: F(e) }),
    mutationFn: ({ groupId: a, data: s }) => {
      const n = F(e);
      return hr.update(n, a, s).then((d) => d.data);
    },
    onSuccess: (a, { groupId: s }, n) => {
      r.invalidateQueries({ queryKey: ve.all(n.tenantId) }), r.invalidateQueries({
        queryKey: ve.detail(n.tenantId, s)
      });
    }
  });
}
function _s() {
  const { numericTenantId: e } = z(), r = W();
  return Z({
    onMutate: () => ({ tenantId: F(e) }),
    mutationFn: (a) => {
      const s = F(e);
      return hr.delete(s, a);
    },
    onSuccess: (a, s, n) => {
      r.invalidateQueries({ queryKey: ve.all(n.tenantId) });
    }
  });
}
const De = {
  all: (e) => ["users", e],
  list: (e, r) => [...De.all(e), "list", r],
  detail: (e, r, a) => [...De.all(e), "detail", r, a],
  count: (e, r) => [...De.all(e), "count", r],
  search: (e, r, a) => [...De.all(e), "search", r, a],
  groups: (e, r) => [...De.all(e), "groups", r]
};
function Yr(e, r) {
  const { numericTenantId: a } = z();
  return te({
    queryKey: De.list(a, e),
    queryFn: () => or.list(F(a), e).then((s) => s.data),
    enabled: a !== null && ((r == null ? void 0 : r.enabled) ?? !0),
    placeholderData: Pe
  });
}
function zs(e, r) {
  const { numericTenantId: a } = z();
  return te({
    queryKey: De.count(a, e),
    queryFn: () => or.count(F(a), e).then((s) => s.data.count),
    enabled: a !== null && ((r == null ? void 0 : r.enabled) ?? !0),
    placeholderData: Pe
  });
}
function Ks(e, r) {
  const { numericTenantId: a } = z();
  return te({
    queryKey: De.detail(a, e, r),
    queryFn: () => or.getById(F(a), e, r).then((s) => s.data),
    enabled: a !== null && e > 0
  });
}
function Qs(e, r = 20) {
  const { numericTenantId: a } = z(), s = re(() => {
    if (e)
      return {
        where: Vr(["email", "displayName", "name"], e),
        limit: r,
        order: "email ASC"
      };
  }, [e, r]);
  return te({
    queryKey: De.search(a, e, r),
    queryFn: () => or.list(F(a), s).then((n) => n.data),
    enabled: a !== null && e.length >= 2,
    placeholderData: Pe
  });
}
function Il(e) {
  const { numericTenantId: r } = z();
  return te({
    queryKey: De.groups(r, e),
    queryFn: () => or.getGroups(F(r), e).then((a) => Rs(a.data, e)),
    enabled: r !== null && e > 0
  });
}
function Pt() {
  const { numericTenantId: e } = z(), r = W();
  return Z({
    onMutate: () => ({ tenantId: F(e) }),
    mutationFn: (a) => {
      const s = F(e);
      return or.create(s, a).then((n) => n.data);
    },
    onSuccess: (a, s, n) => {
      r.invalidateQueries({ queryKey: De.all(n.tenantId) });
    }
  });
}
const Qe = {
  all: (e, r) => ["groupMembers", e, r],
  list: (e, r, a) => [...Qe.all(e, r), "list", a],
  count: (e, r, a) => [...Qe.all(e, r), "count", a]
};
function js(e, r) {
  const { numericTenantId: a } = z();
  return te({
    queryKey: Qe.list(a, e, r),
    queryFn: () => er.list(F(a), e, r).then((s) => s.data),
    enabled: a !== null && e > 0
  });
}
function Sl(e, r) {
  const { numericTenantId: a } = z();
  return te({
    queryKey: Qe.count(a, e, r),
    queryFn: () => er.count(F(a), e, r).then((s) => s.data.count),
    enabled: a !== null && e > 0
  });
}
function ql(e, r) {
  const { numericTenantId: a } = z(), s = W();
  return Z({
    onMutate: () => ({ tenantId: F(a), groupId: e }),
    mutationFn: (n) => {
      const d = F(a);
      return er.add(d, e, r, n).then((l) => l.data);
    },
    onSuccess: (n, d, l) => {
      s.invalidateQueries({
        queryKey: Qe.all(l.tenantId, l.groupId)
      }), s.invalidateQueries({
        queryKey: ve.detail(l.tenantId, l.groupId)
      }), s.invalidateQueries({
        queryKey: ve.list(l.tenantId)
      });
    }
  });
}
function Bs(e) {
  const { numericTenantId: r } = z(), a = W();
  return Z({
    onMutate: () => ({ tenantId: F(r), groupId: e }),
    mutationFn: (s) => {
      const n = F(r);
      return er.addMultiple(n, e, s).then((d) => d.data);
    },
    onSuccess: (s, n, d) => {
      a.invalidateQueries({
        queryKey: Qe.all(d.tenantId, d.groupId)
      }), a.invalidateQueries({
        queryKey: ve.detail(d.tenantId, d.groupId)
      }), a.invalidateQueries({
        queryKey: ve.list(d.tenantId)
      });
    }
  });
}
function Hs(e) {
  const { numericTenantId: r } = z(), a = W();
  return Z({
    onMutate: () => ({ tenantId: F(r), groupId: e }),
    mutationFn: ({ userId: s, data: n }) => {
      const d = F(r);
      return er.update(d, e, s, n).then((l) => l.data);
    },
    onSuccess: (s, n, d) => {
      a.invalidateQueries({
        queryKey: Qe.all(d.tenantId, d.groupId)
      }), a.invalidateQueries({
        queryKey: ve.detail(d.tenantId, d.groupId)
      });
    }
  });
}
function Vs() {
  const { numericTenantId: e } = z(), r = W();
  return Z({
    onMutate: () => ({ tenantId: F(e) }),
    mutationFn: async ({ userId: a, groups: s }) => {
      const n = F(e), d = await Promise.allSettled(
        s.map(
          (m) => er.addMultiple(n, m.id, [{ userId: a, role: "member" }])
        )
      ), l = [];
      return d.forEach((m, v) => {
        if (m.status !== "rejected") return;
        const i = s[v];
        i && l.push({ group: i, status: Xe(m.reason) });
      }), { failed: l.map((m) => m.group), failures: l };
    },
    onSuccess: (a, s, n) => {
      const d = s.groups.filter((l) => !a.failed.some((m) => m.id === l.id));
      for (const l of d)
        r.invalidateQueries({
          queryKey: Qe.all(n.tenantId, l.id)
        });
      d.length > 0 && (r.invalidateQueries({ queryKey: ve.list(n.tenantId) }), r.invalidateQueries({
        queryKey: De.groups(n.tenantId, s.userId)
      }));
    }
  });
}
function Ws(e) {
  const { numericTenantId: r } = z(), a = W();
  return Z({
    onMutate: () => ({ tenantId: F(r), groupId: e }),
    mutationFn: (s) => {
      const n = F(r);
      return er.remove(n, e, s);
    },
    onSuccess: (s, n, d) => {
      a.invalidateQueries({
        queryKey: Qe.all(d.tenantId, d.groupId)
      }), a.invalidateQueries({
        queryKey: ve.detail(d.tenantId, d.groupId)
      }), a.invalidateQueries({
        queryKey: ve.list(d.tenantId)
      });
    }
  });
}
function Ys(e, r) {
  var x;
  const { numericTenantId: a } = z(), s = (r == null ? void 0 : r.enabled) ?? !0, n = e.length > 0 && s, d = {
    where: { namespaceId: { inq: e } },
    fields: { id: !0, name: !0, namespaceId: !0 },
    order: "name ASC"
  }, {
    data: l,
    isLoading: m,
    isPlaceholderData: v,
    isError: i,
    error: u,
    refetch: h
  } = dr(d, { enabled: n }), g = re(() => !n || v ? [] : (l ?? []).map((w) => w.id), [l, n, v]), p = xs({
    queries: g.map((w) => ({
      queryKey: Qe.list(a, w),
      queryFn: () => er.list(F(a), w).then((I) => I.data.users),
      enabled: a !== null && s
    }))
  }), f = re(() => {
    const w = /* @__PURE__ */ new Map();
    for (const I of p)
      for (const S of I.data ?? [])
        w.has(S.id) || w.set(S.id, S);
    return [...w.values()];
  }, [p]), c = p.some((w) => w.isLoading), y = ((x = p.find((w) => w.isError)) == null ? void 0 : x.error) ?? null, b = n && (m || v) || c, q = i || p.some((w) => w.isError), C = u ?? y, N = L(() => {
    h(), p.forEach((w) => void w.refetch());
  }, [h, p]);
  return {
    users: f,
    isLoading: b,
    isError: q,
    error: C,
    refetch: N,
    groupCount: g.length
  };
}
const gr = {
  all: (e) => ["clients", e],
  list: (e, r) => [...gr.all(e), "list", r],
  byClientId: (e, r) => [...gr.all(e), "byClientId", r],
  detail: (e, r, a) => [...gr.all(e), "detail", r, a]
};
function Cl(e) {
  const { numericTenantId: r } = z();
  return te({
    queryKey: gr.list(r, e),
    queryFn: () => Br.list(F(r), e).then((a) => a.data),
    enabled: r !== null
  });
}
function wl(e, r) {
  var m;
  const { numericTenantId: a } = z(), s = r == null ? void 0 : r.include, n = te({
    queryKey: gr.byClientId(a, e),
    queryFn: () => Br.list(F(a), { where: { clientId: e }, limit: 1 }).then((v) => v.data[0]),
    enabled: a !== null && !!e,
    staleTime: 300 * 1e3
  }), d = (m = n.data) == null ? void 0 : m.id, l = te({
    queryKey: gr.detail(
      a,
      d,
      s == null ? void 0 : s.map((v) => v.relation)
    ),
    queryFn: () => Br.getById(F(a), d, { include: s }).then((v) => v.data),
    enabled: a !== null && d !== void 0 && s !== void 0,
    staleTime: 300 * 1e3
  });
  return s ? {
    data: l.data,
    isLoading: n.isLoading || l.isLoading,
    isError: n.isError || l.isError,
    error: n.error || l.error
  } : {
    data: n.data,
    isLoading: n.isLoading,
    isError: n.isError,
    error: n.error
  };
}
const ye = {
  all: (e) => ["accessRoles", e],
  list: (e, r) => [...ye.all(e), "list", r],
  detail: (e, r) => [...ye.all(e), "detail", r],
  count: (e, r) => [...ye.all(e), "count", r],
  permissions: (e, r) => [...ye.all(e), "permissions", r],
  forGroup: (e, r) => [...ye.all(e), "group", r]
};
function Lt(e, r) {
  const { numericTenantId: a } = z();
  return te({
    queryKey: ye.list(a, e),
    queryFn: () => Ue.list(F(a), e).then((s) => s.data),
    enabled: a !== null && ((r == null ? void 0 : r.enabled) ?? !0),
    placeholderData: Pe
  });
}
function Js(e) {
  const { numericTenantId: r } = z();
  return te({
    queryKey: ye.detail(r, e),
    queryFn: () => Ue.getById(F(r), e).then((a) => a.data),
    enabled: r !== null && e > 0
  });
}
function Xs(e, r) {
  const { numericTenantId: a } = z();
  return te({
    queryKey: ye.count(a, e),
    queryFn: () => Ue.count(F(a), e).then((s) => s.data.count),
    enabled: a !== null && ((r == null ? void 0 : r.enabled) ?? !0),
    placeholderData: Pe
  });
}
function Zs() {
  const { numericTenantId: e } = z(), r = W();
  return Z({
    onMutate: () => ({ tenantId: F(e) }),
    mutationFn: (a) => {
      const s = F(e);
      return Ue.create(s, a).then((n) => n.data);
    },
    onSuccess: (a, s, n) => {
      r.invalidateQueries({ queryKey: ye.all(n.tenantId) });
    }
  });
}
function Tt() {
  const { numericTenantId: e } = z(), r = W();
  return Z({
    onMutate: () => ({ tenantId: F(e) }),
    mutationFn: ({
      accessRoleId: a,
      data: s
    }) => {
      const n = F(e);
      return Ue.update(n, a, s).then((d) => d.data);
    },
    onSuccess: (a, { accessRoleId: s }, n) => {
      r.invalidateQueries({ queryKey: ye.all(n.tenantId) }), r.invalidateQueries({
        queryKey: ye.detail(n.tenantId, s)
      });
    }
  });
}
function kt() {
  const { numericTenantId: e } = z(), r = W();
  return Z({
    onMutate: () => ({ tenantId: F(e) }),
    mutationFn: (a) => {
      const s = F(e);
      return Ue.delete(s, a);
    },
    onSuccess: (a, s, n) => {
      r.invalidateQueries({ queryKey: ye.all(n.tenantId) });
    }
  });
}
function en(e) {
  const { numericTenantId: r } = z();
  return te({
    queryKey: ye.permissions(r, e),
    queryFn: () => Ue.listPermissions(F(r), e).then((a) => a.data),
    enabled: r !== null && e > 0
  });
}
function rn(e) {
  const { numericTenantId: r } = z(), a = W();
  return Z({
    onMutate: () => ({ tenantId: F(r) }),
    mutationFn: ({
      resourceServerId: s,
      permissionId: n
    }) => {
      const d = F(r);
      return Ue.addPermission(d, s, n, e);
    },
    onSuccess: (s, n, d) => {
      a.invalidateQueries({
        queryKey: ye.permissions(d.tenantId, e)
      });
    }
  });
}
function tn(e) {
  const { numericTenantId: r } = z(), a = W();
  return Z({
    onMutate: () => ({ tenantId: F(r) }),
    mutationFn: ({
      resourceServerId: s,
      permissionId: n
    }) => {
      const d = F(r);
      return Ue.removePermission(
        d,
        s,
        n,
        e
      );
    },
    onSuccess: (s, n, d) => {
      a.invalidateQueries({
        queryKey: ye.permissions(d.tenantId, e)
      });
    }
  });
}
function an(e) {
  const { numericTenantId: r } = z();
  return te({
    queryKey: ye.forGroup(r, e),
    queryFn: () => Ue.listForGroup(F(r), e).then((a) => a.data),
    enabled: r !== null && e > 0
  });
}
function sn(e) {
  const { numericTenantId: r } = z(), a = W();
  return Z({
    onMutate: () => ({ tenantId: F(r) }),
    mutationFn: (s) => {
      const n = F(r);
      return Ue.addToGroup(n, e, s);
    },
    onSuccess: (s, n, d) => {
      a.invalidateQueries({
        queryKey: ye.forGroup(d.tenantId, e)
      });
    }
  });
}
function nn(e) {
  const { numericTenantId: r } = z(), a = W();
  return Z({
    onMutate: () => ({ tenantId: F(r) }),
    mutationFn: (s) => {
      const n = F(r);
      return Ue.removeFromGroup(n, e, s);
    },
    onSuccess: (s, n, d) => {
      a.invalidateQueries({
        queryKey: ye.forGroup(d.tenantId, e)
      });
    }
  });
}
const sr = {
  all: (e) => ["resourceServerPermissions", e],
  list: (e, r) => [...sr.all(e), "list", r],
  count: (e, r) => [...sr.all(e), "count", r]
}, nr = {
  all: (e) => ["resourceServers", e],
  list: (e, r) => [...nr.all(e), "list", r],
  count: (e, r) => [...nr.all(e), "count", r]
};
function Dt(e, r) {
  const { numericTenantId: a } = z();
  return te({
    queryKey: sr.list(a, e),
    queryFn: () => Er.list(F(a), e).then((s) => s.data),
    enabled: a !== null && ((r == null ? void 0 : r.enabled) ?? !0),
    placeholderData: Pe
  });
}
function ln(e, r) {
  const { numericTenantId: a } = z();
  return te({
    queryKey: sr.count(a, e),
    queryFn: () => Er.count(F(a), e).then((s) => s.data.count),
    enabled: a !== null && ((r == null ? void 0 : r.enabled) ?? !0),
    placeholderData: Pe
  });
}
function on() {
  const { numericTenantId: e } = z(), r = W();
  return Z({
    onMutate: () => ({ tenantId: F(e) }),
    mutationFn: ({
      resourceServerId: a,
      data: s
    }) => {
      const n = F(e);
      return Er.create(n, a, s).then((d) => d.data);
    },
    onSuccess: (a, s, n) => {
      r.invalidateQueries({
        queryKey: sr.all(n.tenantId)
      });
    }
  });
}
function dn() {
  const { numericTenantId: e } = z(), r = W();
  return Z({
    onMutate: () => ({ tenantId: F(e) }),
    mutationFn: ({
      resourceServerId: a,
      permissionId: s,
      data: n
    }) => {
      const d = F(e);
      return Er.update(d, a, s, n).then((l) => l.data);
    },
    onSuccess: (a, s, n) => {
      r.invalidateQueries({
        queryKey: sr.all(n.tenantId)
      });
    }
  });
}
function cn() {
  const { numericTenantId: e } = z(), r = W();
  return Z({
    onMutate: () => ({ tenantId: F(e) }),
    mutationFn: ({
      resourceServerId: a,
      permissionId: s
    }) => {
      const n = F(e);
      return Er.delete(n, a, s);
    },
    onSuccess: (a, s, n) => {
      r.invalidateQueries({
        queryKey: sr.all(n.tenantId)
      });
    }
  });
}
function un(e, r) {
  var n;
  const a = e != null && ((r == null ? void 0 : r.enabled) ?? !0), s = Xr(
    a ? { where: { namespaceId: e }, fields: { id: !0 } } : void 0,
    { enabled: a }
  );
  return {
    ids: (n = s.data) == null ? void 0 : n.map((d) => d.id),
    isLoading: a && s.isLoading,
    isError: a && s.isError,
    error: a ? s.error : null,
    refetch: s.refetch
  };
}
function Jr(e) {
  return e.isPending ? !0 : e.selectorInteractive ? e.isLoadingOptions || e.isOptionsError || e.selectedId == null || !e.options.some((r) => r.value === e.selectedId) : e.isResolving || !!e.resolutionError;
}
function yr(e) {
  const r = Oe(), a = r.scopePermissions, s = (e == null ? void 0 : e.enabled) ?? !0, n = (e == null ? void 0 : e.currentId) ?? null, d = s && r.showSelector && !a, l = Xr(void 0, { enabled: d });
  return {
    options: re(() => {
      if (a) {
        const i = [];
        return r.resourceServerId != null && i.push({
          label: r.resourceServerName ?? r.resourceServerIdentifier,
          value: r.resourceServerId
        }), n != null && n !== r.resourceServerId && i.push({
          label: `Resource server #${n}`,
          value: n
        }), i;
      }
      const v = (l.data ?? []).map((i) => ({
        label: i.name,
        value: i.id
      }));
      if (n != null && !v.some((i) => i.value === n)) {
        const i = n === r.resourceServerId ? r.resourceServerName ?? r.resourceServerIdentifier : `Resource server #${n}`;
        v.push({ label: i, value: n });
      }
      return v;
    }, [
      a,
      r.resourceServerId,
      r.resourceServerName,
      r.resourceServerIdentifier,
      n,
      l.data
    ]),
    isLoading: d && l.isLoading,
    isError: d && l.isError,
    error: d ? l.error ?? null : null,
    locked: a
  };
}
function Xr(e, r) {
  const { numericTenantId: a } = z();
  return te({
    queryKey: nr.list(a, e),
    queryFn: () => Rr.list(F(a), e).then((s) => s.data),
    enabled: a !== null && ((r == null ? void 0 : r.enabled) ?? !0)
  });
}
function mn(e, r) {
  const { numericTenantId: a } = z();
  return te({
    queryKey: nr.count(a, e),
    queryFn: () => Rr.count(F(a), e).then((s) => s.data.count),
    enabled: a !== null && ((r == null ? void 0 : r.enabled) ?? !0),
    placeholderData: Pe
  });
}
function pn() {
  const { numericTenantId: e } = z(), r = W();
  return Z({
    onMutate: () => ({ tenantId: F(e) }),
    mutationFn: (a) => {
      const s = F(e);
      return Rr.create(s, a).then((n) => n.data);
    },
    onSuccess: (a, s, n) => {
      r.invalidateQueries({ queryKey: nr.all(n.tenantId) });
    }
  });
}
function gn() {
  const { numericTenantId: e } = z(), r = W();
  return Z({
    onMutate: () => ({ tenantId: F(e) }),
    mutationFn: ({
      resourceServerId: a,
      data: s
    }) => {
      const n = F(e);
      return Rr.update(n, a, s).then((d) => d.data);
    },
    onSuccess: (a, s, n) => {
      r.invalidateQueries({ queryKey: nr.all(n.tenantId) });
    }
  });
}
function vn() {
  const { numericTenantId: e } = z(), r = W();
  return Z({
    onMutate: () => ({ tenantId: F(e) }),
    mutationFn: (a) => {
      const s = F(e);
      return Rr.delete(s, a);
    },
    onSuccess: (a, s, n) => {
      r.invalidateQueries({ queryKey: nr.all(n.tenantId) });
    }
  });
}
const Ke = {
  all: (e) => ["umrsRoles", e],
  list: (e, r) => [...Ke.all(e), "list", r],
  detail: (e, r) => [...Ke.all(e), "detail", r],
  count: (e, r) => [...Ke.all(e), "count", r]
};
function Gt(e, r) {
  const { numericTenantId: a } = z();
  return te({
    queryKey: Ke.list(a, e),
    queryFn: () => br.list(F(a), e).then((s) => s.data),
    enabled: a !== null && ((r == null ? void 0 : r.enabled) ?? !0),
    placeholderData: Pe
  });
}
function Rl(e) {
  const { numericTenantId: r } = z();
  return te({
    queryKey: Ke.detail(r, e),
    queryFn: () => br.getById(F(r), e).then((a) => a.data),
    enabled: r !== null && e > 0
  });
}
function fn(e, r) {
  const { numericTenantId: a } = z();
  return te({
    queryKey: Ke.count(a, e),
    queryFn: () => br.count(F(a), e).then((s) => s.data.count),
    enabled: a !== null && ((r == null ? void 0 : r.enabled) ?? !0),
    placeholderData: Pe
  });
}
function hn() {
  const { numericTenantId: e } = z(), r = W();
  return Z({
    onMutate: () => ({ tenantId: F(e) }),
    mutationFn: (a) => {
      const s = F(e);
      return br.create(s, a).then((n) => n.data);
    },
    onSuccess: (a, s, n) => {
      r.invalidateQueries({ queryKey: Ke.all(n.tenantId) });
    }
  });
}
function bn() {
  const { numericTenantId: e } = z(), r = W();
  return Z({
    onMutate: () => ({ tenantId: F(e) }),
    mutationFn: ({ umrsRoleId: a, data: s }) => {
      const n = F(e);
      return br.update(n, a, s).then((d) => d.data);
    },
    onSuccess: (a, { umrsRoleId: s }, n) => {
      r.invalidateQueries({ queryKey: Ke.all(n.tenantId) }), r.invalidateQueries({
        queryKey: Ke.detail(n.tenantId, s)
      });
    }
  });
}
function yn() {
  const { numericTenantId: e } = z(), r = W();
  return Z({
    onMutate: () => ({ tenantId: F(e) }),
    mutationFn: (a) => {
      const s = F(e);
      return br.delete(s, a);
    },
    onSuccess: (a, s, n) => {
      r.invalidateQueries({ queryKey: Ke.all(n.tenantId) });
    }
  });
}
const qe = {
  all: (e) => ["umrsGrants", e],
  forUser: (e, r) => [...qe.all(e), "user", r],
  forGroup: (e, r) => [...qe.all(e), "group", r],
  allUserGrants: (e) => [...qe.all(e), "allUserGrants"],
  allGroupGrants: (e) => [...qe.all(e), "allGroupGrants"]
};
function xn(e) {
  const { numericTenantId: r } = z();
  return te({
    queryKey: qe.forUser(r, e),
    queryFn: () => Be.listForUser(F(r), e).then((a) => a.data),
    enabled: r !== null && e > 0
  });
}
function Nn(e) {
  const { numericTenantId: r } = z();
  return te({
    queryKey: qe.forGroup(r, e),
    queryFn: () => Be.listForGroup(F(r), e).then((a) => a.data),
    enabled: r !== null && e > 0
  });
}
function In() {
  const { numericTenantId: e } = z();
  return te({
    queryKey: qe.allUserGrants(e),
    queryFn: () => Be.listAllUserGrants(F(e)),
    enabled: e !== null
  });
}
function Sn() {
  const { numericTenantId: e } = z();
  return te({
    queryKey: qe.allGroupGrants(e),
    queryFn: () => Be.listAllGroupGrants(F(e)),
    enabled: e !== null
  });
}
function qn() {
  const { numericTenantId: e } = z(), r = W();
  return Z({
    onMutate: () => ({ tenantId: F(e) }),
    mutationFn: (a) => {
      const s = F(e);
      return Be.assignToUser(s, a).then((n) => n.data);
    },
    onSuccess: (a, s, n) => {
      r.invalidateQueries({ queryKey: qe.all(n.tenantId) }), r.invalidateQueries({
        queryKey: qe.forUser(n.tenantId, s.userId)
      });
    }
  });
}
function Cn() {
  const { numericTenantId: e } = z(), r = W();
  return Z({
    onMutate: () => ({ tenantId: F(e) }),
    mutationFn: (a) => {
      const s = F(e);
      return Be.assignToGroup(s, a).then((n) => n.data);
    },
    onSuccess: (a, s, n) => {
      r.invalidateQueries({ queryKey: qe.all(n.tenantId) }), r.invalidateQueries({
        queryKey: qe.forGroup(n.tenantId, s.groupId)
      });
    }
  });
}
function Ut() {
  const { numericTenantId: e } = z(), r = W();
  return Z({
    onMutate: () => ({ tenantId: F(e) }),
    mutationFn: (a) => {
      const s = F(e);
      return Be.revokeUserGrant(s, a);
    },
    onSuccess: (a, s, n) => {
      r.invalidateQueries({ queryKey: qe.all(n.tenantId) });
    }
  });
}
function Mt() {
  const { numericTenantId: e } = z(), r = W();
  return Z({
    onMutate: () => ({ tenantId: F(e) }),
    mutationFn: (a) => {
      const s = F(e);
      return Be.revokeGroupGrant(s, a);
    },
    onSuccess: (a, s, n) => {
      r.invalidateQueries({ queryKey: qe.all(n.tenantId) });
    }
  });
}
function El() {
  const { numericTenantId: e } = z(), r = W();
  return Z({
    onMutate: () => ({ tenantId: F(e) }),
    mutationFn: ({ grantId: a, data: s }) => {
      const n = F(e);
      return Be.updateUserGrant(n, a, s);
    },
    onSuccess: (a, s, n) => {
      r.invalidateQueries({ queryKey: qe.all(n.tenantId) });
    }
  });
}
function Fl() {
  const { numericTenantId: e } = z(), r = W();
  return Z({
    onMutate: () => ({ tenantId: F(e) }),
    mutationFn: ({ grantId: a, data: s }) => {
      const n = F(e);
      return Be.updateGroupGrant(n, a, s);
    },
    onSuccess: (a, s, n) => {
      r.invalidateQueries({ queryKey: qe.all(n.tenantId) });
    }
  });
}
const $r = {
  all: () => ["issuers"],
  list: (e) => [...$r.all(), "list", e],
  tenantProviders: (e) => [...$r.all(), "tenantProviders", e]
};
function wn(e, r) {
  return te({
    queryKey: $r.list(e),
    queryFn: () => qt.list(e).then((a) => a.data),
    enabled: (r == null ? void 0 : r.enabled) ?? !0,
    placeholderData: Pe
  });
}
function Rn(e) {
  const { numericTenantId: r } = z();
  return te({
    queryKey: $r.tenantProviders(r),
    queryFn: () => qt.listTenantProviders(F(r)).then((a) => a.data),
    enabled: r !== null && ((e == null ? void 0 : e.enabled) ?? !0),
    placeholderData: Pe
  });
}
function ct() {
  return typeof document > "u" ? "light" : document.documentElement.getAttribute("data-clique-mode") === "dark" ? "dark" : "light";
}
function Al() {
  const [e, r] = U(ct);
  return ne(() => {
    const a = document.documentElement, s = () => r(ct()), n = new MutationObserver(s);
    return n.observe(a, { attributes: !0, attributeFilter: ["data-clique-mode"] }), s(), () => n.disconnect();
  }, []), e;
}
const Zr = {
  all: (e) => ["namespaces", e],
  list: (e, r) => [...Zr.all(e), "list", r]
};
function ut(e) {
  if (e === null)
    throw new Error(
      "Tenant ID is not resolved yet. Ensure tenant lookup has completed before mutating."
    );
  return e;
}
function et(e, r) {
  const { numericTenantId: a } = z(), s = vr(), n = as(s == null ? void 0 : s.hasScope);
  return te({
    queryKey: Zr.list(a, e),
    queryFn: () => Ct.list(a, e).then((d) => d.data),
    enabled: a !== null && ((r == null ? void 0 : r.enabled) ?? !0) && n
  });
}
function En() {
  const { numericTenantId: e } = z(), r = W();
  return Z({
    onMutate: () => ({ tenantId: ut(e) }),
    mutationFn: (a) => {
      const s = ut(e);
      return Ct.create(s, a).then((n) => n.data);
    },
    onSuccess: (a, s, n) => {
      r.invalidateQueries({ queryKey: Zr.all(n.tenantId) });
    }
  });
}
function qr(e, r) {
  const [a, s] = U(e);
  return ne(() => {
    r || s(e);
  }, [r, e]), !!(r && a !== e);
}
function xr({
  searchFields: e,
  useList: r,
  useCount: a,
  pageSize: s = 20,
  defaultSortField: n = "name",
  defaultSortOrder: d = "ASC",
  namespaceId: l,
  resetKey: m
}) {
  const [v, i] = U(""), [u, h] = U(0), [g, p] = U(n), [f, c] = U(d === "ASC" ? 1 : -1), y = re(() => Vr(e, v), [e, v]), b = re(
    () => Nt(y, l),
    [y, l]
  );
  ne(() => {
    h(0);
  }, [l, m]);
  const q = re(
    () => ({
      where: b,
      limit: s,
      offset: u * s,
      order: `${g} ${f === 1 ? "ASC" : "DESC"}`
    }),
    [b, s, u, g, f]
  ), {
    data: C,
    isLoading: N,
    isPlaceholderData: x,
    isError: w,
    error: I,
    refetch: S
  } = r(q), {
    data: E,
    isLoading: R,
    isPlaceholderData: P,
    isError: _,
    error: A,
    refetch: k
  } = a(b), T = l ?? m, D = qr(T, x), K = qr(T, P), M = D ? void 0 : C, ee = K ? void 0 : E, Q = N || D, j = L((Y) => {
    i(Y), h(0);
  }, []), $ = L(() => {
    Promise.all([S(), k()]);
  }, [S, k]), ie = (Q || R || K) && !M, O = (M == null ? void 0 : M.length) === 0 && !v, ae = (M == null ? void 0 : M.length) === 0 && !!v;
  return {
    items: M,
    totalCount: ee,
    search: v,
    setSearch: j,
    page: u,
    setPage: h,
    pageSize: s,
    sortField: g,
    sortOrder: f,
    setSortField: p,
    setSortOrder: c,
    isInitialLoad: ie,
    isLoading: Q,
    isError: w || _,
    error: I ?? A,
    isEmpty: O,
    isEmptySearch: ae,
    refetch: $,
    filter: q
  };
}
const Fn = ["name", "description"];
function An(e) {
  const { canList: r, canCreate: a } = Ze("groups"), s = je(e == null ? void 0 : e.namespaceId), { items: n, ...d } = xr({
    searchFields: Fn,
    useList: (m) => dr(m, { enabled: r }),
    useCount: (m) => Et(m, { enabled: r }),
    pageSize: e == null ? void 0 : e.pageSize,
    defaultSortField: e == null ? void 0 : e.defaultSortField,
    defaultSortOrder: e == null ? void 0 : e.defaultSortOrder,
    namespaceId: s
  }), { group: l } = Re();
  return { ...d, groups: n, labels: l, canList: r, canCreate: a };
}
function cr({
  value: e,
  onChange: r,
  placeholder: a = "Search...",
  debounceMs: s = 300,
  className: n,
  style: d,
  pt: l
}) {
  const [m, v] = U(e), i = Ie(void 0);
  ne(() => {
    v(e);
  }, [e]);
  const u = L(
    (g) => {
      const p = g.target.value;
      v(p), i.current !== void 0 && clearTimeout(i.current), i.current = setTimeout(() => r(p), s);
    },
    [r, s]
  );
  ne(() => () => {
    i.current !== void 0 && clearTimeout(i.current);
  }, []);
  const h = L(() => {
    v(""), clearTimeout(i.current), r("");
  }, [r]);
  return /* @__PURE__ */ o("div", { className: n, style: { position: "relative", ...d }, children: [
    /* @__PURE__ */ t(
      "i",
      {
        className: "pi pi-search",
        "aria-hidden": "true",
        style: {
          position: "absolute",
          left: "0.75rem",
          top: "50%",
          transform: "translateY(-50%)",
          color: "var(--clique-fg-tertiary)",
          fontSize: "0.875rem",
          pointerEvents: "none",
          zIndex: 1
        }
      }
    ),
    /* @__PURE__ */ t(
      me,
      {
        value: m,
        onChange: u,
        placeholder: a,
        style: {
          width: "100%",
          paddingLeft: "2.5rem",
          paddingRight: m ? "2.5rem" : void 0
        },
        "aria-label": a,
        pt: l
      }
    ),
    m && /* @__PURE__ */ t(
      "button",
      {
        type: "button",
        onClick: h,
        "aria-label": "Clear search",
        style: {
          position: "absolute",
          right: "0.75rem",
          top: "50%",
          transform: "translateY(-50%)",
          background: "none",
          border: "none",
          padding: 0,
          cursor: "pointer",
          color: "var(--clique-fg-tertiary)",
          zIndex: 1
        },
        children: /* @__PURE__ */ t("i", { className: "pi pi-times", style: { fontSize: "0.875rem" } })
      }
    )
  ] });
}
function xe({
  message: e = "Loading...",
  className: r,
  style: a,
  pt: s
}) {
  return /* @__PURE__ */ o(
    "div",
    {
      className: be("flex flex-col items-center justify-center py-12", r),
      style: a,
      role: "status",
      "aria-label": e,
      children: [
        /* @__PURE__ */ t(
          It,
          {
            "aria-hidden": "true",
            style: { width: "48px", height: "48px" },
            strokeWidth: "4",
            pt: s
          }
        ),
        /* @__PURE__ */ t("p", { className: "text-[var(--clique-fg-secondary)] mt-4 text-sm", children: e })
      ]
    }
  );
}
function Je({
  icon: e = "pi pi-inbox",
  title: r,
  message: a,
  actionLabel: s,
  onAction: n,
  children: d,
  className: l,
  style: m,
  pt: v
}) {
  return /* @__PURE__ */ o(
    "div",
    {
      className: be("flex flex-col items-center justify-center py-16 text-center", l),
      style: m,
      children: [
        /* @__PURE__ */ t("i", { "aria-hidden": "true", className: `${e} text-5xl text-[var(--clique-fg-tertiary)] mb-4` }),
        /* @__PURE__ */ t("h3", { className: "text-lg font-medium text-[var(--clique-fg)] mb-1", children: r }),
        a && /* @__PURE__ */ t("p", { className: "text-sm text-[var(--clique-fg-secondary)] mb-4 max-w-md", children: a }),
        s && n && /* @__PURE__ */ t(
          G,
          {
            type: "button",
            label: s,
            icon: "pi pi-plus",
            onClick: n,
            size: "small",
            outlined: !0,
            pt: v
          }
        ),
        d
      ]
    }
  );
}
function ur({ resourceLabel: e, className: r, style: a }) {
  return /* @__PURE__ */ o("div", { className: be("flex flex-col items-center justify-center py-12", r), style: a, children: [
    /* @__PURE__ */ t("i", { "aria-hidden": "true", className: "pi pi-lock text-4xl text-[var(--clique-warning)] mb-4" }),
    /* @__PURE__ */ t("h3", { className: "text-lg font-medium text-[var(--clique-fg)] mb-1 text-center", children: "Access Denied" }),
    /* @__PURE__ */ o("p", { className: "text-sm text-[var(--clique-fg-secondary)] mb-4 max-w-md text-center", children: [
      "You don’t have permission to access ",
      e ?? "this resource",
      ". Contact your administrator if you believe this is an error."
    ] })
  ] });
}
function mr(e, r, a) {
  return e ? {} : {
    disabled: !0,
    tooltip: a ?? `You don't have permission to create ${r}.`,
    tooltipOptions: { showOnDisabled: !0 }
  };
}
function Pn(e) {
  var r, a, s, n, d, l;
  return ss.isAxiosError(e) ? {
    status: (r = e.response) == null ? void 0 : r.status,
    statusText: (a = e.response) == null ? void 0 : a.statusText,
    url: (s = e.config) == null ? void 0 : s.url,
    method: (d = (n = e.config) == null ? void 0 : n.method) == null ? void 0 : d.toUpperCase(),
    responseBody: (l = e.response) == null ? void 0 : l.data,
    message: e.message
  } : e instanceof Error ? { message: e.message } : { message: String(e) };
}
function he({
  error: e,
  onRetry: r,
  retryLabel: a = "Retry",
  resourceLabel: s,
  className: n,
  style: d,
  pt: l
}) {
  const m = Pn(e), v = m.status === 403, i = m.status !== void 0 && m.status >= 500, u = typeof import.meta < "u" && !0;
  let h, g, p, f;
  return i ? (h = "pi pi-server", g = "text-[var(--clique-accent)]", p = "Server Not Available", f = "The server is temporarily unavailable. Please try again in a few moments.") : v ? (h = "pi pi-lock", g = "text-[var(--clique-warning)]", p = "Access Denied", f = "You don’t have permission to access this resource. Contact your administrator if you believe this is an error.") : (h = "pi pi-exclamation-triangle", g = "text-[var(--clique-destructive)]", p = s ? `Failed to load ${s}` : "Something went wrong", f = m.message), /* @__PURE__ */ o("div", { className: be("flex flex-col items-center justify-center py-12", n), style: d, children: [
    /* @__PURE__ */ t("i", { "aria-hidden": "true", className: `${h} text-4xl ${g} mb-4` }),
    /* @__PURE__ */ t("h3", { className: "text-lg font-medium text-[var(--clique-fg)] mb-1 text-center", children: p }),
    /* @__PURE__ */ t("p", { className: "text-sm text-[var(--clique-fg-secondary)] mb-4 max-w-md text-center", children: f }),
    r && /* @__PURE__ */ t(
      G,
      {
        label: a,
        icon: "pi pi-refresh",
        onClick: r,
        size: "small",
        severity: "secondary",
        pt: l
      }
    ),
    !u && /* @__PURE__ */ t(Ln, { details: m })
  ] });
}
function Ln({ details: e }) {
  const [r, a] = U(!1);
  return e.status != null || e.url != null || e.responseBody != null ? /* @__PURE__ */ o("div", { className: "mt-6 w-full max-w-lg text-left", children: [
    /* @__PURE__ */ o(
      "button",
      {
        type: "button",
        onClick: () => a(!r),
        className: "flex items-center gap-2 text-xs text-[var(--clique-fg-tertiary)] hover:text-[var(--clique-fg-muted)] transition-colors cursor-pointer mx-auto",
        children: [
          /* @__PURE__ */ t(
            "i",
            {
              "aria-hidden": "true",
              className: `pi ${r ? "pi-chevron-down" : "pi-chevron-right"} text-xs`
            }
          ),
          r ? "Hide" : "Show",
          " error details"
        ]
      }
    ),
    r && /* @__PURE__ */ o("div", { className: "mt-3 bg-[var(--clique-bg-subtle)] border border-[var(--clique-border)] rounded-lg p-4 text-xs font-mono overflow-y-auto overflow-x-hidden max-h-64", children: [
      /* @__PURE__ */ t("table", { className: "w-full text-left", children: /* @__PURE__ */ o("tbody", { children: [
        e.status && /* @__PURE__ */ t(Kr, { label: "Status", value: `${e.status} ${e.statusText ?? ""}` }),
        e.method && e.url && /* @__PURE__ */ t(Kr, { label: "Request", value: `${e.method} ${e.url}` }),
        /* @__PURE__ */ t(Kr, { label: "Message", value: e.message })
      ] }) }),
      e.responseBody != null && /* @__PURE__ */ o("div", { className: "mt-3 overflow-hidden", children: [
        /* @__PURE__ */ t("div", { className: "text-[var(--clique-fg-secondary)] font-sans font-medium text-xs mb-1", children: "Response" }),
        /* @__PURE__ */ t("pre", { className: "whitespace-pre m-0 bg-[var(--clique-bg-muted)] border border-[var(--clique-border)] rounded p-2 text-[var(--clique-fg)] text-left overflow-x-auto", children: Tn(e.responseBody) })
      ] })
    ] })
  ] }) : null;
}
function Tn(e) {
  if (typeof e == "string")
    try {
      return JSON.stringify(JSON.parse(e), null, 2);
    } catch {
      return e;
    }
  return JSON.stringify(e, null, 2);
}
function Kr({
  label: e,
  value: r,
  preformatted: a
}) {
  return /* @__PURE__ */ o("tr", { className: "align-top", children: [
    /* @__PURE__ */ t("td", { className: "text-[var(--clique-fg-secondary)] pr-3 py-1 whitespace-nowrap font-sans font-medium", children: e }),
    /* @__PURE__ */ t("td", { className: `text-[var(--clique-fg)] py-1 ${a ? "" : "break-all"}`, children: a ? /* @__PURE__ */ t("pre", { className: "whitespace-pre-wrap m-0 bg-[var(--clique-bg-muted)] border border-[var(--clique-border)] rounded p-2 mt-1 text-left", children: r }) : r })
  ] });
}
const kn = [
  { field: "name", header: "Name", sortable: !0, className: "font-medium" },
  {
    field: "description",
    header: "Description",
    sortable: !0,
    body: (e) => /* @__PURE__ */ t("span", { className: "text-[var(--clique-fg-secondary)]", children: e.description || "—" })
  },
  {
    field: "isPrivileged",
    header: "Privileged",
    sortable: !0,
    style: { width: "120px" },
    body: (e) => e.isPrivileged ? /* @__PURE__ */ t(ce, { value: "Privileged", severity: "warning", icon: "pi pi-star" }) : null
  },
  {
    field: "id",
    header: "ID",
    sortable: !0,
    style: { width: "80px" },
    body: (e) => /* @__PURE__ */ t("span", { className: "text-[var(--clique-fg-tertiary)] text-xs", children: e.id })
  }
];
function Pl({
  onGroupSelect: e,
  onCreateGroup: r,
  pageSize: a = 20,
  namespaceId: s,
  columns: n = kn,
  toolbarActions: d,
  renderLoading: l,
  renderEmpty: m,
  renderError: v,
  renderAccessDenied: i,
  className: u,
  style: h,
  pt: g
}) {
  const p = fr(), {
    groups: f,
    totalCount: c,
    search: y,
    setSearch: b,
    page: q,
    setPage: C,
    pageSize: N,
    sortField: x,
    sortOrder: w,
    setSortField: I,
    setSortOrder: S,
    isInitialLoad: E,
    isLoading: R,
    isError: P,
    error: _,
    refetch: A,
    labels: k,
    canList: T,
    canCreate: D
  } = An({ pageSize: a, namespaceId: s }), K = L(
    (Q) => {
      C(Q.page ?? 0);
    },
    [C]
  ), M = L(
    (Q) => {
      I(Q.sortField), S(Q.sortOrder === 1 ? 1 : -1), C(0);
    },
    [I, S, C]
  ), ee = () => T ? E ? l ? l() : /* @__PURE__ */ t(xe, { message: `Loading ${k.plural}...` }) : P ? v ? v(_, A) : /* @__PURE__ */ t(he, { error: _, resourceLabel: k.plural, onRetry: A }) : (f == null ? void 0 : f.length) === 0 && !y ? m ? m() : /* @__PURE__ */ t(
    Je,
    {
      icon: p.group,
      title: `No ${k.plural} yet`,
      message: `Create ${k.withArticle} to start organizing users.`,
      actionLabel: r && D ? `Create ${k.singularTitle}` : void 0,
      onAction: D ? r : void 0
    }
  ) : /* @__PURE__ */ t(
    Ae,
    {
      value: f ?? [],
      lazy: !0,
      paginator: !0,
      rows: N,
      totalRecords: c ?? 0,
      first: q * N,
      onPage: K,
      sortField: x,
      sortOrder: w,
      onSort: M,
      loading: R,
      dataKey: "id",
      emptyMessage: `No ${k.plural} match your search.`,
      selectionMode: "single",
      onSelectionChange: (Q) => {
        Q.value && (e == null || e(Q.value));
      },
      rowHover: !0,
      stripedRows: !0,
      className: "rounded-lg border border-[var(--clique-border)] overflow-hidden",
      pt: g,
      rowClassName: () => e ? "cursor-pointer" : "",
      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport",
      currentPageReportTemplate: `Showing {first} to {last} of {totalRecords} ${k.plural}`,
      children: n.map((Q) => /* @__PURE__ */ t(
        X,
        {
          field: Q.field,
          header: Q.header,
          sortable: Q.sortable,
          className: Q.className,
          style: Q.style,
          body: Q.body
        },
        Q.field
      ))
    }
  ) : i ? i() : /* @__PURE__ */ t(ur, { resourceLabel: k.plural });
  return /* @__PURE__ */ o("div", { className: be(u), style: h, children: [
    /* @__PURE__ */ o("div", { className: "flex items-center justify-between mb-4 gap-4", children: [
      /* @__PURE__ */ t(
        cr,
        {
          value: y,
          onChange: b,
          placeholder: `Search ${k.plural} by name or description...`,
          className: "flex-1 max-w-md"
        }
      ),
      /* @__PURE__ */ o("div", { className: "flex items-center gap-2", children: [
        d,
        r && /* @__PURE__ */ t(
          G,
          {
            type: "button",
            label: `New ${k.singularTitle}`,
            icon: p.create,
            onClick: D ? r : void 0,
            size: "small",
            ...mr(D, k.plural)
          }
        )
      ] })
    ] }),
    ee()
  ] });
}
function Ge({
  visible: e,
  onHide: r,
  onConfirm: a,
  header: s = "Confirm",
  message: n,
  confirmLabel: d = "Confirm",
  rejectLabel: l = "Cancel",
  confirmSeverity: m = "danger",
  confirmIcon: v,
  loading: i = !1,
  className: u,
  style: h,
  pt: g
}) {
  return /* @__PURE__ */ t(
    fe,
    {
      visible: e,
      onHide: () => {
        i || r();
      },
      header: s,
      modal: !0,
      draggable: !1,
      resizable: !1,
      closable: !i,
      closeOnEscape: !i,
      className: u,
      style: { width: "28rem", ...h },
      pt: g,
      footer: /* @__PURE__ */ o("div", { className: "flex justify-end gap-3", children: [
        /* @__PURE__ */ t(
          G,
          {
            type: "button",
            label: l,
            onClick: r,
            severity: "secondary",
            outlined: !0,
            disabled: i
          }
        ),
        /* @__PURE__ */ t(
          G,
          {
            type: "button",
            label: d,
            icon: v,
            onClick: a,
            severity: m,
            raised: !0,
            loading: i
          }
        )
      ] }),
      children: /* @__PURE__ */ t("p", { className: "text-[var(--clique-fg)]", children: n })
    }
  );
}
function Ur(e, r) {
  return {
    name: e.name,
    description: e.description ?? "",
    allowExtensionRequest: e.allowExtensionRequest,
    allowInvites: r != null,
    invitationEmailTemplateId: (r == null ? void 0 : r.invitationEmailTemplateId) ?? null,
    namespaceId: e.namespaceId
  };
}
function $t(e) {
  const { onUpdated: r, onDeleted: a, onSuccess: s, onError: n } = e, d = "group" in e ? e.group : void 0, l = "groupId" in e ? e.groupId : void 0, {
    data: m,
    isLoading: v,
    isError: i,
    error: u,
    refetch: h
  } = At(l ?? 0, void 0), g = d ?? m, p = (g == null ? void 0 : g.id) ?? l ?? 0, f = d ? !1 : v, c = d ? !1 : i, y = d ? null : u, { group: b } = Re(), q = je(), [C, N] = U(!1), [x, w] = U({
    name: "",
    description: "",
    allowExtensionRequest: !1,
    allowInvites: !1,
    invitationEmailTemplateId: null,
    namespaceId: null
  }), [I, S] = U(""), [E, R] = U(!1), P = Os(), _ = _s(), { data: A } = Rt(p), k = ks(), T = Ds(), D = Gs(), { invitationApproveIn: K, invitationApproveInUnit: M } = Hr(), ee = Ie(p), Q = A != null;
  ne(() => {
    g && (g.id !== ee.current ? (ee.current = g.id, w(Ur(g, A)), S(""), R(!1), N(!1)) : C || w(Ur(g, A)));
  }, [g, C, A]);
  const j = L(() => {
    g && (w(Ur(g, A)), S(""), N(!0));
  }, [g, A]), $ = L(() => {
    g && (w(Ur(g, A)), S(""), N(!1));
  }, [g, A]), ie = L(
    async (se) => {
      const de = x.allowInvites !== Q, oe = x.allowInvites && A != null && (x.invitationEmailTemplateId ?? null) !== (A.invitationEmailTemplateId ?? null);
      !de && !oe || (x.allowInvites && !Q ? await k.mutateAsync({
        accessType: "RBAC",
        accessSubType: "GENERATED_CLIENT_ACCESS",
        name: se.name,
        groupId: se.id,
        enableSelfRequests: !0,
        approveIn: K ?? xt,
        approveInUnit: M ?? yt,
        invitationEmailTemplateId: x.invitationEmailTemplateId
      }) : x.allowInvites && A && oe ? await T.mutateAsync({
        id: A.id,
        data: { ...A, invitationEmailTemplateId: x.invitationEmailTemplateId }
      }) : !x.allowInvites && A && await D.mutateAsync(A.id));
    },
    [
      x.allowInvites,
      x.invitationEmailTemplateId,
      Q,
      A,
      k,
      T,
      D,
      K,
      M
    ]
  ), O = L(() => {
    if (!g) return;
    const se = x.name.trim();
    if (!se) {
      S("Name is required.");
      return;
    }
    if (se.length < 2) {
      S("Name must be at least 2 characters.");
      return;
    }
    S("");
    const de = {};
    se !== g.name && (de.name = se);
    const oe = x.description.trim();
    oe !== (g.description ?? "") && (de.description = oe), x.allowExtensionRequest !== g.allowExtensionRequest && (de.allowExtensionRequest = x.allowExtensionRequest), x.namespaceId !== g.namespaceId && (de.namespaceId = x.namespaceId);
    const le = x.allowInvites !== Q, H = x.allowInvites && A != null && (x.invitationEmailTemplateId ?? null) !== (A.invitationEmailTemplateId ?? null);
    if (Object.keys(de).length === 0 && !le && !H) {
      N(!1);
      return;
    }
    const ze = (V) => {
      ie(V).then(() => {
        N(!1), r == null || r(V), s == null || s(`${b.singularTitle} updated successfully.`);
      }).catch((Se) => {
        console.error("Group saved but invite settings update failed", Se), N(!1), r == null || r(V), n == null || n(`${b.singularTitle} saved, but updating invite settings failed.`);
      });
    };
    Object.keys(de).length > 0 ? P.mutate(
      { groupId: g.id, data: de },
      {
        onSuccess: () => ze({ ...g, ...de }),
        onError: (V) => {
          console.error("Failed to update group", V);
          let Se;
          Se = Xe(V) !== 403 ? `Failed to update ${b.singular}.` : ir({ message: lr(V) }), n == null || n(Se);
        }
      }
    ) : ze(g);
  }, [
    x,
    g,
    Q,
    A,
    P,
    ie,
    r,
    s,
    n,
    b
  ]), ae = L(() => {
    g && _.mutate(g.id, {
      onSuccess: () => {
        R(!1), s == null || s(`${b.singularTitle} deleted successfully.`), a == null || a();
      },
      onError: (se) => {
        R(!1), console.error("Failed to delete group", se), n == null || n(`Failed to delete ${b.singular}.`);
      }
    });
  }, [g, _, a, s, n, b]), Y = L(
    (se, de) => {
      w((oe) => ({ ...oe, [se]: de })), se === "name" && S("");
    },
    []
  ), ue = L(() => {
    h();
  }, [h]);
  return {
    group: g,
    isLoading: f,
    isError: c,
    error: y,
    refetch: ue,
    editing: C,
    startEditing: j,
    cancelEditing: $,
    form: x,
    updateField: Y,
    nameError: I,
    handleSave: O,
    isSaving: P.isPending,
    showDeleteConfirm: E,
    setShowDeleteConfirm: R,
    handleDelete: ae,
    isDeleting: _.isPending,
    hasRequestableAccess: Q,
    labels: b,
    namespaceLocked: q != null
  };
}
function Dn(e) {
  const { groupId: r, namespaceId: a, onSuccess: s, onError: n } = e, {
    data: d,
    isLoading: l,
    isError: m,
    error: v,
    refetch: i
  } = At(r), { data: u, isLoading: h, isError: g, error: p, refetch: f } = an(r), { resourceServerId: c, scopePermissions: y } = Oe(), b = a !== void 0 ? a : d == null ? void 0 : d.namespaceId, q = a !== void 0 || d != null, C = a === void 0 && m && !l, N = y ? c != null : q, x = re(() => y ? c != null ? { where: { resourceServerId: c } } : void 0 : b != null ? { where: { namespaceId: b } } : void 0, [y, c, b]), [w, I] = U(!1), [S, E] = U(null), [R, P] = U(null), _ = L((le) => {
    I(le), le || E(null);
  }, []);
  ne(() => {
    E(null);
  }, [r, b, c, y]);
  const {
    data: A,
    isLoading: k,
    isError: T,
    error: D,
    isPlaceholderData: K,
    refetch: M
  } = Lt(x, { enabled: w && N }), ee = w && (y ? c == null || k || K : a === void 0 && l || k || K || !q && !C), Q = w && (y ? c != null && !K && T : C || q && !K && T), j = C ? v : Q ? D : null, $ = sn(r), ie = nn(r), O = re(() => new Set((u ?? []).map((le) => le.id)), [u]), ae = re(() => !N || K ? [] : (A ?? []).filter((le) => O.has(le.id) ? !1 : y ? le.resourceServerId === c : !(b != null && le.namespaceId !== void 0 && Number(le.namespaceId) !== b)), [
    A,
    O,
    N,
    K,
    b,
    c,
    y
  ]), Y = re(() => {
    const le = [], H = /* @__PURE__ */ new Set();
    for (const ze of u ?? [])
      for (const V of ze.resourceServerPermissions ?? [])
        H.has(V.id) || (H.add(V.id), le.push(V));
    return le;
  }, [u]), ue = L(() => {
    if (S !== null) {
      if (!ae.some((le) => le.id === S)) {
        E(null);
        return;
      }
      $.mutate(S, {
        onSuccess: () => {
          _(!1), s == null || s("Access role added to group.");
        },
        onError: (le) => {
          console.error("Failed to add access role to group", le), n == null || n("Failed to add access role to group.");
        }
      });
    }
  }, [S, ae, $, s, n]), se = L(() => {
    R && ie.mutate(R.id, {
      onSuccess: () => {
        P(null), s == null || s("Access role removed from group.");
      },
      onError: (le) => {
        console.error("Failed to remove access role from group", le), P(null), n == null || n("Failed to remove access role from group.");
      }
    });
  }, [R, ie, s, n]), de = L(() => {
    f();
  }, [f]), oe = L(() => {
    i(), M();
  }, [i, M]);
  return {
    roles: u ?? [],
    isLoading: h,
    isError: g,
    error: p,
    refetch: de,
    allPermissions: Y,
    availableRoles: ae,
    isLoadingAvailable: ee,
    isAvailableError: Q,
    availableError: j,
    refetchAvailable: oe,
    showAddDialog: w,
    setShowAddDialog: _,
    selectedRoleId: S,
    setSelectedRoleId: E,
    handleAddRole: ue,
    isAdding: $.isPending,
    roleToRemove: R,
    setRoleToRemove: P,
    handleRemoveConfirm: se,
    isRemoving: ie.isPending
  };
}
function Ot({
  groupId: e,
  namespaceId: r,
  onSuccess: a,
  onError: s,
  className: n,
  style: d,
  pt: l
}) {
  var g;
  const m = Dn({ groupId: e, namespaceId: r, onSuccess: a, onError: s }), v = (p) => {
    var c;
    const f = ((c = p.resourceServerPermissions) == null ? void 0 : c.length) ?? 0;
    return /* @__PURE__ */ t(
      ce,
      {
        value: `${f} permission${f !== 1 ? "s" : ""}`,
        severity: "info",
        icon: "pi pi-lock"
      }
    );
  }, i = (p) => p.isPrivileged ? /* @__PURE__ */ t(ce, { value: "Privileged", severity: "warning", icon: "pi pi-star" }) : null, u = (p) => /* @__PURE__ */ t("div", { className: "flex items-center gap-1 justify-center", children: /* @__PURE__ */ t(
    G,
    {
      type: "button",
      icon: "pi pi-trash",
      className: "p-button-text p-button-danger p-button-sm",
      onClick: () => m.setRoleToRemove(p),
      disabled: m.isRemoving
    }
  ) }), h = m.availableRoles.map((p) => ({
    label: p.name,
    value: p.id
  }));
  return m.isLoading ? /* @__PURE__ */ t(xe, { message: "Loading access roles..." }) : m.isError ? /* @__PURE__ */ t(
    he,
    {
      error: m.error,
      resourceLabel: "access roles",
      onRetry: m.refetch
    }
  ) : /* @__PURE__ */ o(
    "div",
    {
      className: be("mt-8 border-t border-[var(--clique-border)] pt-6", n),
      style: d,
      children: [
        /* @__PURE__ */ o("div", { className: "flex items-center justify-between mb-4", children: [
          /* @__PURE__ */ o("span", { className: "text-lg font-semibold text-[var(--clique-fg)]", children: [
            "Access Roles (",
            m.roles.length,
            ")"
          ] }),
          /* @__PURE__ */ t(
            G,
            {
              type: "button",
              label: "Add Access Role",
              icon: "pi pi-plus",
              size: "small",
              onClick: () => m.setShowAddDialog(!0)
            }
          )
        ] }),
        /* @__PURE__ */ o(
          Ae,
          {
            value: m.roles,
            dataKey: "id",
            stripedRows: !0,
            pt: l,
            emptyMessage: /* @__PURE__ */ o("div", { className: "text-center py-8", children: [
              /* @__PURE__ */ t(
                "i",
                {
                  "aria-hidden": "true",
                  className: "pi pi-shield text-4xl text-[var(--clique-fg-tertiary)] mb-3"
                }
              ),
              /* @__PURE__ */ t("p", { className: "text-[var(--clique-fg-secondary)]", children: 'No access roles assigned. Click "Add Access Role" to assign one.' })
            ] }),
            children: [
              /* @__PURE__ */ t(X, { field: "name", header: "Name", className: "font-medium" }),
              /* @__PURE__ */ t(
                X,
                {
                  field: "description",
                  header: "Description",
                  body: (p) => /* @__PURE__ */ t("span", { className: "text-[var(--clique-fg-secondary)]", children: p.description || "—" })
                }
              ),
              /* @__PURE__ */ t(X, { header: "Permissions", body: v, style: { width: "150px" } }),
              /* @__PURE__ */ t(X, { header: "Privileged", body: i, style: { width: "120px" } }),
              /* @__PURE__ */ t(
                X,
                {
                  header: "Actions",
                  body: u,
                  style: { width: "100px" },
                  bodyStyle: { textAlign: "center" },
                  headerStyle: { textAlign: "center" }
                }
              )
            ]
          }
        ),
        m.roles.length > 0 && /* @__PURE__ */ t(Is, { multiple: !0, className: "mt-4", children: m.roles.map((p) => {
          const f = p.resourceServerPermissions ?? [], c = /* @__PURE__ */ o("span", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ t("span", { className: "font-medium", children: p.name }),
            /* @__PURE__ */ t(
              ce,
              {
                value: `${f.length} permission${f.length !== 1 ? "s" : ""}`,
                severity: "info",
                icon: "pi pi-lock"
              }
            )
          ] });
          return /* @__PURE__ */ t(Ss, { header: c, children: f.length === 0 ? /* @__PURE__ */ t("p", { className: "text-sm text-[var(--clique-fg-secondary)]", children: "No permissions assigned to this access role." }) : /* @__PURE__ */ t("div", { className: "flex flex-wrap gap-2", children: f.map((y) => /* @__PURE__ */ t(ce, { value: y.name, severity: "info" }, y.id)) }) }, p.id);
        }) }),
        /* @__PURE__ */ t(
          fe,
          {
            header: "Add Access Role to Group",
            visible: m.showAddDialog,
            onHide: () => m.setShowAddDialog(!1),
            closable: !m.isAdding,
            closeOnEscape: !m.isAdding,
            modal: !0,
            style: { width: "28rem" },
            footer: /* @__PURE__ */ o("div", { className: "flex justify-end gap-3", children: [
              /* @__PURE__ */ t(
                G,
                {
                  type: "button",
                  label: "Cancel",
                  onClick: () => m.setShowAddDialog(!1),
                  severity: "secondary",
                  outlined: !0,
                  disabled: m.isAdding
                }
              ),
              /* @__PURE__ */ t(
                G,
                {
                  type: "button",
                  label: "Add",
                  icon: "pi pi-plus",
                  onClick: m.handleAddRole,
                  raised: !0,
                  loading: m.isAdding,
                  disabled: m.isAvailableError || m.selectedRoleId === null
                }
              )
            ] }),
            children: m.isAvailableError ? /* @__PURE__ */ t(
              he,
              {
                error: m.availableError,
                resourceLabel: "access roles",
                onRetry: m.refetchAvailable
              }
            ) : /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
              /* @__PURE__ */ t(
                "label",
                {
                  htmlFor: "add-group-role",
                  className: "text-sm font-semibold text-[var(--clique-fg)]",
                  children: "Access Role"
                }
              ),
              /* @__PURE__ */ t(
                ge,
                {
                  inputId: "add-group-role",
                  value: m.selectedRoleId,
                  options: h,
                  onChange: (p) => m.setSelectedRoleId(p.value),
                  placeholder: "Select an access role",
                  className: "w-full",
                  filter: !0,
                  loading: m.isLoadingAvailable,
                  emptyMessage: "No available access roles"
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ t(
          Ge,
          {
            visible: m.roleToRemove !== null,
            onHide: () => m.setRoleToRemove(null),
            onConfirm: m.handleRemoveConfirm,
            header: "Remove Access Role",
            message: `Are you sure you want to remove "${(g = m.roleToRemove) == null ? void 0 : g.name}" from this group?`,
            confirmLabel: "Remove",
            confirmIcon: "pi pi-trash",
            confirmSeverity: "danger",
            loading: m.isRemoving
          }
        )
      ]
    }
  );
}
function Gn(e) {
  const { groupId: r, existingMemberIds: a, onSuccess: s, onError: n, onDismiss: d, enabled: l = !0 } = e, { group: m } = Re(), [v, i] = U([]), [u, h] = U("member"), [g, p] = U(null), {
    data: f,
    isLoading: c,
    isError: y,
    error: b,
    refetch: q
  } = Yr(void 0, { enabled: l }), C = Bs(r), N = re(() => f ? f.filter((I) => !a.includes(I.id)) : [], [f, a]), x = L(() => {
    i([]), h("member"), p(null);
  }, []), w = L(() => {
    if (v.length === 0) {
      n == null || n("Please select at least one user.");
      return;
    }
    const I = v.map((S) => ({
      userId: S,
      role: u
    }));
    C.mutate(I, {
      onSuccess: () => {
        s == null || s(
          `Successfully added ${v.length} member${v.length > 1 ? "s" : ""}.`
        ), x(), d == null || d();
      },
      onError: (S) => {
        console.error("Failed to add members", S), n == null || n("Failed to add members.");
      }
    });
  }, [v, u, C, s, n, d, x]);
  return {
    availableUsers: N,
    isLoadingUsers: c,
    isUsersError: y,
    usersError: b,
    refetchUsers: () => void q(),
    selectedUserIds: v,
    setSelectedUserIds: i,
    defaultRole: u,
    setDefaultRole: h,
    defaultExpiryDate: g,
    setDefaultExpiryDate: p,
    handleSubmit: w,
    isPending: C.isPending,
    resetForm: x,
    labels: m
  };
}
const Un = [
  { label: "Member", value: "member" },
  { label: "Manager", value: "manager" },
  { label: "Owner", value: "owner" }
];
function Mn({
  visible: e,
  onHide: r,
  groupId: a,
  existingMemberIds: s,
  onSuccess: n,
  onError: d,
  className: l,
  style: m,
  pt: v
}) {
  const i = Gn({
    groupId: a,
    existingMemberIds: s,
    onSuccess: n,
    onError: d,
    onDismiss: r,
    enabled: e
  }), u = () => {
    i.isPending || r();
  }, h = (c) => {
    i.setSelectedUserIds(c.value || []);
  }, g = (c) => {
    i.setDefaultRole(c.value);
  }, p = (c) => {
    i.setDefaultExpiryDate(c.value ?? null);
  }, f = /* @__PURE__ */ o("div", { className: "flex justify-end gap-2", children: [
    /* @__PURE__ */ t(
      G,
      {
        type: "button",
        label: "Cancel",
        icon: "pi pi-times",
        onClick: u,
        severity: "secondary",
        outlined: !0,
        disabled: i.isPending
      }
    ),
    /* @__PURE__ */ t(
      G,
      {
        type: "button",
        label: "Add Members",
        icon: "pi pi-plus",
        onClick: i.handleSubmit,
        loading: i.isPending,
        disabled: i.selectedUserIds.length === 0
      }
    )
  ] });
  return /* @__PURE__ */ o(
    fe,
    {
      header: `Add Members to ${i.labels.singularTitle}`,
      visible: e,
      onHide: u,
      footer: f,
      closable: !i.isPending,
      closeOnEscape: !i.isPending,
      className: l,
      style: { width: "600px", ...m },
      pt: v,
      breakpoints: { "960px": "90vw" },
      children: [
        i.isLoadingUsers && /* @__PURE__ */ t(xe, { message: "Loading users..." }),
        i.isUsersError && /* @__PURE__ */ t(
          he,
          {
            error: i.usersError,
            resourceLabel: "users",
            onRetry: () => i.refetchUsers()
          }
        ),
        !i.isLoadingUsers && !i.isUsersError && /* @__PURE__ */ o("div", { className: "flex flex-col gap-4", children: [
          /* @__PURE__ */ o("div", { children: [
            /* @__PURE__ */ o(
              "label",
              {
                htmlFor: "add-member-users",
                className: "block text-sm font-medium text-[var(--clique-fg)] mb-2",
                children: [
                  "Select Users ",
                  /* @__PURE__ */ t("span", { className: "text-[var(--clique-destructive)]", children: "*" })
                ]
              }
            ),
            /* @__PURE__ */ t(
              St,
              {
                inputId: "add-member-users",
                value: i.selectedUserIds,
                options: i.availableUsers,
                onChange: h,
                optionLabel: "email",
                optionValue: "id",
                placeholder: "Select users to add",
                filter: !0,
                showClear: !0,
                className: "w-full",
                display: "chip",
                disabled: i.isPending,
                emptyFilterMessage: "No users found",
                itemTemplate: (c) => {
                  var y;
                  return /* @__PURE__ */ o("div", { className: "flex items-center gap-2", children: [
                    /* @__PURE__ */ t("div", { className: "w-8 h-8 rounded-full bg-[var(--clique-primary-muted)] flex items-center justify-center text-[var(--clique-primary)] font-medium text-sm", children: ((y = c.givenName) == null ? void 0 : y[0]) || c.email[0].toUpperCase() }),
                    /* @__PURE__ */ o("div", { className: "flex flex-col", children: [
                      /* @__PURE__ */ t("span", { className: "font-medium text-[var(--clique-fg)]", children: c.givenName && c.familyName ? `${c.givenName} ${c.familyName}` : c.name || c.email }),
                      /* @__PURE__ */ t("span", { className: "text-xs text-[var(--clique-fg-secondary)]", children: c.email })
                    ] })
                  ] });
                }
              }
            ),
            i.availableUsers.length === 0 && /* @__PURE__ */ o("small", { className: "text-[var(--clique-fg-secondary)] mt-1 block", children: [
              "All users in this tenant are already members of this ",
              i.labels.singular,
              "."
            ] })
          ] }),
          /* @__PURE__ */ o("div", { children: [
            /* @__PURE__ */ o(
              "label",
              {
                htmlFor: "add-member-role",
                className: "block text-sm font-medium text-[var(--clique-fg)] mb-2",
                children: [
                  "Default Role ",
                  /* @__PURE__ */ t("span", { className: "text-[var(--clique-destructive)]", children: "*" })
                ]
              }
            ),
            /* @__PURE__ */ t(
              ge,
              {
                inputId: "add-member-role",
                value: i.defaultRole,
                options: Un,
                onChange: g,
                className: "w-full",
                disabled: i.isPending
              }
            ),
            /* @__PURE__ */ t("small", { className: "text-[var(--clique-fg-secondary)] mt-1 block", children: "All selected users will be added with this role." })
          ] }),
          /* @__PURE__ */ o("div", { children: [
            /* @__PURE__ */ t(
              "label",
              {
                htmlFor: "add-member-expiry",
                className: "block text-sm font-medium text-[var(--clique-fg)] mb-2",
                children: "Expiry Date (Optional)"
              }
            ),
            /* @__PURE__ */ t(
              Wr,
              {
                inputId: "add-member-expiry",
                value: i.defaultExpiryDate,
                onChange: p,
                className: "w-full",
                showIcon: !0,
                showButtonBar: !0,
                minDate: /* @__PURE__ */ new Date(),
                dateFormat: "yy-mm-dd",
                disabled: i.isPending
              }
            ),
            /* @__PURE__ */ t("small", { className: "text-[var(--clique-fg-secondary)] mt-1 block", children: "Leave empty for no expiration." })
          ] })
        ] })
      ]
    }
  );
}
function _t(e) {
  const { defaultIdentityIssuer: r, defaultIdentityIssuerMode: a } = Hr(), s = a === ns.Always && (r == null ? void 0 : r.trim()) || void 0, n = e && !s, {
    data: d = [],
    isLoading: l,
    isError: m
  } = wn(void 0, { enabled: n }), {
    data: v = [],
    isLoading: i,
    isError: u
  } = Rn({ enabled: n }), h = re(() => {
    if (s || v.length === 0 || d.length === 0) return [];
    const c = new Map(d.map((q) => [q.id, q])), y = /* @__PURE__ */ new Set(), b = [];
    for (const q of v) {
      if (q.issuerId === void 0 || q.issuerId === null) continue;
      const C = c.get(q.issuerId);
      !C || y.has(C.issuer) || (y.add(C.issuer), b.push({
        id: C.id,
        tenantId: C.tenantId,
        name: q.displayName || q.name,
        issuer: C.issuer
      }));
    }
    return b.sort((q, C) => q.name.localeCompare(C.name, void 0, { sensitivity: "base" })), b;
  }, [s, v, d]), g = s ? !1 : l || i, p = s ? !1 : m || u, f = re(() => {
    if (s) return s;
    if (!r || h.length === 0) return;
    const c = r.trim().toLowerCase();
    if (!c) return;
    const y = h.find((C) => C.issuer.toLowerCase() === c);
    if (y) return y.issuer;
    const b = h.find((C) => C.name.toLowerCase() === c);
    if (b) return b.issuer;
    const q = h.filter((C) => C.name.toLowerCase().includes(c));
    return q.length === 1 ? q[0].issuer : void 0;
  }, [s, r, h]);
  return ne(() => {
    s || !r || g || h.length === 0 || f || console.warn(
      `[clique] defaultIdentityIssuer "${r}" did not match any of the tenant's identity providers. Provide an exact issuer URL or provider name. Available providers: ${h.map((c) => c.name).join(", ")}`
    );
  }, [s, r, g, h, f]), {
    issuers: h,
    isLoadingIssuers: g,
    issuersError: p,
    resolvedDefaultIssuer: f,
    isIssuerLocked: !!s
  };
}
const $n = 300 * 1e3;
function On({
  issuers: e,
  resolvedDefaultIssuer: r,
  isIssuerLocked: a,
  users: s
}) {
  const n = W(), [d, l] = U([]), [m, v] = U(""), [i, u] = U(null), h = L((I) => {
    v(I), u(null);
  }, []), g = L(
    (I) => {
      if (!I || I.confidence === "low" || e.length === 0) return;
      const S = (R) => R == null ? void 0 : R.toLowerCase();
      if (I.recommendedProvider) {
        const R = S(I.recommendedProvider), P = e.find((_) => S(_.issuer) === R || S(_.name) === R);
        if (P) return P.issuer;
      }
      for (const R of I.providers)
        if (R.issuerUrl) {
          const P = e.find((_) => S(_.issuer) === S(R.issuerUrl));
          if (P && (!I.recommendedProvider || S(R.connectionName) === S(I.recommendedProvider)))
            return P.issuer;
        }
      const E = I.providers.find((R) => R.issuerUrl);
      if (E) {
        const R = e.find((P) => S(P.issuer) === S(E.issuerUrl));
        if (R) return R.issuer;
      }
    },
    [e]
  ), p = Ie(/* @__PURE__ */ new Set()), f = Ie(0), c = L(() => (f.current += 1, `new-user-${f.current}`), []), y = L(
    (I, S, E, R) => {
      if (!S) return;
      if (E.some(
        (A) => A.id !== R && A.email === I && A.identityIssuer === S
      ))
        return "A user with this email and issuer has already been added.";
      if (s == null ? void 0 : s.some(
        (A) => A.email.toLowerCase() === I && A.identityIssuer === S
      ))
        return "A user with this email and issuer already exists. Select them from the existing users list above.";
    },
    [s]
  ), b = L(
    (I) => I.map((S, E) => ({
      ...S,
      error: y(S.email, S.identityIssuer, I.slice(0, E), S.id)
    })),
    [y]
  );
  ne(() => {
    r && l((I) => {
      let S = !1;
      const E = I.map((R) => !R.identityIssuer && !R.isManualOverride ? (S = !0, { ...R, identityIssuer: r }) : R);
      return S ? b(E) : I;
    });
  }, [r, b]), ne(() => {
    l((I) => {
      if (I.length === 0) return I;
      const S = b(I);
      return S.some((R, P) => R.error !== I[P].error) ? S : I;
    });
  }, [b]);
  const q = L(
    (I) => {
      var _;
      const S = I.trim().toLowerCase();
      if (!S) return;
      const E = r;
      if (d.some((A) => A.email === S && A.identityIssuer === E)) {
        u("This email has already been added.");
        return;
      }
      u(null);
      const R = c();
      l(
        (A) => b([
          ...A,
          {
            id: R,
            email: S,
            identityIssuer: E
          }
        ])
      ), v("");
      const P = S.includes("@") && ((_ = S.split("@")[1]) == null ? void 0 : _.includes("."));
      a || !P || (p.current.add(S), n.fetchQuery({
        queryKey: ls.forEmail(S),
        queryFn: () => is.getForEmail(S).then((A) => A.data),
        staleTime: $n
      }).then((A) => {
        const k = g(A);
        k && A.confidence !== "low" && l(
          (T) => b(
            T.map(
              (D) => D.id === R && !D.isManualOverride ? {
                ...D,
                identityIssuer: k,
                detectedIssuer: k,
                detectedConfidence: A.confidence
              } : D
            )
          )
        );
      }).catch(() => {
      }).finally(() => {
        p.current.delete(S);
      }));
    },
    [
      d,
      g,
      r,
      a,
      b,
      n,
      c
    ]
  ), C = L(
    (I) => {
      l((S) => b(S.filter((E) => E.id !== I)));
    },
    [b]
  ), N = L(
    (I, S) => {
      l(
        (E) => b(
          E.map(
            (R) => R.id === I ? { ...R, identityIssuer: S, isManualOverride: !0 } : R
          )
        )
      );
    },
    [b]
  ), x = L((I) => {
    l((S) => S.map((E) => E.id === I ? { ...E, isManualOverride: !0 } : E));
  }, []), w = L(() => {
    l([]), v(""), u(null);
  }, []);
  return {
    newUsers: d,
    addNewUser: q,
    removeNewUser: C,
    updateNewUserIssuer: N,
    setManualOverride: x,
    newUserEmail: m,
    setNewUserEmail: h,
    emailError: i,
    setEmailError: u,
    revalidateNewUsers: b,
    setNewUsers: l,
    resetNewUsers: w
  };
}
async function _n({
  selectedUserIds: e,
  newUsers: r,
  notesValue: a,
  requestableAccessId: s,
  availableUsers: n,
  createInvitation: d,
  createUser: l
}) {
  var h;
  let m = 0;
  const v = [], i = [], u = /* @__PURE__ */ new Set();
  for (const g of e)
    try {
      await d({
        requestableAccessId: s,
        requestedForUserId: g,
        requestorNotes: a
      }), m += 1;
    } catch (p) {
      console.error(`Failed to invite user ${g}`, p), i.push(g);
      const f = ((h = n.find((c) => c.id === g)) == null ? void 0 : h.email) ?? `user ${g}`;
      v.push(f);
    }
  for (const g of r)
    try {
      const p = await l({
        email: g.email,
        identityIssuer: g.identityIssuer
      });
      await d({
        requestableAccessId: s,
        requestedForUserId: p.id,
        requestorNotes: a
      }), m += 1;
    } catch (p) {
      console.error(`Failed to create and invite ${g.email}`, p), u.add(g.id), v.push(g.email);
    }
  return { successCount: m, failedLabels: v, failedExistingIds: i, failedNewUserIds: u };
}
function zn(e) {
  const {
    requestableAccessId: r,
    existingMemberIds: a,
    onSuccess: s,
    onError: n,
    onDismiss: d,
    enabled: l = !0
  } = e, { group: m } = Re(), [v, i] = U([]), [u, h] = U(""), [g, p] = U(!1), {
    data: f,
    isLoading: c,
    isError: y,
    error: b,
    refetch: q
  } = Yr(void 0, { enabled: l }), C = Us(), N = Pt(), x = re(() => f ? f.filter((se) => !a.includes(se.id)) : [], [f, a]), { issuers: w, isLoadingIssuers: I, issuersError: S, resolvedDefaultIssuer: E, isIssuerLocked: R } = _t(l), {
    newUsers: P,
    addNewUser: _,
    removeNewUser: A,
    updateNewUserIssuer: k,
    setManualOverride: T,
    newUserEmail: D,
    setNewUserEmail: K,
    emailError: M,
    setEmailError: ee,
    revalidateNewUsers: Q,
    setNewUsers: j,
    resetNewUsers: $
  } = On({
    issuers: w,
    resolvedDefaultIssuer: E,
    isIssuerLocked: R,
    users: f
  }), ie = v.length > 0 || P.length > 0, O = P.some((se) => !!se.error), ae = ie && !O, Y = L(() => {
    i([]), h(""), $();
  }, [$]), ue = L(async () => {
    if (!ie) {
      n == null || n("Please select at least one user or add a new email.");
      return;
    }
    if (P.filter((V) => !V.identityIssuer).length > 0) {
      n == null || n("Please select an identity issuer for all new users.");
      return;
    }
    if (P.filter((V) => V.error).length > 0) {
      n == null || n("Resolve the highlighted email and issuer conflicts before sending invitations.");
      return;
    }
    p(!0);
    const { successCount: oe, failedLabels: le, failedExistingIds: H, failedNewUserIds: ze } = await _n(
      {
        selectedUserIds: v,
        newUsers: P,
        notesValue: u.trim() || void 0,
        requestableAccessId: r,
        availableUsers: x,
        createInvitation: (V) => C.mutateAsync(V),
        createUser: (V) => N.mutateAsync(V)
      }
    );
    if (p(!1), le.length === 0) {
      s == null || s(`Successfully invited ${oe} user${oe > 1 ? "s" : ""}.`), Y(), d == null || d();
      return;
    }
    if (i(H), j((V) => Q(V.filter((Se) => ze.has(Se.id)))), oe > 0) {
      n == null || n(
        `Invited ${oe} user${oe > 1 ? "s" : ""}, but failed for: ${le.join(", ")}. The failed entries are kept so you can retry.`
      );
      return;
    }
    n == null || n("Failed to send invitations.");
  }, [
    ie,
    v,
    P,
    u,
    r,
    x,
    C,
    N,
    Q,
    j,
    s,
    n,
    d,
    Y
  ]);
  return {
    availableUsers: x,
    isLoadingUsers: c,
    isUsersError: y,
    usersError: b,
    refetchUsers: () => void q(),
    selectedUserIds: v,
    setSelectedUserIds: i,
    notes: u,
    setNotes: h,
    newUsers: P,
    addNewUser: _,
    removeNewUser: A,
    updateNewUserIssuer: k,
    setManualOverride: T,
    newUserEmail: D,
    setNewUserEmail: K,
    emailError: M,
    setEmailError: ee,
    issuers: w,
    isLoadingIssuers: I,
    issuersError: S,
    defaultIssuer: E,
    isIssuerLocked: R,
    handleSubmit: () => void ue(),
    isPending: g,
    resetForm: Y,
    labels: m,
    canSubmit: ae
  };
}
function Kn(e) {
  return e === "high" ? "Auto-detected" : "Suggested";
}
function Qn(e) {
  return e === "high" ? "success" : "warning";
}
function jn({
  newUser: e,
  issuers: r,
  defaultIssuer: a,
  isLoadingIssuers: s,
  isIssuerLocked: n,
  isPending: d,
  onUpdateIssuer: l,
  onManualOverride: m,
  onRemove: v
}) {
  var p;
  const i = !!e.detectedIssuer && !e.isManualOverride, u = (p = r.find((f) => f.issuer === e.identityIssuer)) == null ? void 0 : p.name, h = (f) => /* @__PURE__ */ o("div", { className: "flex items-center justify-between gap-2", children: [
    /* @__PURE__ */ t("span", { children: f.label }),
    a && f.value === a && /* @__PURE__ */ t(ce, { value: "Default", severity: "info" })
  ] }), g = (f, c) => f ? /* @__PURE__ */ o("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ t("span", { children: f.label }),
    a && f.value === a && /* @__PURE__ */ t(ce, { value: "Default", severity: "info" })
  ] }) : /* @__PURE__ */ t("span", { className: "text-[var(--clique-fg-secondary)]", children: c.placeholder });
  return /* @__PURE__ */ o("div", { className: "flex items-center gap-2 p-3 rounded-lg border border-[var(--clique-border)] bg-[var(--clique-bg-secondary)]", children: [
    /* @__PURE__ */ o("div", { className: "flex-1 flex flex-col gap-2", children: [
      /* @__PURE__ */ o("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ t(qs, { label: e.email, icon: "pi pi-user-plus" }),
        e.detectedConfidence && !e.isManualOverride && /* @__PURE__ */ t(
          ce,
          {
            value: Kn(e.detectedConfidence),
            severity: Qn(e.detectedConfidence),
            icon: e.detectedConfidence === "high" ? "pi pi-check-circle" : "pi pi-info-circle"
          }
        )
      ] }),
      !n && (i ? /* @__PURE__ */ o("div", { className: "flex items-center gap-2 text-sm", children: [
        /* @__PURE__ */ t("i", { "aria-hidden": "true", className: "pi pi-shield text-[var(--clique-primary)]" }),
        /* @__PURE__ */ t("span", { className: "text-[var(--clique-fg)]", children: u || e.identityIssuer }),
        /* @__PURE__ */ t(
          "button",
          {
            type: "button",
            className: "text-xs text-[var(--clique-primary)] hover:underline cursor-pointer bg-transparent border-none p-0",
            onClick: m,
            disabled: d,
            children: "Change"
          }
        )
      ] }) : /* @__PURE__ */ t(
        ge,
        {
          value: e.identityIssuer || "",
          options: r.map((f) => ({
            label: f.name,
            value: f.issuer
          })),
          onChange: (f) => l(f.value),
          placeholder: "Select identity issuer *",
          className: "w-full",
          loading: s,
          disabled: d,
          itemTemplate: h,
          valueTemplate: g
        }
      )),
      e.error && /* @__PURE__ */ t("small", { className: "text-[var(--clique-destructive)]", children: e.error })
    ] }),
    /* @__PURE__ */ t(
      G,
      {
        type: "button",
        icon: "pi pi-trash",
        severity: "danger",
        text: !0,
        rounded: !0,
        onClick: v,
        disabled: d,
        tooltip: "Remove",
        tooltipOptions: { position: "top" }
      }
    )
  ] });
}
function Bn({
  visible: e,
  onHide: r,
  requestableAccessId: a,
  existingMemberIds: s,
  onSuccess: n,
  onError: d,
  className: l,
  style: m,
  pt: v
}) {
  const i = zn({
    requestableAccessId: a,
    existingMemberIds: s,
    onSuccess: n,
    onError: d,
    onDismiss: r,
    // Only fetch users/issuers/providers once the dialog is actually open.
    enabled: e
  }), u = () => {
    i.isPending || r();
  }, h = (c) => {
    i.setSelectedUserIds(c.value || []);
  }, g = () => {
    const c = i.newUserEmail.trim();
    if (!c) return;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(c)) {
      i.setEmailError("Please enter a valid email address.");
      return;
    }
    i.addNewUser(c);
  }, p = (c) => {
    c.key === "Enter" && (c.preventDefault(), g());
  }, f = /* @__PURE__ */ o("div", { className: "flex justify-end gap-2", children: [
    /* @__PURE__ */ t(
      G,
      {
        type: "button",
        label: "Cancel",
        icon: "pi pi-times",
        onClick: u,
        severity: "secondary",
        outlined: !0,
        disabled: i.isPending
      }
    ),
    /* @__PURE__ */ t(
      G,
      {
        type: "button",
        label: "Send Invitations",
        icon: "pi pi-envelope",
        onClick: i.handleSubmit,
        loading: i.isPending,
        disabled: !i.canSubmit
      }
    )
  ] });
  return /* @__PURE__ */ o(
    fe,
    {
      header: `Invite Users to ${i.labels.singularTitle}`,
      visible: e,
      onHide: u,
      footer: f,
      closable: !i.isPending,
      closeOnEscape: !i.isPending,
      className: l,
      style: { width: "650px", ...m },
      pt: v,
      breakpoints: { "960px": "90vw" },
      children: [
        i.isLoadingUsers && /* @__PURE__ */ t(xe, { message: "Loading users..." }),
        i.isUsersError && /* @__PURE__ */ t(
          he,
          {
            error: i.usersError,
            resourceLabel: "users",
            onRetry: () => i.refetchUsers()
          }
        ),
        !i.isLoadingUsers && !i.isUsersError && /* @__PURE__ */ o("div", { className: "flex flex-col gap-5", children: [
          /* @__PURE__ */ o("div", { children: [
            /* @__PURE__ */ t(
              "label",
              {
                htmlFor: "invite-member-users",
                className: "block text-sm font-medium text-[var(--clique-fg)] mb-2",
                children: "Select Existing Users"
              }
            ),
            /* @__PURE__ */ t(
              St,
              {
                inputId: "invite-member-users",
                value: i.selectedUserIds,
                options: i.availableUsers,
                onChange: h,
                optionLabel: "email",
                optionValue: "id",
                placeholder: "Search and select existing users",
                filter: !0,
                showClear: !0,
                className: "w-full",
                display: "chip",
                disabled: i.isPending,
                emptyFilterMessage: "No users found",
                itemTemplate: (c) => {
                  var y;
                  return /* @__PURE__ */ o("div", { className: "flex items-center gap-2", children: [
                    /* @__PURE__ */ t("div", { className: "w-8 h-8 rounded-full bg-[var(--clique-primary-muted)] flex items-center justify-center text-[var(--clique-primary)] font-medium text-sm", children: ((y = c.givenName) == null ? void 0 : y[0]) || c.email[0].toUpperCase() }),
                    /* @__PURE__ */ o("div", { className: "flex flex-col", children: [
                      /* @__PURE__ */ t("span", { className: "font-medium text-[var(--clique-fg)]", children: c.givenName && c.familyName ? `${c.givenName} ${c.familyName}` : c.name || c.email }),
                      /* @__PURE__ */ t("span", { className: "text-xs text-[var(--clique-fg-secondary)]", children: c.email })
                    ] })
                  ] });
                }
              }
            ),
            i.availableUsers.length === 0 && /* @__PURE__ */ o("small", { className: "text-[var(--clique-fg-secondary)] mt-1 block", children: [
              "All users in this tenant are already members of this ",
              i.labels.singular,
              "."
            ] })
          ] }),
          /* @__PURE__ */ o("div", { className: "flex items-center gap-3", children: [
            /* @__PURE__ */ t("div", { className: "flex-1 border-t border-[var(--clique-border)]" }),
            /* @__PURE__ */ t("span", { className: "text-xs font-medium text-[var(--clique-fg-secondary)] uppercase", children: "Or invite new users" }),
            /* @__PURE__ */ t("div", { className: "flex-1 border-t border-[var(--clique-border)]" })
          ] }),
          i.issuersError && /* @__PURE__ */ o(
            "div",
            {
              role: "alert",
              className: "flex items-start gap-2 p-3 rounded-lg border border-[var(--clique-destructive-border)] bg-[var(--clique-destructive-subtle)] text-sm text-[var(--clique-destructive-strong)]",
              children: [
                /* @__PURE__ */ t("i", { "aria-hidden": "true", className: "pi pi-exclamation-triangle mt-0.5" }),
                /* @__PURE__ */ t("span", { children: "Couldn't load identity providers. New users can't be created right now — you can still invite existing users above, or close and retry." })
              ]
            }
          ),
          /* @__PURE__ */ o("div", { children: [
            /* @__PURE__ */ t(
              "label",
              {
                htmlFor: "invite-new-user-email",
                className: "block text-sm font-medium text-[var(--clique-fg)] mb-2",
                children: "New User Email"
              }
            ),
            /* @__PURE__ */ o("div", { className: "flex gap-2", children: [
              /* @__PURE__ */ t(
                me,
                {
                  id: "invite-new-user-email",
                  value: i.newUserEmail,
                  onChange: (c) => i.setNewUserEmail(c.target.value),
                  onKeyDown: p,
                  placeholder: "Enter email address for new user",
                  className: "flex-1",
                  disabled: i.isPending || i.issuersError,
                  invalid: !!i.emailError,
                  "aria-invalid": !!i.emailError,
                  "aria-describedby": "invite-new-user-email-help"
                }
              ),
              /* @__PURE__ */ t(
                G,
                {
                  type: "button",
                  icon: "pi pi-plus",
                  onClick: g,
                  disabled: i.isPending || i.issuersError || !i.newUserEmail.trim(),
                  tooltip: "Add new user",
                  tooltipOptions: { position: "top" }
                }
              )
            ] }),
            i.emailError ? /* @__PURE__ */ t(
              "small",
              {
                id: "invite-new-user-email-help",
                className: "text-[var(--clique-destructive)] mt-1 block",
                children: i.emailError
              }
            ) : i.isIssuerLocked ? null : /* @__PURE__ */ t(
              "small",
              {
                id: "invite-new-user-email-help",
                className: "text-[var(--clique-fg-secondary)] mt-1 block",
                children: "Identity provider will be detected automatically when possible."
              }
            )
          ] }),
          i.newUsers.length > 0 && /* @__PURE__ */ o("div", { children: [
            /* @__PURE__ */ t("label", { className: "block text-sm font-medium text-[var(--clique-fg)] mb-2", children: "New Users to Create" }),
            /* @__PURE__ */ t("div", { className: "flex flex-col gap-3", children: i.newUsers.map((c) => /* @__PURE__ */ t(
              jn,
              {
                newUser: c,
                issuers: i.issuers,
                defaultIssuer: i.defaultIssuer,
                isLoadingIssuers: i.isLoadingIssuers,
                isIssuerLocked: i.isIssuerLocked,
                isPending: i.isPending,
                onUpdateIssuer: (y) => i.updateNewUserIssuer(c.id, y),
                onManualOverride: () => i.setManualOverride(c.id),
                onRemove: () => i.removeNewUser(c.id)
              },
              c.id
            )) })
          ] }),
          /* @__PURE__ */ o("div", { children: [
            /* @__PURE__ */ t(
              "label",
              {
                htmlFor: "invite-member-notes",
                className: "block text-sm font-medium text-[var(--clique-fg)] mb-2",
                children: "Message (Optional)"
              }
            ),
            /* @__PURE__ */ t(
              _e,
              {
                id: "invite-member-notes",
                value: i.notes,
                onChange: (c) => i.setNotes(c.target.value),
                placeholder: "Add a message to include with the invitation",
                className: "w-full",
                rows: 3,
                autoResize: !0,
                disabled: i.isPending
              }
            )
          ] })
        ] })
      ]
    }
  );
}
function Hn(e) {
  const { groupId: r, onSuccess: a, onError: s } = e, { group: n } = Re(), [d, l] = U(!1), [m, v] = U(!1), [i, u] = U(null), [h, g] = U(null), [p, f] = U(null), c = re(
    () => ({
      order: "id DESC",
      fields: {
        id: !0,
        name: !0,
        email: !0,
        givenName: !0,
        familyName: !0,
        displayName: !0,
        picture: !0
      }
    }),
    []
  ), {
    data: y,
    isLoading: b,
    isError: q,
    error: C,
    refetch: N
  } = js(r, c), { data: x } = Rt(r), w = Hs(r), I = Ws(r), S = re(() => y ? Array.isArray(y.users) ? y.users : (console.error("Members is not an array:", y.users), []) : [], [y]), E = re(() => S.map((T) => T.id), [S]), R = S.length, P = L(() => {
    N();
  }, [N]), _ = L(() => {
    i && I.mutate(i.id, {
      onSuccess: () => {
        u(null), a == null || a("Member removed successfully."), P();
      },
      onError: (T) => {
        u(null), console.error("Failed to remove member", T), s == null || s("Failed to remove member.");
      }
    });
  }, [i, I, a, s, P]), A = L(
    (T, D) => {
      const K = { role: D };
      w.mutate(
        { userId: T, data: K },
        {
          onSuccess: () => {
            g(null), a == null || a("Member role updated successfully."), P();
          },
          onError: (M) => {
            console.error("Failed to update member role", M), s == null || s("Failed to update member role.");
          }
        }
      );
    },
    [w, a, s, P]
  ), k = L(
    (T, D) => {
      const K = {
        expiryDate: D ? D.toISOString() : null
      };
      w.mutate(
        { userId: T, data: K },
        {
          onSuccess: () => {
            f(null), a == null || a("Expiry date updated successfully."), P();
          },
          onError: (M) => {
            console.error("Failed to update expiry date", M), s == null || s("Failed to update expiry date.");
          }
        }
      );
    },
    [w, a, s, P]
  );
  return {
    members: S,
    memberCount: R,
    existingMemberIds: E,
    isLoading: b,
    isError: q,
    error: C,
    refetch: P,
    hasInviteCapability: x != null,
    requestableAccessId: x == null ? void 0 : x.id,
    showAddDialog: d,
    setShowAddDialog: l,
    showInviteDialog: m,
    setShowInviteDialog: v,
    memberToRemove: i,
    setMemberToRemove: u,
    handleRemoveConfirm: _,
    isRemoving: I.isPending,
    editingRoleForUserId: h,
    setEditingRoleForUserId: g,
    handleRoleChange: A,
    editingExpiryForUserId: p,
    setEditingExpiryForUserId: f,
    handleExpiryChange: k,
    isUpdating: w.isPending,
    labels: n
  };
}
const Vn = [
  { label: "Member", value: "member" },
  { label: "Manager", value: "manager" },
  { label: "Owner", value: "owner" }
], Wn = {
  member: "info",
  manager: "success",
  owner: "warning"
}, Yn = {
  member: "pi pi-user",
  manager: "pi pi-briefcase",
  owner: "pi pi-crown"
};
function zt({
  groupId: e,
  onSuccess: r,
  onError: a,
  className: s,
  style: n,
  pt: d
}) {
  var g;
  const l = Hn({ groupId: e, onSuccess: r, onError: a }), m = (p) => {
    var y;
    const f = p.givenName && p.familyName ? `${p.givenName} ${p.familyName}` : p.name || p.email, c = ((y = p.givenName) == null ? void 0 : y[0]) || p.email[0].toUpperCase();
    return /* @__PURE__ */ o("div", { className: "flex items-center gap-3", children: [
      /* @__PURE__ */ t("div", { className: "w-10 h-10 rounded-full bg-[var(--clique-primary-muted)] flex items-center justify-center text-[var(--clique-primary)] font-medium", children: c }),
      /* @__PURE__ */ o("div", { className: "flex flex-col", children: [
        /* @__PURE__ */ t("span", { className: "font-medium text-[var(--clique-fg)]", children: f }),
        /* @__PURE__ */ t("span", { className: "text-xs text-[var(--clique-fg-secondary)]", children: p.email })
      ] })
    ] });
  }, v = (p) => {
    const f = p.role || "member";
    return l.editingRoleForUserId === p.id ? /* @__PURE__ */ t(
      ge,
      {
        value: f,
        options: Vn,
        onChange: (c) => l.handleRoleChange(p.id, c.value),
        disabled: l.isUpdating,
        autoFocus: !0,
        onBlur: () => l.setEditingRoleForUserId(null),
        className: "w-full"
      }
    ) : /* @__PURE__ */ o("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ t(ce, { value: f, severity: Wn[f], icon: Yn[f] }),
      /* @__PURE__ */ t(
        G,
        {
          icon: "pi pi-pencil",
          className: "p-button-text p-button-sm",
          onClick: () => l.setEditingRoleForUserId(p.id)
        }
      )
    ] });
  }, i = (p) => {
    const f = p.expiryDate !== null && p.expiryDate !== void 0, c = f && new Date(p.expiryDate) < new Date(Date.now() + 10080 * 60 * 1e3);
    return l.editingExpiryForUserId === p.id ? /* @__PURE__ */ t(
      Wr,
      {
        value: p.expiryDate ? new Date(p.expiryDate) : null,
        onChange: (y) => l.handleExpiryChange(p.id, y.value),
        className: "w-full",
        showIcon: !0,
        showButtonBar: !0,
        minDate: /* @__PURE__ */ new Date(),
        dateFormat: "yy-mm-dd",
        disabled: l.isUpdating,
        autoFocus: !0,
        onBlur: () => l.setEditingExpiryForUserId(null)
      }
    ) : /* @__PURE__ */ o("div", { className: "flex items-center gap-2", children: [
      f ? /* @__PURE__ */ o(
        "span",
        {
          className: c ? "text-[var(--clique-accent)] font-medium" : "text-[var(--clique-fg)]",
          children: [
            new Date(p.expiryDate).toLocaleDateString(),
            c && /* @__PURE__ */ t("i", { className: "pi pi-exclamation-triangle ml-2 text-[var(--clique-accent)]" })
          ]
        }
      ) : /* @__PURE__ */ t("span", { className: "text-[var(--clique-fg-tertiary)]", children: "No expiry" }),
      /* @__PURE__ */ t(
        G,
        {
          icon: "pi pi-calendar",
          className: "p-button-text p-button-sm",
          onClick: () => l.setEditingExpiryForUserId(p.id)
        }
      )
    ] });
  }, u = (p) => /* @__PURE__ */ t(
    G,
    {
      icon: "pi pi-trash",
      className: "p-button-text p-button-danger p-button-sm",
      onClick: () => l.setMemberToRemove(p)
    }
  ), h = /* @__PURE__ */ o("div", { className: "flex items-center justify-between", children: [
    /* @__PURE__ */ o("span", { className: "text-lg font-semibold", children: [
      "Members (",
      l.memberCount,
      ")"
    ] }),
    /* @__PURE__ */ o("div", { className: "flex gap-2", children: [
      l.hasInviteCapability && /* @__PURE__ */ t(
        G,
        {
          type: "button",
          label: "Invite Users",
          icon: "pi pi-envelope",
          size: "small",
          severity: "secondary",
          outlined: !0,
          onClick: () => l.setShowInviteDialog(!0)
        }
      ),
      /* @__PURE__ */ t(
        G,
        {
          type: "button",
          label: "Add Members",
          icon: "pi pi-plus",
          size: "small",
          onClick: () => l.setShowAddDialog(!0)
        }
      )
    ] })
  ] });
  return l.isLoading ? /* @__PURE__ */ t(xe, { message: "Loading members..." }) : l.isError ? /* @__PURE__ */ t(
    he,
    {
      error: l.error,
      resourceLabel: "members",
      onRetry: () => l.refetch()
    }
  ) : /* @__PURE__ */ o(
    "div",
    {
      className: be("mt-8 border-t border-[var(--clique-border)] pt-6", s),
      style: n,
      children: [
        /* @__PURE__ */ o(
          Ae,
          {
            value: l.members,
            paginator: !0,
            rows: 10,
            rowsPerPageOptions: [5, 10, 25, 50],
            paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
            currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} members",
            stripedRows: !0,
            showGridlines: !0,
            pt: d,
            header: h,
            emptyMessage: /* @__PURE__ */ o("div", { className: "text-center py-8", children: [
              /* @__PURE__ */ t("i", { className: "pi pi-users text-4xl text-[var(--clique-fg-tertiary)] mb-3" }),
              /* @__PURE__ */ t("p", { className: "text-[var(--clique-fg-secondary)]", children: 'No members yet. Click "Add Members" to get started.' })
            ] }),
            tableStyle: { minWidth: "50rem" },
            children: [
              /* @__PURE__ */ t(X, { header: "User", body: m, style: { width: "40%" } }),
              /* @__PURE__ */ t(X, { header: "Role", body: v, style: { width: "25%" } }),
              /* @__PURE__ */ t(X, { header: "Expiry Date", body: i, style: { width: "25%" } }),
              /* @__PURE__ */ t(
                X,
                {
                  header: "Actions",
                  body: u,
                  style: { width: "10%" },
                  bodyStyle: { textAlign: "center" },
                  headerStyle: { textAlign: "center" }
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ t(
          Mn,
          {
            visible: l.showAddDialog,
            onHide: () => l.setShowAddDialog(!1),
            groupId: e,
            existingMemberIds: l.existingMemberIds,
            onSuccess: (p) => {
              r == null || r(p), l.refetch();
            },
            onError: a
          }
        ),
        l.hasInviteCapability && /* @__PURE__ */ t(
          Bn,
          {
            visible: l.showInviteDialog,
            onHide: () => l.setShowInviteDialog(!1),
            requestableAccessId: l.requestableAccessId,
            existingMemberIds: l.existingMemberIds,
            onSuccess: (p) => {
              r == null || r(p), l.refetch();
            },
            onError: a
          }
        ),
        /* @__PURE__ */ t(
          Ge,
          {
            visible: l.memberToRemove !== null,
            onHide: () => l.setMemberToRemove(null),
            onConfirm: l.handleRemoveConfirm,
            header: "Remove Member",
            message: `Are you sure you want to remove ${((g = l.memberToRemove) == null ? void 0 : g.email) || "this user"} from the ${l.labels.singular}?`,
            confirmLabel: "Remove",
            confirmIcon: "pi pi-trash",
            confirmSeverity: "danger",
            loading: l.isRemoving
          }
        )
      ]
    }
  );
}
function Or({
  visible: e,
  onHide: r,
  assignTo: a,
  preselectedRoleId: s,
  preselectedGroupId: n,
  preselectedUserId: d,
  onAssigned: l,
  onSuccess: m,
  onError: v,
  className: i,
  style: u,
  pt: h
}) {
  const [g, p] = U(null), [f, c] = U(null), [y, b] = U(""), [q, C] = U(null), [N, x] = U(""), [w, I] = U(""), { data: S, isLoading: E } = Gt({
    limit: 500,
    order: "name ASC"
  }), { data: R, isLoading: P } = dr({
    limit: 500,
    order: "name ASC"
  }), { data: _, isLoading: A } = Qs(N), { data: k } = Ks(d ?? 0), T = qn(), D = Cn();
  ne(() => {
    e && (p(s ?? null), c(a === "user" ? d ?? null : n ?? null), b(""), C(null), x(""), I(""));
  }, [e, s, n, d, a]);
  const K = T.isPending || D.isPending, M = (S ?? []).map((O) => ({
    label: O.name,
    value: O.id
  })), ee = (R ?? []).map((O) => ({
    label: O.name,
    value: O.id
  })), Q = [
    ...k && !(_ ?? []).some((O) => O.id === k.id) ? [
      {
        label: `${k.displayName || k.name || k.email} (${k.email})`,
        value: k.id
      }
    ] : [],
    ...(_ ?? []).map((O) => ({
      label: `${O.displayName || O.name || O.email} (${O.email})`,
      value: O.id
    }))
  ], j = L(() => {
    if (!g || !f) return;
    I("");
    const O = {
      umrsRoleId: g,
      resourceId: y.trim(),
      ...q ? { expiresAt: q.toISOString() } : {}
    };
    a === "user" ? T.mutate(
      { userId: f, ...O },
      {
        onSuccess: () => {
          m == null || m("UMRS role granted to user."), l == null || l(), r();
        },
        onError: (ae) => {
          console.error("Failed to assign grant", ae);
          const Y = "Failed to assign UMRS role. Please try again.";
          I(Y), v == null || v(Y);
        }
      }
    ) : D.mutate(
      { groupId: f, ...O },
      {
        onSuccess: () => {
          m == null || m("UMRS role granted to group."), l == null || l(), r();
        },
        onError: (ae) => {
          console.error("Failed to assign grant", ae);
          const Y = "Failed to assign UMRS role. Please try again.";
          I(Y), v == null || v(Y);
        }
      }
    );
  }, [
    g,
    f,
    y,
    q,
    a,
    T,
    D,
    m,
    l,
    r,
    v
  ]), $ = a === "user" ? "Assign UMRS Role to User" : "Assign UMRS Role to Group", ie = g !== null && f !== null;
  return /* @__PURE__ */ t(
    fe,
    {
      visible: e,
      onHide: r,
      header: $,
      modal: !0,
      draggable: !1,
      resizable: !1,
      closable: !K,
      closeOnEscape: !K,
      className: i,
      style: { width: "30rem", ...u },
      pt: h,
      footer: /* @__PURE__ */ o("div", { className: "flex justify-end gap-3", children: [
        /* @__PURE__ */ t(
          G,
          {
            type: "button",
            label: "Cancel",
            onClick: r,
            severity: "secondary",
            outlined: !0,
            disabled: K
          }
        ),
        /* @__PURE__ */ t(
          G,
          {
            type: "button",
            label: "Assign",
            icon: "pi pi-check",
            onClick: j,
            raised: !0,
            loading: K,
            disabled: !ie || K
          }
        )
      ] }),
      children: /* @__PURE__ */ o("div", { className: "flex flex-col gap-5", children: [
        /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
          /* @__PURE__ */ o(
            "label",
            {
              htmlFor: "grant-umrs-role",
              className: "text-sm font-semibold text-[var(--clique-fg)]",
              children: [
                "UMRS Role ",
                /* @__PURE__ */ t("span", { className: "text-[var(--clique-destructive)]", children: "*" })
              ]
            }
          ),
          /* @__PURE__ */ t(
            ge,
            {
              inputId: "grant-umrs-role",
              value: g,
              options: M,
              onChange: (O) => p(O.value),
              placeholder: "Select a UMRS role",
              className: "w-full",
              loading: E,
              filter: !0,
              disabled: !!s,
              emptyMessage: "No UMRS roles available"
            }
          )
        ] }),
        a === "user" ? /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
          /* @__PURE__ */ o(
            "label",
            {
              htmlFor: "grant-target-user",
              className: "text-sm font-semibold text-[var(--clique-fg)]",
              children: [
                "User ",
                /* @__PURE__ */ t("span", { className: "text-[var(--clique-destructive)]", children: "*" })
              ]
            }
          ),
          /* @__PURE__ */ t(
            ge,
            {
              inputId: "grant-target-user",
              value: f,
              options: Q,
              onChange: (O) => c(O.value),
              onFilter: (O) => x(O.filter),
              placeholder: "Search for a user...",
              className: "w-full",
              loading: A,
              filter: !0,
              disabled: !!d,
              emptyFilterMessage: N.length < 2 ? "Type at least 2 characters" : "No users found",
              emptyMessage: "Type to search for users"
            }
          )
        ] }) : /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
          /* @__PURE__ */ o(
            "label",
            {
              htmlFor: "grant-target-group",
              className: "text-sm font-semibold text-[var(--clique-fg)]",
              children: [
                "Group ",
                /* @__PURE__ */ t("span", { className: "text-[var(--clique-destructive)]", children: "*" })
              ]
            }
          ),
          /* @__PURE__ */ t(
            ge,
            {
              inputId: "grant-target-group",
              value: f,
              options: ee,
              onChange: (O) => c(O.value),
              placeholder: "Select a group",
              className: "w-full",
              loading: P,
              filter: !0,
              disabled: !!n,
              emptyMessage: "No groups available"
            }
          )
        ] }),
        /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
          /* @__PURE__ */ t(
            "label",
            {
              htmlFor: "grant-resource-id",
              className: "text-sm font-semibold text-[var(--clique-fg)]",
              children: "Resource ID"
            }
          ),
          /* @__PURE__ */ t(
            me,
            {
              id: "grant-resource-id",
              value: y,
              onChange: (O) => b(O.target.value),
              placeholder: "Optional resource identifier",
              className: "w-full"
            }
          )
        ] }),
        /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
          /* @__PURE__ */ t(
            "label",
            {
              htmlFor: "grant-expires-at",
              className: "text-sm font-semibold text-[var(--clique-fg)]",
              children: "Expires At"
            }
          ),
          /* @__PURE__ */ t(
            Wr,
            {
              inputId: "grant-expires-at",
              value: q,
              onChange: (O) => C(O.value),
              showTime: !0,
              showIcon: !0,
              placeholder: "Optional expiration date",
              className: "w-full",
              minDate: /* @__PURE__ */ new Date()
            }
          )
        ] }),
        w && /* @__PURE__ */ o("div", { className: "text-[var(--clique-destructive-strong)] text-sm bg-[var(--clique-destructive-subtle)] border border-[var(--clique-destructive-border)] rounded-lg p-3", children: [
          /* @__PURE__ */ t("i", { "aria-hidden": "true", className: "pi pi-exclamation-circle mr-2" }),
          w
        ] })
      ] })
    }
  );
}
function Jn(e) {
  const { groupId: r, onSuccess: a, onError: s } = e, { data: n, isLoading: d, isError: l, error: m, refetch: v } = Nn(r), i = Mt(), [u, h] = U(!1), [g, p] = U(null), f = L(() => {
    g && i.mutate(g.grantId, {
      onSuccess: () => {
        a == null || a(`Grant for "${g.roleName}" revoked.`), p(null);
      },
      onError: (c) => {
        console.error("Failed to revoke grant", c), s == null || s("Failed to revoke grant. Please try again.");
      }
    });
  }, [g, i, a, s]);
  return {
    grants: n ?? [],
    isLoading: d,
    isError: l,
    error: m,
    refetch: v,
    showAssignDialog: u,
    setShowAssignDialog: h,
    grantToRevoke: g,
    setGrantToRevoke: p,
    handleRevoke: f,
    isRevoking: i.isPending
  };
}
function Xn(e) {
  return e ? new Date(e).toLocaleDateString(void 0, {
    year: "numeric",
    month: "short",
    day: "numeric"
  }) : "—";
}
function Kt({
  groupId: e,
  onSuccess: r,
  onError: a,
  className: s,
  style: n,
  pt: d
}) {
  var g;
  const l = Jn({ groupId: e, onSuccess: r, onError: a }), m = (p) => /* @__PURE__ */ t("span", { className: "font-medium text-[var(--clique-fg)]", children: p.roleName }), v = (p) => /* @__PURE__ */ t(ce, { value: p.resourceServer, severity: "info" }), i = (p) => {
    const f = Xn(p.expiresAt);
    return p.expiringSoon ? /* @__PURE__ */ t(ce, { value: f, severity: "warning", icon: "pi pi-clock" }) : f;
  }, u = (p) => p.grantSource || "—", h = (p) => /* @__PURE__ */ t(
    G,
    {
      type: "button",
      icon: "pi pi-trash",
      onClick: () => l.setGrantToRevoke(p),
      severity: "danger",
      text: !0,
      rounded: !0,
      size: "small",
      "aria-label": "Revoke grant"
    }
  );
  return /* @__PURE__ */ o("div", { className: be("mt-6", s), style: n, children: [
    /* @__PURE__ */ o(
      "div",
      {
        className: "rounded-lg border border-[var(--clique-border)] p-6",
        style: { backgroundColor: "var(--clique-bg)" },
        children: [
          /* @__PURE__ */ o("div", { className: "flex items-center justify-between mb-4", children: [
            /* @__PURE__ */ t("h3", { className: "text-lg font-medium text-[var(--clique-fg)]", children: "UMRS Roles" }),
            /* @__PURE__ */ t(
              G,
              {
                type: "button",
                label: "Assign Role",
                icon: "pi pi-plus",
                onClick: () => l.setShowAssignDialog(!0),
                size: "small",
                outlined: !0
              }
            )
          ] }),
          l.isLoading ? /* @__PURE__ */ t(xe, { message: "Loading UMRS grants..." }) : l.isError ? /* @__PURE__ */ t(
            he,
            {
              error: l.error,
              resourceLabel: "UMRS grants",
              onRetry: l.refetch
            }
          ) : l.grants.length === 0 ? /* @__PURE__ */ t("p", { className: "text-sm text-[var(--clique-fg-secondary)]", children: "No UMRS roles assigned to this group." }) : /* @__PURE__ */ o(
            Ae,
            {
              value: l.grants,
              size: "small",
              stripedRows: !0,
              pt: d,
              emptyMessage: "No UMRS grants found.",
              children: [
                /* @__PURE__ */ t(X, { header: "Role", body: m }),
                /* @__PURE__ */ t(X, { header: "Resource Server", body: v }),
                /* @__PURE__ */ t(X, { header: "Source", body: u }),
                /* @__PURE__ */ t(X, { header: "Expires", body: i, style: { width: "8rem" } }),
                /* @__PURE__ */ t(X, { body: h, style: { width: "4rem" } })
              ]
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ t(
      Or,
      {
        visible: l.showAssignDialog,
        onHide: () => l.setShowAssignDialog(!1),
        assignTo: "group",
        preselectedGroupId: e,
        onAssigned: l.refetch,
        onSuccess: r,
        onError: a
      }
    ),
    /* @__PURE__ */ t(
      Ge,
      {
        visible: l.grantToRevoke !== null,
        onHide: () => l.setGrantToRevoke(null),
        onConfirm: l.handleRevoke,
        header: "Revoke UMRS Grant",
        message: `Are you sure you want to revoke the "${(g = l.grantToRevoke) == null ? void 0 : g.roleName}" role from this group?`,
        confirmLabel: "Revoke",
        confirmSeverity: "danger",
        loading: l.isRevoking
      }
    )
  ] });
}
function Pr({
  id: e,
  value: r,
  onChange: a,
  disabled: s,
  enabled: n = !0
}) {
  const { data: d, isLoading: l } = et(void 0, { enabled: n }), m = En(), [v, i] = U(!1), [u, h] = U(""), [g, p] = U(""), [f, c] = U(""), [y, b] = U(""), [q, C] = U(""), N = Ie(null), x = re(
    () => (d ?? []).map((E) => ({ label: E.name, value: E.id })),
    [d]
  ), w = L(() => {
    h(""), p(""), c(""), b(""), C("");
  }, []);
  ne(() => {
    v && (w(), setTimeout(() => {
      var E;
      return (E = N.current) == null ? void 0 : E.focus();
    }, 100));
  }, [v, w]);
  const I = L(() => {
    const E = u.trim();
    if (!E) {
      b("Name is required.");
      return;
    }
    if (E.length < 2) {
      b("Name must be at least 2 characters.");
      return;
    }
    b(""), C(""), m.mutate(
      {
        name: E,
        type: g.trim() || void 0,
        description: f.trim() || void 0
      },
      {
        onSuccess: (R) => {
          i(!1), a(R.id);
        },
        onError: (R) => {
          console.error("Failed to create namespace", R), C("Failed to create namespace. Please try again.");
        }
      }
    );
  }, [u, g, f, m, a]), S = m.isPending;
  return /* @__PURE__ */ o("div", { className: "flex gap-2", children: [
    /* @__PURE__ */ t("div", { className: "flex-1", children: /* @__PURE__ */ t(
      ge,
      {
        inputId: e,
        value: r,
        options: x,
        onChange: (E) => a(E.value ?? null),
        placeholder: "No namespace",
        className: "w-full",
        loading: l,
        filter: !0,
        showClear: !0,
        emptyMessage: "No namespaces available",
        disabled: s
      }
    ) }),
    /* @__PURE__ */ t(
      G,
      {
        type: "button",
        icon: "pi pi-plus",
        onClick: () => i(!0),
        severity: "secondary",
        outlined: !0,
        disabled: s,
        "aria-label": "Create namespace",
        tooltip: "Create namespace",
        tooltipOptions: { position: "top" }
      }
    ),
    /* @__PURE__ */ t(
      fe,
      {
        visible: v,
        onHide: () => i(!1),
        header: "Create Namespace",
        modal: !0,
        draggable: !1,
        resizable: !1,
        closable: !S,
        closeOnEscape: !S,
        style: { width: "28rem" },
        footer: /* @__PURE__ */ o("div", { className: "flex justify-end gap-3", children: [
          /* @__PURE__ */ t(
            G,
            {
              type: "button",
              label: "Cancel",
              onClick: () => i(!1),
              severity: "secondary",
              outlined: !0,
              disabled: S
            }
          ),
          /* @__PURE__ */ t(
            G,
            {
              type: "button",
              label: "Create",
              icon: "pi pi-check",
              onClick: I,
              raised: !0,
              loading: S
            }
          )
        ] }),
        children: /* @__PURE__ */ o("div", { className: "flex flex-col gap-4", children: [
          /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
            /* @__PURE__ */ o(
              "label",
              {
                htmlFor: "new-namespace-name",
                className: "text-sm font-semibold text-[var(--clique-fg)]",
                children: [
                  "Name ",
                  /* @__PURE__ */ t("span", { className: "text-[var(--clique-destructive)]", children: "*" })
                ]
              }
            ),
            /* @__PURE__ */ t(
              me,
              {
                id: "new-namespace-name",
                ref: N,
                value: u,
                onChange: (E) => {
                  h(E.target.value), b("");
                },
                placeholder: "e.g. My Namespace",
                className: `w-full ${y ? "p-invalid" : ""}`,
                "aria-invalid": !!y,
                "aria-describedby": y ? "new-namespace-name-error" : void 0,
                onKeyDown: (E) => {
                  E.key === "Enter" && I();
                }
              }
            ),
            y && /* @__PURE__ */ t(
              "small",
              {
                id: "new-namespace-name-error",
                className: "text-[var(--clique-destructive)] text-xs",
                children: y
              }
            )
          ] }),
          /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
            /* @__PURE__ */ t(
              "label",
              {
                htmlFor: "new-namespace-type",
                className: "text-sm font-semibold text-[var(--clique-fg)]",
                children: "Type"
              }
            ),
            /* @__PURE__ */ t(
              me,
              {
                id: "new-namespace-type",
                value: g,
                onChange: (E) => p(E.target.value),
                placeholder: "e.g. project, team, department",
                className: "w-full"
              }
            )
          ] }),
          /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
            /* @__PURE__ */ t(
              "label",
              {
                htmlFor: "new-namespace-description",
                className: "text-sm font-semibold text-[var(--clique-fg)]",
                children: "Description"
              }
            ),
            /* @__PURE__ */ t(
              _e,
              {
                id: "new-namespace-description",
                value: f,
                onChange: (E) => c(E.target.value),
                placeholder: "Optional description",
                className: "w-full",
                rows: 3,
                autoResize: !0
              }
            )
          ] }),
          q && /* @__PURE__ */ o("div", { className: "text-[var(--clique-destructive-strong)] text-sm bg-[var(--clique-destructive-subtle)] border border-[var(--clique-destructive-border)] rounded-lg p-3", children: [
            /* @__PURE__ */ t("i", { "aria-hidden": "true", className: "pi pi-exclamation-circle mr-2" }),
            q
          ] })
        ] })
      }
    )
  ] });
}
function Zn({
  visible: e,
  onHide: r,
  groupId: a,
  onDeleted: s,
  onSuccess: n,
  onError: d,
  renderInviteTemplateSelector: l,
  className: m,
  style: v,
  pt: i
}) {
  var y, b, q, C, N;
  const u = $t({
    groupId: a,
    onDeleted: () => {
      setTimeout(() => {
        r(), s == null || s();
      }, 1e3);
    },
    onSuccess: n,
    onError: d
  }), h = u.labels, g = !u.isSaving && !u.isDeleting, { data: p } = et(void 0, {
    enabled: u.editing || ((y = u.group) == null ? void 0 : y.namespaceId) != null
  }), f = ((b = p == null ? void 0 : p.find((x) => {
    var w;
    return x.id === ((w = u.group) == null ? void 0 : w.namespaceId);
  })) == null ? void 0 : b.name) ?? null, c = L(() => {
    g && r();
  }, [g, r]);
  return /* @__PURE__ */ o(Ce, { children: [
    /* @__PURE__ */ o(
      fe,
      {
        header: ((q = u.group) == null ? void 0 : q.name) || `${h.singularTitle} Details`,
        visible: e,
        onHide: c,
        closable: g,
        closeOnEscape: g,
        maximizable: !0,
        className: m,
        style: { width: "900px", ...v },
        pt: i,
        breakpoints: { "960px": "95vw" },
        children: [
          u.isLoading && /* @__PURE__ */ t(xe, { message: "Loading group..." }),
          u.isError && /* @__PURE__ */ t(
            he,
            {
              error: u.error,
              resourceLabel: h.singular,
              onRetry: () => u.refetch()
            }
          ),
          !u.isLoading && !u.isError && u.group && /* @__PURE__ */ o("div", { children: [
            /* @__PURE__ */ o("div", { className: "flex items-center justify-between mb-6", children: [
              /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: u.group.isPrivileged && /* @__PURE__ */ t(ce, { value: "Privileged", severity: "warning", icon: "pi pi-star" }) }),
              /* @__PURE__ */ t("div", { className: "flex gap-2", children: u.editing ? /* @__PURE__ */ o(Ce, { children: [
                /* @__PURE__ */ t(
                  G,
                  {
                    type: "button",
                    label: "Cancel",
                    icon: "pi pi-times",
                    onClick: u.cancelEditing,
                    severity: "secondary",
                    outlined: !0,
                    size: "small",
                    disabled: u.isSaving
                  }
                ),
                /* @__PURE__ */ t(
                  G,
                  {
                    type: "button",
                    label: "Save",
                    icon: "pi pi-check",
                    onClick: u.handleSave,
                    raised: !0,
                    size: "small",
                    loading: u.isSaving
                  }
                )
              ] }) : /* @__PURE__ */ o(Ce, { children: [
                /* @__PURE__ */ t(
                  G,
                  {
                    type: "button",
                    label: "Edit",
                    icon: "pi pi-pencil",
                    onClick: u.startEditing,
                    severity: "secondary",
                    outlined: !0,
                    size: "small"
                  }
                ),
                /* @__PURE__ */ t(
                  G,
                  {
                    type: "button",
                    label: "Delete",
                    icon: "pi pi-trash",
                    onClick: () => u.setShowDeleteConfirm(!0),
                    severity: "danger",
                    outlined: !0,
                    size: "small"
                  }
                )
              ] }) })
            ] }),
            /* @__PURE__ */ o(
              "div",
              {
                className: "rounded-lg border border-[var(--clique-border)] p-6 mb-6",
                style: { backgroundColor: "var(--clique-bg)" },
                children: [
                  /* @__PURE__ */ o("h3", { className: "text-lg font-medium text-[var(--clique-fg)] mb-4", children: [
                    h.singularTitle,
                    " Info"
                  ] }),
                  u.editing ? /* @__PURE__ */ o("div", { className: "flex flex-col gap-4", children: [
                    /* @__PURE__ */ o("div", { children: [
                      /* @__PURE__ */ o(
                        "label",
                        {
                          htmlFor: "dialog-edit-group-name",
                          className: "block text-sm font-medium text-[var(--clique-fg)] mb-1",
                          children: [
                            "Name ",
                            /* @__PURE__ */ t("span", { className: "text-[var(--clique-destructive)]", children: "*" })
                          ]
                        }
                      ),
                      /* @__PURE__ */ t(
                        me,
                        {
                          id: "dialog-edit-group-name",
                          value: u.form.name,
                          onChange: (x) => u.updateField("name", x.target.value),
                          className: `w-full ${u.nameError ? "p-invalid" : ""}`,
                          "aria-invalid": !!u.nameError,
                          "aria-describedby": u.nameError ? "dialog-edit-name-error" : void 0
                        }
                      ),
                      u.nameError && /* @__PURE__ */ t(
                        "small",
                        {
                          id: "dialog-edit-name-error",
                          className: "text-[var(--clique-destructive)] mt-1 block",
                          children: u.nameError
                        }
                      )
                    ] }),
                    /* @__PURE__ */ o("div", { children: [
                      /* @__PURE__ */ t(
                        "label",
                        {
                          htmlFor: "dialog-edit-group-description",
                          className: "block text-sm font-medium text-[var(--clique-fg)] mb-1",
                          children: "Description"
                        }
                      ),
                      /* @__PURE__ */ t(
                        _e,
                        {
                          id: "dialog-edit-group-description",
                          value: u.form.description,
                          onChange: (x) => u.updateField("description", x.target.value),
                          className: "w-full",
                          rows: 3,
                          autoResize: !0
                        }
                      )
                    ] }),
                    /* @__PURE__ */ o("div", { children: [
                      /* @__PURE__ */ t(
                        "label",
                        {
                          htmlFor: "dialog-edit-group-namespace",
                          className: "block text-sm font-medium text-[var(--clique-fg)] mb-1",
                          children: "Namespace"
                        }
                      ),
                      /* @__PURE__ */ t(
                        Pr,
                        {
                          id: "dialog-edit-group-namespace",
                          value: u.form.namespaceId,
                          onChange: (x) => u.updateField("namespaceId", x),
                          disabled: u.namespaceLocked
                        }
                      )
                    ] }),
                    /* @__PURE__ */ o("div", { className: "flex items-center gap-2", children: [
                      /* @__PURE__ */ t(
                        Ye,
                        {
                          inputId: "dialog-edit-group-extension",
                          checked: u.form.allowExtensionRequest,
                          onChange: (x) => u.updateField("allowExtensionRequest", x.checked ?? !1)
                        }
                      ),
                      /* @__PURE__ */ t(
                        "label",
                        {
                          htmlFor: "dialog-edit-group-extension",
                          className: "text-sm text-[var(--clique-fg)] cursor-pointer",
                          children: "Allow extension requests"
                        }
                      )
                    ] }),
                    /* @__PURE__ */ o("div", { className: "flex items-center gap-2", children: [
                      /* @__PURE__ */ t(
                        Ye,
                        {
                          inputId: "dialog-edit-group-invite",
                          checked: u.form.allowInvites,
                          onChange: (x) => u.updateField("allowInvites", x.checked ?? !1),
                          disabled: u.group.isPrivileged
                        }
                      ),
                      /* @__PURE__ */ t(
                        "label",
                        {
                          htmlFor: "dialog-edit-group-invite",
                          className: "text-sm text-[var(--clique-fg)] cursor-pointer",
                          children: "Allow inviting users"
                        }
                      )
                    ] }),
                    u.form.allowInvites && !u.group.isPrivileged && l && /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5 pl-7", children: [
                      /* @__PURE__ */ t("label", { className: "text-sm font-medium text-[var(--clique-fg)]", children: "Invitation email template" }),
                      /* @__PURE__ */ t("p", { className: "text-xs text-[var(--clique-fg-secondary)]", children: "Choose a custom email sent to invited users, or leave empty to use the default." }),
                      l({
                        value: u.form.invitationEmailTemplateId,
                        onChange: (x) => u.updateField("invitationEmailTemplateId", x),
                        disabled: u.isSaving
                      })
                    ] })
                  ] }) : /* @__PURE__ */ o("dl", { className: "grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-3 text-sm", children: [
                    /* @__PURE__ */ o("div", { children: [
                      /* @__PURE__ */ t("dt", { className: "text-[var(--clique-fg-secondary)]", children: "ID" }),
                      /* @__PURE__ */ t("dd", { className: "text-[var(--clique-fg)] font-medium", children: u.group.id })
                    ] }),
                    /* @__PURE__ */ o("div", { children: [
                      /* @__PURE__ */ t("dt", { className: "text-[var(--clique-fg-secondary)]", children: "Name" }),
                      /* @__PURE__ */ t("dd", { className: "text-[var(--clique-fg)] font-medium", children: u.group.name })
                    ] }),
                    /* @__PURE__ */ o("div", { children: [
                      /* @__PURE__ */ t("dt", { className: "text-[var(--clique-fg-secondary)]", children: "Description" }),
                      /* @__PURE__ */ t("dd", { className: "text-[var(--clique-fg)] font-medium", children: u.group.description || "—" })
                    ] }),
                    /* @__PURE__ */ o("div", { children: [
                      /* @__PURE__ */ t("dt", { className: "text-[var(--clique-fg-secondary)]", children: "Privileged" }),
                      /* @__PURE__ */ t("dd", { className: "text-[var(--clique-fg)] font-medium", children: u.group.isPrivileged ? "Yes" : "No" })
                    ] }),
                    /* @__PURE__ */ o("div", { children: [
                      /* @__PURE__ */ t("dt", { className: "text-[var(--clique-fg-secondary)]", children: "Allow Extension Request" }),
                      /* @__PURE__ */ t("dd", { className: "text-[var(--clique-fg)] font-medium", children: u.group.allowExtensionRequest ? "Yes" : "No" })
                    ] }),
                    /* @__PURE__ */ o("div", { children: [
                      /* @__PURE__ */ t("dt", { className: "text-[var(--clique-fg-secondary)]", children: "Allow Inviting Users" }),
                      /* @__PURE__ */ t("dd", { className: "text-[var(--clique-fg)] font-medium", children: u.hasRequestableAccess ? "Yes" : "No" })
                    ] }),
                    /* @__PURE__ */ o("div", { children: [
                      /* @__PURE__ */ t("dt", { className: "text-[var(--clique-fg-secondary)]", children: "Namespace" }),
                      /* @__PURE__ */ t("dd", { className: "text-[var(--clique-fg)] font-medium", children: f || "—" })
                    ] }),
                    /* @__PURE__ */ o("div", { children: [
                      /* @__PURE__ */ t("dt", { className: "text-[var(--clique-fg-secondary)]", children: "Tenant ID" }),
                      /* @__PURE__ */ t("dd", { className: "text-[var(--clique-fg)] font-medium", children: u.group.tenantId })
                    ] })
                  ] })
                ]
              }
            ),
            /* @__PURE__ */ t(
              Ot,
              {
                groupId: a,
                namespaceId: (C = u.group) == null ? void 0 : C.namespaceId,
                onSuccess: n,
                onError: d
              }
            ),
            /* @__PURE__ */ t(zt, { groupId: a, onSuccess: n, onError: d }),
            /* @__PURE__ */ t(Kt, { groupId: a, onSuccess: n, onError: d })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ t(
      Ge,
      {
        visible: u.showDeleteConfirm,
        onHide: () => u.setShowDeleteConfirm(!1),
        onConfirm: u.handleDelete,
        header: `Delete ${h.singularTitle}`,
        message: `Are you sure you want to delete "${(N = u.group) == null ? void 0 : N.name}"? This action cannot be undone.`,
        confirmLabel: "Delete",
        confirmIcon: "pi pi-trash",
        confirmSeverity: "danger",
        loading: u.isDeleting
      }
    )
  ] });
}
function ei(e) {
  const {
    pageSize: r = 12,
    includeMemberCount: a = !0,
    useDialog: s = !1,
    onGroupSelect: n,
    namespaceId: d
  } = e ?? {}, l = je(d), [m, v] = U(""), [i, u] = U(0), [h, g] = U(null), p = re(() => Vr(["name", "description"], m), [m]), f = re(
    () => Nt(p, l),
    [p, l]
  );
  ne(() => {
    u(0), g(null);
  }, [l]);
  const c = re(
    () => ({
      where: f,
      limit: r,
      offset: i * r,
      order: "name ASC",
      include: a ? [{ relation: "users" }] : void 0
    }),
    [f, r, i, a]
  ), { canList: y, canCreate: b } = Ze("groups"), {
    data: q,
    isLoading: C,
    isPlaceholderData: N,
    isError: x,
    error: w,
    refetch: I
  } = dr(c, {
    enabled: y
  }), {
    data: S,
    isLoading: E,
    isPlaceholderData: R,
    isError: P,
    error: _,
    refetch: A
  } = Et(f, { enabled: y }), k = qr(l, N), T = qr(l, R), D = k ? void 0 : q, K = T ? void 0 : S, M = C || k, ee = L((Y) => {
    v(Y), u(0);
  }, []), Q = L(
    (Y) => {
      s ? g(Y.id) : n == null || n(Y);
    },
    [s, n]
  ), j = L(() => {
    Promise.all([I(), A()]);
  }, [I, A]), { group: $ } = Re(), ie = (M || E || T) && !D, O = (D == null ? void 0 : D.length) === 0 && !m, ae = (D == null ? void 0 : D.length) === 0 && !!m;
  return {
    groups: D,
    totalCount: K,
    search: m,
    setSearch: ee,
    page: i,
    setPage: u,
    pageSize: r,
    isInitialLoad: ie,
    isLoading: M,
    isError: x || P,
    error: w ?? _,
    isEmpty: O,
    isEmptySearch: ae,
    selectedGroupId: h,
    setSelectedGroupId: g,
    handleCardClick: Q,
    refetch: j,
    filter: c,
    labels: $,
    canList: y,
    canCreate: b
  };
}
function Ll({
  onGroupSelect: e,
  onCreateGroup: r,
  pageSize: a = 12,
  namespaceId: s,
  includeMemberCount: n = !0,
  useDialog: d = !1,
  onSuccess: l,
  onError: m,
  renderInviteTemplateSelector: v,
  className: i,
  style: u,
  pt: h
}) {
  const g = ei({
    pageSize: a,
    includeMemberCount: n,
    useDialog: d,
    onGroupSelect: e,
    namespaceId: s
  }), {
    groups: p,
    totalCount: f,
    search: c,
    setSearch: y,
    page: b,
    setPage: q,
    pageSize: C,
    isInitialLoad: N,
    isError: x,
    error: w,
    isEmpty: I,
    isEmptySearch: S,
    selectedGroupId: E,
    setSelectedGroupId: R,
    handleCardClick: P,
    refetch: _,
    labels: A,
    canList: k,
    canCreate: T
  } = g, D = (M) => {
    q(M.page);
  }, K = () => k ? N ? /* @__PURE__ */ t(xe, { message: `Loading ${A.plural}...` }) : x ? /* @__PURE__ */ t(he, { error: w, resourceLabel: A.plural, onRetry: _ }) : I ? /* @__PURE__ */ t(
    Je,
    {
      icon: "pi pi-users",
      title: `No ${A.plural} yet`,
      message: `Create ${A.withArticle} to start organizing users.`,
      actionLabel: r && T ? `Create ${A.singularTitle}` : void 0,
      onAction: T ? r : void 0
    }
  ) : S ? /* @__PURE__ */ t(
    Je,
    {
      icon: "pi pi-search",
      title: `No ${A.plural} found`,
      message: `No ${A.plural} match "${c}"`
    }
  ) : /* @__PURE__ */ o(Ce, { children: [
    /* @__PURE__ */ t("div", { className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6", children: p == null ? void 0 : p.map((M) => {
      var Q;
      const ee = ((Q = M == null ? void 0 : M.users) == null ? void 0 : Q.length) ?? 0;
      return /* @__PURE__ */ o(
        "div",
        {
          onClick: () => P(M),
          className: "group relative rounded-2xl shadow-[var(--clique-shadow)] hover:shadow-[var(--clique-shadow-lg)] border border-[var(--clique-border)] hover:border-[var(--clique-primary)] transition-all duration-300 cursor-pointer overflow-hidden",
          style: { backgroundColor: "var(--clique-bg)", minHeight: "200px" },
          children: [
            /* @__PURE__ */ t(
              "div",
              {
                className: "absolute top-0 left-0 right-0 h-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300",
                style: {
                  background: "linear-gradient(to right, var(--clique-gradient-from), var(--clique-gradient-to))"
                }
              }
            ),
            /* @__PURE__ */ o("div", { className: "p-6 flex flex-col h-full", children: [
              /* @__PURE__ */ o("div", { className: "flex items-start gap-3 mb-4", children: [
                /* @__PURE__ */ o("div", { className: "flex-1 min-w-0", children: [
                  /* @__PURE__ */ t("h3", { className: "text-xl font-bold text-[var(--clique-fg)] mb-1 truncate group-hover:text-[var(--clique-primary)] transition-colors", children: M.name }),
                  M.isPrivileged && /* @__PURE__ */ o("span", { className: "inline-flex items-center gap-1 px-2 py-1 bg-[var(--clique-accent-subtle)] text-[var(--clique-accent-strong)] text-xs font-medium rounded-full", children: [
                    /* @__PURE__ */ t("i", { className: "pi pi-shield", style: { fontSize: "10px" } }),
                    "Privileged"
                  ] })
                ] }),
                /* @__PURE__ */ t("div", { className: "flex-shrink-0 w-12 h-12 bg-[var(--clique-primary-subtle)] rounded-xl flex items-center justify-center transition-colors", children: /* @__PURE__ */ t("i", { className: "pi pi-users text-[var(--clique-primary)] text-xl" }) })
              ] }),
              /* @__PURE__ */ t("div", { className: "flex-1 mb-4", children: M.description ? /* @__PURE__ */ t("p", { className: "text-sm text-[var(--clique-fg-muted)] leading-relaxed line-clamp-3", children: M.description }) : /* @__PURE__ */ t("p", { className: "text-sm text-[var(--clique-fg-tertiary)] italic", children: "No description available" }) }),
              /* @__PURE__ */ o("div", { className: "flex items-center justify-between pt-4 border-t-2 border-[var(--clique-border-subtle)]", children: [
                /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ o("div", { className: "px-3 py-1.5 bg-[var(--clique-primary-subtle)] rounded-lg", children: [
                  /* @__PURE__ */ t("span", { className: "text-xs font-medium text-[var(--clique-fg-secondary)]", children: "Members" }),
                  /* @__PURE__ */ t("p", { className: "text-lg font-bold text-[var(--clique-primary)]", children: ee })
                ] }) }),
                /* @__PURE__ */ o(
                  "button",
                  {
                    type: "button",
                    className: "flex items-center gap-1 text-sm font-medium text-[var(--clique-fg-tertiary)] group-hover:text-[var(--clique-primary)] transition-colors",
                    onClick: (j) => {
                      j.stopPropagation(), P(M);
                    },
                    children: [
                      "View",
                      /* @__PURE__ */ t("i", { className: "pi pi-arrow-right text-xs group-hover:translate-x-1 transition-transform" })
                    ]
                  }
                )
              ] })
            ] })
          ]
        },
        M.id
      );
    }) }),
    f !== void 0 && f > C && /* @__PURE__ */ t("div", { className: "mt-8", children: /* @__PURE__ */ t(
      Ns,
      {
        first: b * C,
        rows: C,
        totalRecords: f,
        onPageChange: D,
        template: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport",
        currentPageReportTemplate: `Showing {first} to {last} of {totalRecords} ${A.plural}`,
        pt: h
      }
    ) })
  ] }) : /* @__PURE__ */ t(ur, { resourceLabel: A.plural });
  return /* @__PURE__ */ o("div", { className: be(i), style: u, children: [
    /* @__PURE__ */ o("div", { className: "flex items-center justify-between gap-4 mb-6", children: [
      /* @__PURE__ */ t("div", { className: "flex-1 max-w-md", children: /* @__PURE__ */ t(
        cr,
        {
          value: c,
          onChange: y,
          placeholder: `Search ${A.plural}...`
        }
      ) }),
      r && /* @__PURE__ */ t(
        G,
        {
          type: "button",
          label: `Create ${A.singularTitle}`,
          icon: "pi pi-plus",
          onClick: T ? r : void 0,
          severity: "success",
          ...mr(T, A.plural)
        }
      )
    ] }),
    K(),
    d && E !== null && /* @__PURE__ */ t(
      Zn,
      {
        visible: !0,
        onHide: () => R(null),
        groupId: E,
        onDeleted: () => {
          R(null), _();
        },
        onSuccess: l,
        onError: m,
        renderInviteTemplateSelector: v
      }
    )
  ] });
}
function He(e) {
  const [r, a] = U(e), [s, n] = U({}), [d, l] = U(""), m = L((p) => {
    n((f) => {
      if (!f[p]) return f;
      const c = { ...f };
      return delete c[p], c;
    });
  }, []), v = L(
    (p, f) => {
      a((c) => {
        const y = { ...c };
        return y[p] = f, y;
      }), m(p);
    },
    [m]
  ), i = L((p, f) => {
    n((c) => {
      const y = { ...c };
      return y[p] = f, y;
    });
  }, []), u = L(() => n({}), []), h = L(() => {
    a(e), n({}), l("");
  }, [e]), g = L((p) => {
    a(p), n({}), l("");
  }, []);
  return {
    form: r,
    setForm: a,
    updateField: v,
    errors: s,
    setFieldError: i,
    clearError: m,
    clearErrors: u,
    submitError: d,
    setSubmitError: l,
    reset: h,
    hydrate: g
  };
}
function Ee(e, r) {
  return e.trim().length > 0 ? void 0 : `${r} is required.`;
}
function Fe(e, r, a) {
  return e.trim().length >= r ? void 0 : `${a} must be at least ${r} characters.`;
}
const ri = {
  name: "",
  description: "",
  allowExtensionRequest: !1,
  enableSelfRequests: !1,
  namespaceId: null
};
function ti(e) {
  const { onCreated: r, onError: a, onDismiss: s } = e ?? {}, n = je(), d = re(
    () => ({ ...ri, namespaceId: n ?? null }),
    [n]
  ), {
    form: l,
    updateField: m,
    errors: v,
    setFieldError: i,
    clearErrors: u,
    submitError: h,
    setSubmitError: g,
    reset: p
  } = He(d), f = $s(), { group: c } = Re(), y = L(() => {
    const b = l.name.trim(), q = Ee(b, "Name") ?? Fe(b, 2, "Name");
    if (q) {
      i("name", q);
      return;
    }
    u(), g(""), f.mutate(
      {
        name: b,
        description: l.description.trim() || void 0,
        allowExtensionRequest: l.allowExtensionRequest,
        enableSelfRequests: l.enableSelfRequests,
        namespaceId: l.namespaceId
      },
      {
        onSuccess: (C) => {
          r == null || r(C), s == null || s();
        },
        onError: (C) => {
          console.error("Failed to create group", C);
          const N = Xe(C) !== 403 ? `Failed to create ${c.singular}. Please try again.` : ir({ message: lr(C) });
          g(N), a == null || a(N);
        }
      }
    );
  }, [
    l,
    f,
    r,
    s,
    a,
    c.singular,
    i,
    u,
    g
  ]);
  return {
    form: l,
    updateField: m,
    nameError: v.name ?? "",
    submitError: h,
    resetForm: p,
    handleSubmit: y,
    isPending: f.isPending,
    labels: c,
    namespaceLocked: n != null
  };
}
function Tl({
  visible: e,
  onHide: r,
  onCreated: a,
  className: s,
  style: n,
  pt: d
}) {
  const l = Ie(null), m = ti({
    onCreated: a,
    onDismiss: r
  }), {
    form: v,
    updateField: i,
    nameError: u,
    submitError: h,
    resetForm: g,
    handleSubmit: p,
    isPending: f,
    labels: c,
    namespaceLocked: y
  } = m;
  return ne(() => {
    e && (g(), setTimeout(() => {
      var b;
      return (b = l.current) == null ? void 0 : b.focus();
    }, 100));
  }, [e, g]), /* @__PURE__ */ t(
    fe,
    {
      visible: e,
      onHide: r,
      header: `Create ${c.singularTitle}`,
      modal: !0,
      draggable: !1,
      resizable: !1,
      closable: !f,
      closeOnEscape: !f,
      className: s,
      style: { width: "32rem", ...n },
      pt: d,
      footer: /* @__PURE__ */ o("div", { className: "flex justify-end gap-3", children: [
        /* @__PURE__ */ t(
          G,
          {
            type: "button",
            label: "Cancel",
            onClick: r,
            severity: "secondary",
            outlined: !0,
            disabled: f
          }
        ),
        /* @__PURE__ */ t(
          G,
          {
            type: "button",
            label: "Create",
            icon: "pi pi-check",
            onClick: p,
            raised: !0,
            loading: f
          }
        )
      ] }),
      children: /* @__PURE__ */ o("div", { className: "flex flex-col gap-6", children: [
        /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
          /* @__PURE__ */ o("label", { htmlFor: "group-name", className: "text-sm font-semibold text-[var(--clique-fg)]", children: [
            "Name ",
            /* @__PURE__ */ t("span", { className: "text-[var(--clique-destructive)]", children: "*" })
          ] }),
          /* @__PURE__ */ t(
            me,
            {
              id: "group-name",
              ref: l,
              value: v.name,
              onChange: (b) => i("name", b.target.value),
              placeholder: `Enter ${c.singular} name`,
              className: `w-full ${u ? "p-invalid" : ""}`,
              "aria-invalid": !!u,
              "aria-describedby": u ? "group-name-error" : void 0
            }
          ),
          u && /* @__PURE__ */ t("small", { id: "group-name-error", className: "text-[var(--clique-destructive)] text-xs", children: u })
        ] }),
        /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
          /* @__PURE__ */ t(
            "label",
            {
              htmlFor: "group-description",
              className: "text-sm font-semibold text-[var(--clique-fg)]",
              children: "Description"
            }
          ),
          /* @__PURE__ */ t(
            _e,
            {
              id: "group-description",
              value: v.description,
              onChange: (b) => i("description", b.target.value),
              placeholder: "Optional description",
              className: "w-full",
              rows: 3,
              autoResize: !0
            }
          )
        ] }),
        /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
          /* @__PURE__ */ t(
            "label",
            {
              htmlFor: "group-namespace",
              className: "text-sm font-semibold text-[var(--clique-fg)]",
              children: "Namespace"
            }
          ),
          /* @__PURE__ */ t(
            Pr,
            {
              id: "group-namespace",
              value: v.namespaceId,
              onChange: (b) => i("namespaceId", b),
              disabled: y,
              enabled: e
            }
          )
        ] }),
        /* @__PURE__ */ o("fieldset", { className: "border-t border-[var(--clique-border)] pt-5 flex flex-col gap-4", children: [
          /* @__PURE__ */ t("legend", { className: "text-sm font-semibold text-[var(--clique-fg)] pr-2", children: "Options" }),
          /* @__PURE__ */ o("div", { className: "flex items-center gap-3", children: [
            /* @__PURE__ */ t(
              Ye,
              {
                inputId: "group-extension",
                checked: v.allowExtensionRequest,
                onChange: (b) => i("allowExtensionRequest", b.checked ?? !1)
              }
            ),
            /* @__PURE__ */ t(
              "label",
              {
                htmlFor: "group-extension",
                className: "text-sm text-[var(--clique-fg)] cursor-pointer",
                children: "Allow extension requests"
              }
            )
          ] }),
          /* @__PURE__ */ o("div", { className: "flex items-center gap-3", children: [
            /* @__PURE__ */ t(
              Ye,
              {
                inputId: "group-invite",
                checked: v.enableSelfRequests,
                onChange: (b) => i("enableSelfRequests", b.checked ?? !1)
              }
            ),
            /* @__PURE__ */ t(
              "label",
              {
                htmlFor: "group-invite",
                className: "text-sm text-[var(--clique-fg)] cursor-pointer",
                children: "Allow inviting users"
              }
            )
          ] })
        ] }),
        h && /* @__PURE__ */ o("div", { className: "text-[var(--clique-destructive-strong)] text-sm bg-[var(--clique-destructive-subtle)] border border-[var(--clique-destructive-border)] rounded-lg p-3", children: [
          /* @__PURE__ */ t("i", { "aria-hidden": "true", className: "pi pi-exclamation-circle mr-2" }),
          h
        ] })
      ] })
    }
  );
}
function kl({
  group: e,
  onDeleted: r,
  onUpdated: a,
  onBack: s,
  onError: n,
  onSuccess: d,
  renderInviteTemplateSelector: l,
  className: m,
  style: v
}) {
  var f;
  const i = $t({
    group: e,
    onUpdated: a,
    onDeleted: r,
    onSuccess: d,
    onError: n
  }), u = i.group ?? e, { labels: h } = i, { data: g } = et(void 0, {
    enabled: i.editing || u.namespaceId != null
  }), p = ((f = g == null ? void 0 : g.find((c) => c.id === u.namespaceId)) == null ? void 0 : f.name) ?? null;
  return /* @__PURE__ */ o("div", { className: be(m), style: v, children: [
    /* @__PURE__ */ o("div", { className: "flex items-center gap-3 mb-6", children: [
      s && /* @__PURE__ */ t(
        G,
        {
          type: "button",
          icon: "pi pi-arrow-left",
          onClick: s,
          text: !0,
          rounded: !0,
          severity: "secondary",
          "aria-label": `Back to ${h.plural}`
        }
      ),
      /* @__PURE__ */ o("div", { className: "flex-1", children: [
        /* @__PURE__ */ o("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ t("h2", { className: "text-2xl font-semibold text-[var(--clique-fg)]", children: u.name }),
          u.isPrivileged && /* @__PURE__ */ t(ce, { value: "Privileged", severity: "warning", icon: "pi pi-star" })
        ] }),
        u.description && /* @__PURE__ */ t("p", { className: "text-[var(--clique-fg-secondary)] text-sm mt-1", children: u.description })
      ] }),
      /* @__PURE__ */ t("div", { className: "flex gap-3", children: i.editing ? /* @__PURE__ */ o(Ce, { children: [
        /* @__PURE__ */ t(
          G,
          {
            type: "button",
            label: "Cancel",
            icon: "pi pi-times",
            onClick: i.cancelEditing,
            severity: "secondary",
            outlined: !0,
            size: "small",
            disabled: i.isSaving
          }
        ),
        /* @__PURE__ */ t(
          G,
          {
            type: "button",
            label: "Save",
            icon: "pi pi-check",
            onClick: i.handleSave,
            raised: !0,
            size: "small",
            loading: i.isSaving
          }
        )
      ] }) : /* @__PURE__ */ o(Ce, { children: [
        /* @__PURE__ */ t(
          G,
          {
            type: "button",
            label: "Edit",
            icon: "pi pi-pencil",
            onClick: i.startEditing,
            severity: "secondary",
            outlined: !0,
            size: "small"
          }
        ),
        /* @__PURE__ */ t(
          G,
          {
            type: "button",
            label: "Delete",
            icon: "pi pi-trash",
            onClick: () => i.setShowDeleteConfirm(!0),
            severity: "danger",
            outlined: !0,
            size: "small"
          }
        )
      ] }) })
    ] }),
    /* @__PURE__ */ o(
      "div",
      {
        className: "rounded-lg border border-[var(--clique-border)] p-6",
        style: { backgroundColor: "var(--clique-bg)" },
        children: [
          /* @__PURE__ */ o("h3", { className: "text-lg font-medium text-[var(--clique-fg)] mb-4", children: [
            h.singularTitle,
            " Info"
          ] }),
          i.editing ? /* @__PURE__ */ o("div", { className: "flex flex-col gap-4", children: [
            /* @__PURE__ */ o("div", { children: [
              /* @__PURE__ */ o(
                "label",
                {
                  htmlFor: "edit-group-name",
                  className: "block text-sm font-medium text-[var(--clique-fg)] mb-1",
                  children: [
                    "Name ",
                    /* @__PURE__ */ t("span", { className: "text-[var(--clique-destructive)]", children: "*" })
                  ]
                }
              ),
              /* @__PURE__ */ t(
                me,
                {
                  id: "edit-group-name",
                  value: i.form.name,
                  onChange: (c) => i.updateField("name", c.target.value),
                  className: `w-full ${i.nameError ? "p-invalid" : ""}`,
                  "aria-invalid": !!i.nameError,
                  "aria-describedby": i.nameError ? "edit-name-error" : void 0
                }
              ),
              i.nameError && /* @__PURE__ */ t("small", { id: "edit-name-error", className: "text-[var(--clique-destructive)] mt-1 block", children: i.nameError })
            ] }),
            /* @__PURE__ */ o("div", { children: [
              /* @__PURE__ */ t(
                "label",
                {
                  htmlFor: "edit-group-description",
                  className: "block text-sm font-medium text-[var(--clique-fg)] mb-1",
                  children: "Description"
                }
              ),
              /* @__PURE__ */ t(
                _e,
                {
                  id: "edit-group-description",
                  value: i.form.description,
                  onChange: (c) => i.updateField("description", c.target.value),
                  className: "w-full",
                  rows: 3,
                  autoResize: !0
                }
              )
            ] }),
            /* @__PURE__ */ o("div", { children: [
              /* @__PURE__ */ t(
                "label",
                {
                  htmlFor: "edit-group-namespace",
                  className: "block text-sm font-medium text-[var(--clique-fg)] mb-1",
                  children: "Namespace"
                }
              ),
              /* @__PURE__ */ t(
                Pr,
                {
                  id: "edit-group-namespace",
                  value: i.form.namespaceId,
                  onChange: (c) => i.updateField("namespaceId", c),
                  disabled: i.namespaceLocked
                }
              )
            ] }),
            /* @__PURE__ */ o("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ t(
                Ye,
                {
                  inputId: "edit-group-extension",
                  checked: i.form.allowExtensionRequest,
                  onChange: (c) => i.updateField("allowExtensionRequest", c.checked ?? !1)
                }
              ),
              /* @__PURE__ */ t(
                "label",
                {
                  htmlFor: "edit-group-extension",
                  className: "text-sm text-[var(--clique-fg)] cursor-pointer",
                  children: "Allow extension requests"
                }
              )
            ] }),
            /* @__PURE__ */ o("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ t(
                Ye,
                {
                  inputId: "edit-group-invite",
                  checked: i.form.allowInvites,
                  onChange: (c) => i.updateField("allowInvites", c.checked ?? !1),
                  disabled: u.isPrivileged
                }
              ),
              /* @__PURE__ */ t(
                "label",
                {
                  htmlFor: "edit-group-invite",
                  className: "text-sm text-[var(--clique-fg)] cursor-pointer",
                  children: "Allow inviting users"
                }
              )
            ] }),
            i.form.allowInvites && !u.isPrivileged && l && /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5 pl-7", children: [
              /* @__PURE__ */ t("label", { className: "text-sm font-medium text-[var(--clique-fg)]", children: "Invitation email template" }),
              /* @__PURE__ */ t("p", { className: "text-xs text-[var(--clique-fg-secondary)]", children: "Choose a custom email sent to invited users, or leave empty to use the default." }),
              l({
                value: i.form.invitationEmailTemplateId,
                onChange: (c) => i.updateField("invitationEmailTemplateId", c),
                disabled: i.isSaving
              })
            ] })
          ] }) : /* @__PURE__ */ o("dl", { className: "grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-3 text-sm", children: [
            /* @__PURE__ */ o("div", { children: [
              /* @__PURE__ */ t("dt", { className: "text-[var(--clique-fg-secondary)]", children: "ID" }),
              /* @__PURE__ */ t("dd", { className: "text-[var(--clique-fg)] font-medium", children: u.id })
            ] }),
            /* @__PURE__ */ o("div", { children: [
              /* @__PURE__ */ t("dt", { className: "text-[var(--clique-fg-secondary)]", children: "Name" }),
              /* @__PURE__ */ t("dd", { className: "text-[var(--clique-fg)] font-medium", children: u.name })
            ] }),
            /* @__PURE__ */ o("div", { children: [
              /* @__PURE__ */ t("dt", { className: "text-[var(--clique-fg-secondary)]", children: "Description" }),
              /* @__PURE__ */ t("dd", { className: "text-[var(--clique-fg)] font-medium", children: u.description || "—" })
            ] }),
            /* @__PURE__ */ o("div", { children: [
              /* @__PURE__ */ t("dt", { className: "text-[var(--clique-fg-secondary)]", children: "Privileged" }),
              /* @__PURE__ */ t("dd", { className: "text-[var(--clique-fg)] font-medium", children: u.isPrivileged ? "Yes" : "No" })
            ] }),
            /* @__PURE__ */ o("div", { children: [
              /* @__PURE__ */ t("dt", { className: "text-[var(--clique-fg-secondary)]", children: "Allow Extension Request" }),
              /* @__PURE__ */ t("dd", { className: "text-[var(--clique-fg)] font-medium", children: u.allowExtensionRequest ? "Yes" : "No" })
            ] }),
            /* @__PURE__ */ o("div", { children: [
              /* @__PURE__ */ t("dt", { className: "text-[var(--clique-fg-secondary)]", children: "Allow Inviting Users" }),
              /* @__PURE__ */ t("dd", { className: "text-[var(--clique-fg)] font-medium", children: i.hasRequestableAccess ? "Yes" : "No" })
            ] }),
            /* @__PURE__ */ o("div", { children: [
              /* @__PURE__ */ t("dt", { className: "text-[var(--clique-fg-secondary)]", children: "Namespace" }),
              /* @__PURE__ */ t("dd", { className: "text-[var(--clique-fg)] font-medium", children: p || "—" })
            ] }),
            /* @__PURE__ */ o("div", { children: [
              /* @__PURE__ */ t("dt", { className: "text-[var(--clique-fg-secondary)]", children: "Tenant ID" }),
              /* @__PURE__ */ t("dd", { className: "text-[var(--clique-fg)] font-medium", children: u.tenantId })
            ] })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ t(
      Ot,
      {
        groupId: u.id,
        namespaceId: u.namespaceId,
        onSuccess: d,
        onError: n
      }
    ),
    /* @__PURE__ */ t(zt, { groupId: u.id, onSuccess: d, onError: n }),
    /* @__PURE__ */ t(Kt, { groupId: u.id, onSuccess: d, onError: n }),
    /* @__PURE__ */ t(
      Ge,
      {
        visible: i.showDeleteConfirm,
        onHide: () => i.setShowDeleteConfirm(!1),
        onConfirm: i.handleDelete,
        header: `Delete ${h.singularTitle}`,
        message: `Are you sure you want to delete "${u.name}"? This action cannot be undone.`,
        confirmLabel: "Delete",
        confirmIcon: "pi pi-trash",
        confirmSeverity: "danger",
        loading: i.isDeleting
      }
    )
  ] });
}
const ai = ["name", "description"];
function si(e) {
  const { canList: r, canCreate: a } = Ze("roles"), s = je(e == null ? void 0 : e.namespaceId), { resourceServerId: n, scopePermissions: d } = Oe(), l = d ? void 0 : s, m = !d || n != null, { items: v, filter: i, ...u } = xr({
    searchFields: ai,
    useList: (g) => Lt(
      d ? { ...g, where: pr(g.where, n) } : g,
      { enabled: r && m }
    ),
    useCount: (g) => Xs(
      d ? pr(g, n) : g,
      { enabled: r && m }
    ),
    pageSize: e == null ? void 0 : e.pageSize,
    defaultSortField: e == null ? void 0 : e.defaultSortField,
    defaultSortOrder: e == null ? void 0 : e.defaultSortOrder,
    namespaceId: l,
    resetKey: d ? n : void 0
  }), { role: h } = Re();
  return {
    ...u,
    roles: v,
    filter: d ? { ...i, where: pr(i.where, n) } : i,
    labels: h,
    canList: r,
    canCreate: a
  };
}
function ni(e) {
  return [
    { field: "name", header: "Name", sortable: !0, className: "font-medium" },
    {
      field: "description",
      header: "Description",
      sortable: !0,
      body: (r) => /* @__PURE__ */ t("span", { className: "text-[var(--clique-fg-secondary)]", children: r.description || "—" })
    },
    {
      field: "isPrivileged",
      header: "Privileged",
      sortable: !0,
      style: { width: "120px" },
      body: (r) => r.isPrivileged ? /* @__PURE__ */ t(ce, { value: "Privileged", severity: "warning", icon: "pi pi-star" }) : null
    },
    {
      field: "createdAt",
      header: "Created",
      sortable: !0,
      style: { width: "120px" },
      body: (r) => /* @__PURE__ */ t("span", { className: "text-[var(--clique-fg-tertiary)] text-xs", children: e.formatDate(r.createdAt) })
    }
  ];
}
function Dl({
  onRoleSelect: e,
  onCreateRole: r,
  pageSize: a = 20,
  namespaceId: s,
  columns: n,
  toolbarActions: d,
  renderLoading: l,
  renderEmpty: m,
  renderError: v,
  renderAccessDenied: i,
  className: u,
  style: h,
  pt: g
}) {
  const p = fr(), f = Fr(), {
    roles: c,
    totalCount: y,
    search: b,
    setSearch: q,
    page: C,
    setPage: N,
    pageSize: x,
    sortField: w,
    sortOrder: I,
    setSortField: S,
    setSortOrder: E,
    isInitialLoad: R,
    isLoading: P,
    isError: _,
    error: A,
    refetch: k,
    labels: T,
    canList: D,
    canCreate: K
  } = si({ pageSize: a, namespaceId: s }), M = n ?? ni(f), ee = L(
    ($) => {
      N($.page ?? 0);
    },
    [N]
  ), Q = L(
    ($) => {
      S($.sortField), E($.sortOrder === 1 ? 1 : -1), N(0);
    },
    [S, E, N]
  ), j = () => D ? R ? l ? l() : /* @__PURE__ */ t(xe, { message: `Loading ${T.plural}...` }) : _ ? v ? v(A, k) : /* @__PURE__ */ t(he, { error: A, resourceLabel: T.plural, onRetry: k }) : (c == null ? void 0 : c.length) === 0 && !b ? m ? m() : /* @__PURE__ */ t(
    Je,
    {
      icon: p.role,
      title: `No ${T.plural} yet`,
      message: `Create ${T.withArticle} to start managing access.`,
      actionLabel: r && K ? `Create ${T.singularTitle}` : void 0,
      onAction: K ? r : void 0
    }
  ) : /* @__PURE__ */ t(
    Ae,
    {
      value: c ?? [],
      lazy: !0,
      paginator: !0,
      rows: x,
      totalRecords: y ?? 0,
      first: C * x,
      onPage: ee,
      sortField: w,
      sortOrder: I,
      onSort: Q,
      loading: P,
      dataKey: "id",
      emptyMessage: `No ${T.plural} match your search.`,
      selectionMode: "single",
      onSelectionChange: ($) => {
        $.value && (e == null || e($.value));
      },
      rowHover: !0,
      stripedRows: !0,
      className: "rounded-lg border border-[var(--clique-border)] overflow-hidden",
      pt: g,
      rowClassName: () => e ? "cursor-pointer" : "",
      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport",
      currentPageReportTemplate: `Showing {first} to {last} of {totalRecords} ${T.plural}`,
      children: M.map(($) => /* @__PURE__ */ t(
        X,
        {
          field: $.field,
          header: $.header,
          sortable: $.sortable,
          className: $.className,
          style: $.style,
          body: $.body
        },
        $.field
      ))
    }
  ) : i ? i() : /* @__PURE__ */ t(ur, { resourceLabel: T.plural });
  return /* @__PURE__ */ o("div", { className: be(u), style: h, children: [
    /* @__PURE__ */ o("div", { className: "flex items-center justify-between mb-4 gap-4", children: [
      /* @__PURE__ */ t(
        cr,
        {
          value: b,
          onChange: q,
          placeholder: `Search ${T.plural} by name or description...`,
          className: "flex-1 max-w-md"
        }
      ),
      /* @__PURE__ */ o("div", { className: "flex items-center gap-2", children: [
        d,
        r && /* @__PURE__ */ t(
          G,
          {
            type: "button",
            label: `New ${T.singularTitle}`,
            icon: p.create,
            onClick: K ? r : void 0,
            size: "small",
            ...mr(K, T.plural)
          }
        )
      ] })
    ] }),
    j()
  ] });
}
const ii = {
  name: "",
  description: "",
  resourceServerId: null
};
function li(e) {
  const { onCreated: r, onError: a, onDismiss: s } = e ?? {}, {
    form: n,
    updateField: d,
    errors: l,
    setFieldError: m,
    clearErrors: v,
    submitError: i,
    setSubmitError: u,
    reset: h
  } = He(ii), g = Zs(), p = L(() => {
    const f = n.name.trim();
    v(), u("");
    let c = !1;
    const y = Ee(f, "Name") ?? Fe(f, 2, "Name");
    y && (m("name", y), c = !0), n.resourceServerId === null && (m("resourceServerId", "Resource server is required."), c = !0), !c && g.mutate(
      {
        name: f,
        description: n.description.trim() || void 0,
        resourceServerId: n.resourceServerId
      },
      {
        onSuccess: (b) => {
          r == null || r(b), s == null || s();
        },
        onError: (b) => {
          console.error("Failed to create access role", b);
          const q = Xe(b) !== 403 ? "Failed to create access role. Please try again." : ir({ message: lr(b) });
          u(q), a == null || a(q);
        }
      }
    );
  }, [
    n,
    g,
    r,
    s,
    a,
    m,
    v,
    u
  ]);
  return {
    form: n,
    updateField: d,
    nameError: l.name ?? "",
    resourceServerError: l.resourceServerId ?? "",
    submitError: i,
    resetForm: h,
    handleSubmit: p,
    isPending: g.isPending
  };
}
const oi = {
  name: "",
  identifier: "",
  namespaceId: null
};
function di(e) {
  const { onCreated: r, onError: a, onDismiss: s } = e ?? {}, n = je(), d = re(
    () => ({ ...oi, namespaceId: n ?? null }),
    [n]
  ), {
    form: l,
    updateField: m,
    errors: v,
    setFieldError: i,
    clearErrors: u,
    submitError: h,
    setSubmitError: g,
    reset: p
  } = He(d), f = pn(), c = L(() => {
    const y = l.name.trim(), b = l.identifier.trim();
    let q = !1;
    const C = Ee(y, "Name") ?? Fe(y, 2, "Name");
    C && (i("name", C), q = !0);
    const N = Ee(b, "Identifier") ?? Fe(b, 2, "Identifier");
    N && (i("identifier", N), q = !0), !q && (u(), g(""), f.mutate(
      { name: y, identifier: b, namespaceId: l.namespaceId },
      {
        onSuccess: (x) => {
          r == null || r(x), s == null || s();
        },
        onError: (x) => {
          console.error("Failed to create resource server", x);
          const w = "Failed to create resource server. Please try again.";
          g(w), a == null || a(w);
        }
      }
    ));
  }, [
    l,
    f,
    r,
    s,
    a,
    i,
    u,
    g
  ]);
  return {
    form: l,
    updateField: m,
    nameError: v.name ?? "",
    identifierError: v.identifier ?? "",
    submitError: h,
    resetForm: p,
    handleSubmit: c,
    isPending: f.isPending,
    namespaceLocked: n != null
  };
}
function rt({
  visible: e,
  onHide: r,
  onCreated: a,
  className: s,
  style: n,
  pt: d
}) {
  const l = Ie(null), m = di({
    onCreated: a,
    onDismiss: r
  }), {
    form: v,
    updateField: i,
    nameError: u,
    identifierError: h,
    submitError: g,
    resetForm: p,
    handleSubmit: f,
    isPending: c,
    namespaceLocked: y
  } = m;
  return ne(() => {
    e && (p(), setTimeout(() => {
      var b;
      return (b = l.current) == null ? void 0 : b.focus();
    }, 100));
  }, [e, p]), /* @__PURE__ */ t(
    fe,
    {
      visible: e,
      onHide: r,
      header: "Create Resource Server",
      modal: !0,
      draggable: !1,
      resizable: !1,
      closable: !c,
      closeOnEscape: !c,
      className: s,
      style: { width: "32rem", ...n },
      pt: d,
      footer: /* @__PURE__ */ o("div", { className: "flex justify-end gap-3", children: [
        /* @__PURE__ */ t(
          G,
          {
            type: "button",
            label: "Cancel",
            onClick: r,
            severity: "secondary",
            outlined: !0,
            disabled: c
          }
        ),
        /* @__PURE__ */ t(
          G,
          {
            type: "button",
            label: "Create",
            icon: "pi pi-check",
            onClick: f,
            raised: !0,
            loading: c
          }
        )
      ] }),
      children: /* @__PURE__ */ o("div", { className: "flex flex-col gap-6", children: [
        /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
          /* @__PURE__ */ o("label", { htmlFor: "rs-name", className: "text-sm font-semibold text-[var(--clique-fg)]", children: [
            "Name ",
            /* @__PURE__ */ t("span", { className: "text-[var(--clique-destructive)]", children: "*" })
          ] }),
          /* @__PURE__ */ t(
            me,
            {
              id: "rs-name",
              ref: l,
              value: v.name,
              onChange: (b) => i("name", b.target.value),
              placeholder: "e.g. My API",
              className: `w-full ${u ? "p-invalid" : ""}`,
              "aria-invalid": !!u,
              "aria-describedby": u ? "rs-name-error" : void 0
            }
          ),
          u && /* @__PURE__ */ t("small", { id: "rs-name-error", className: "text-[var(--clique-destructive)] text-xs", children: u })
        ] }),
        /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
          /* @__PURE__ */ o("label", { htmlFor: "rs-identifier", className: "text-sm font-semibold text-[var(--clique-fg)]", children: [
            "Identifier ",
            /* @__PURE__ */ t("span", { className: "text-[var(--clique-destructive)]", children: "*" })
          ] }),
          /* @__PURE__ */ t(
            me,
            {
              id: "rs-identifier",
              value: v.identifier,
              onChange: (b) => i("identifier", b.target.value),
              placeholder: "e.g. https://api.example.com",
              className: `w-full ${h ? "p-invalid" : ""}`,
              "aria-invalid": !!h,
              "aria-describedby": h ? "rs-identifier-error" : void 0
            }
          ),
          h && /* @__PURE__ */ t("small", { id: "rs-identifier-error", className: "text-[var(--clique-destructive)] text-xs", children: h }),
          /* @__PURE__ */ t("small", { className: "text-[var(--clique-fg-tertiary)] text-xs", children: "A unique URI that identifies this resource server (e.g. an API audience URL)." })
        ] }),
        /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
          /* @__PURE__ */ t("label", { htmlFor: "rs-namespace", className: "text-sm font-semibold text-[var(--clique-fg)]", children: "Namespace" }),
          /* @__PURE__ */ t(
            Pr,
            {
              id: "rs-namespace",
              value: v.namespaceId,
              onChange: (b) => i("namespaceId", b),
              disabled: y || c,
              enabled: e
            }
          )
        ] }),
        g && /* @__PURE__ */ o("div", { className: "text-[var(--clique-destructive-strong)] text-sm bg-[var(--clique-destructive-subtle)] border border-[var(--clique-destructive-border)] rounded-lg p-3", children: [
          /* @__PURE__ */ t("i", { "aria-hidden": "true", className: "pi pi-exclamation-circle mr-2" }),
          g
        ] })
      ] })
    }
  );
}
function Gl({
  visible: e,
  onHide: r,
  onCreated: a,
  className: s,
  style: n,
  pt: d
}) {
  const l = Ie(null), [m, v] = U(!1), i = Oe(), u = li({
    onCreated: a,
    onDismiss: r
  }), {
    options: h,
    isLoading: g,
    isError: p,
    error: f,
    locked: c
  } = yr({ enabled: e }), {
    form: y,
    updateField: b,
    nameError: q,
    resourceServerError: C,
    submitError: N,
    resetForm: x,
    handleSubmit: w,
    isPending: I
  } = u, S = i.showSelector && !c, E = Jr({
    isPending: I,
    selectorInteractive: S,
    isResolving: i.isResolving,
    resolutionError: i.resolutionError,
    isLoadingOptions: g,
    isOptionsError: p,
    selectedId: y.resourceServerId,
    options: h
  });
  return ne(() => {
    e && (x(), setTimeout(() => {
      var R;
      return (R = l.current) == null ? void 0 : R.focus();
    }, 100));
  }, [e, x]), ne(() => {
    !e || i.resourceServerId == null || y.resourceServerId != null || b("resourceServerId", i.resourceServerId);
  }, [e, i.resourceServerId, y.resourceServerId, b]), /* @__PURE__ */ o(
    fe,
    {
      visible: e,
      onHide: r,
      header: "Create Access Role",
      modal: !0,
      draggable: !1,
      resizable: !1,
      closable: !I,
      closeOnEscape: !I,
      className: s,
      style: { width: "32rem", ...n },
      pt: d,
      footer: /* @__PURE__ */ o("div", { className: "flex justify-end gap-3", children: [
        /* @__PURE__ */ t(
          G,
          {
            type: "button",
            label: "Cancel",
            onClick: r,
            severity: "secondary",
            outlined: !0,
            disabled: I
          }
        ),
        /* @__PURE__ */ t(
          G,
          {
            type: "button",
            label: "Create",
            icon: "pi pi-check",
            onClick: w,
            raised: !0,
            loading: I || (S ? g : i.isResolving),
            disabled: E
          }
        )
      ] }),
      children: [
        /* @__PURE__ */ o("div", { className: "flex flex-col gap-6", children: [
          /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
            /* @__PURE__ */ o("label", { htmlFor: "role-name", className: "text-sm font-semibold text-[var(--clique-fg)]", children: [
              "Name ",
              /* @__PURE__ */ t("span", { className: "text-[var(--clique-destructive)]", children: "*" })
            ] }),
            /* @__PURE__ */ t(
              me,
              {
                id: "role-name",
                ref: l,
                value: y.name,
                onChange: (R) => b("name", R.target.value),
                placeholder: "Enter access role name",
                className: `w-full ${q ? "p-invalid" : ""}`,
                "aria-invalid": !!q,
                "aria-describedby": q ? "role-name-error" : void 0
              }
            ),
            q && /* @__PURE__ */ t("small", { id: "role-name-error", className: "text-[var(--clique-destructive)] text-xs", children: q })
          ] }),
          /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
            /* @__PURE__ */ t(
              "label",
              {
                htmlFor: "role-description",
                className: "text-sm font-semibold text-[var(--clique-fg)]",
                children: "Description"
              }
            ),
            /* @__PURE__ */ t(
              _e,
              {
                id: "role-description",
                value: y.description,
                onChange: (R) => b("description", R.target.value),
                placeholder: "Optional description",
                className: "w-full",
                rows: 3,
                autoResize: !0
              }
            )
          ] }),
          i.showSelector && /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
            /* @__PURE__ */ o(
              "label",
              {
                htmlFor: "role-resource-server",
                className: "text-sm font-semibold text-[var(--clique-fg)]",
                children: [
                  "Resource Server ",
                  /* @__PURE__ */ t("span", { className: "text-[var(--clique-destructive)]", children: "*" })
                ]
              }
            ),
            /* @__PURE__ */ o("div", { className: "flex gap-2 items-start", children: [
              /* @__PURE__ */ t(
                ge,
                {
                  inputId: "role-resource-server",
                  value: y.resourceServerId,
                  options: h,
                  onChange: (R) => b("resourceServerId", R.value),
                  placeholder: "Select a resource server",
                  className: `flex-1 ${C ? "p-invalid" : ""}`,
                  loading: g,
                  disabled: c,
                  filter: !0,
                  "aria-invalid": !!C,
                  "aria-describedby": C ? "role-resource-server-error" : void 0
                }
              ),
              !c && /* @__PURE__ */ t(
                G,
                {
                  type: "button",
                  icon: "pi pi-plus",
                  tooltip: "New Resource Server",
                  tooltipOptions: { position: "top" },
                  onClick: () => v(!0),
                  severity: "secondary",
                  outlined: !0,
                  "aria-label": "New Resource Server"
                }
              )
            ] }),
            C && /* @__PURE__ */ t(
              "small",
              {
                id: "role-resource-server-error",
                className: "text-[var(--clique-destructive)] text-xs",
                children: C
              }
            ),
            p && /* @__PURE__ */ t("small", { className: "text-[var(--clique-destructive)] text-xs", children: f instanceof Error ? f.message : "Failed to load resource servers" })
          ] }),
          !S && i.resolutionError && /* @__PURE__ */ o(
            "div",
            {
              role: "alert",
              className: "text-[var(--clique-destructive-strong)] text-sm bg-[var(--clique-destructive-subtle)] border border-[var(--clique-destructive-border)] rounded-lg p-3",
              children: [
                /* @__PURE__ */ t("i", { "aria-hidden": "true", className: "pi pi-exclamation-circle mr-2" }),
                i.resolutionError
              ]
            }
          ),
          N && /* @__PURE__ */ o("div", { className: "text-[var(--clique-destructive-strong)] text-sm bg-[var(--clique-destructive-subtle)] border border-[var(--clique-destructive-border)] rounded-lg p-3", children: [
            /* @__PURE__ */ t("i", { "aria-hidden": "true", className: "pi pi-exclamation-circle mr-2" }),
            N
          ] })
        ] }),
        /* @__PURE__ */ t(
          rt,
          {
            visible: m,
            onHide: () => v(!1),
            onCreated: (R) => {
              b("resourceServerId", R.id), v(!1);
            }
          }
        )
      ]
    }
  );
}
function ci(e) {
  if (!e.role) return { status: "wait" };
  if (e.scopePermissions) {
    if (e.configuredServerId == null)
      return e.isResolving && !e.resolutionError ? { status: "wait" } : { status: "closed" };
    if (e.role.resourceServerId !== e.configuredServerId) return { status: "closed" };
  } else if (e.namespaceId != null && e.role.namespaceId != null && e.role.namespaceId !== e.namespaceId)
    return { status: "closed" };
  return { status: "query", resourceServerId: e.role.resourceServerId };
}
function ui(e) {
  const { roleId: r, onDeleted: a, onSuccess: s, onError: n } = e, {
    data: d,
    isLoading: l,
    isError: m,
    error: v,
    refetch: i
  } = Js(r), {
    data: u,
    isLoading: h,
    refetch: g
  } = en(r), {
    resourceServerId: p,
    isResolving: f,
    scopePermissions: c,
    resolutionError: y,
    refetch: b
  } = Oe(), q = os(), C = ci({
    role: d,
    scopePermissions: c,
    configuredServerId: p,
    isResolving: f,
    resolutionError: y,
    namespaceId: q
  }), N = C.status === "query" ? { where: { resourceServerId: C.resourceServerId } } : void 0, {
    data: x,
    isLoading: w,
    isPlaceholderData: I,
    isError: S,
    error: E,
    refetch: R
  } = Dt(N, {
    enabled: C.status === "query"
  }), P = C.status === "query" ? `${c ? "scoped" : "role"}:${C.resourceServerId}` : C.status, _ = qr(P, I), A = C.status === "wait" || w || _, k = (c && y ? new Error(y) : null) ?? (C.status === "query" && S ? E : null), T = L(() => {
    if (c && y) {
      b();
      return;
    }
    R();
  }, [c, y, b, R]), D = rn(r), K = tn(r), M = kt(), [ee, Q] = U(!1), [j, $] = U(null), [ie, O] = U(
    null
  ), [ae, Y] = U(!1);
  ne(() => {
    $(null);
  }, [P]);
  const ue = re(() => new Set((u ?? []).map((V) => V.id)), [u]), se = re(
    () => C.status !== "query" || _ ? [] : (x ?? []).filter((V) => !ue.has(V.id)),
    [x, ue, C.status, _]
  ), de = L(() => {
    if (j === null) return;
    const V = se.find((Se) => Se.id === j);
    V && D.mutate(
      { resourceServerId: V.resourceServerId, permissionId: V.id },
      {
        onSuccess: () => {
          Q(!1), $(null), s == null || s("Permission added to access role.");
        },
        onError: (Se) => {
          console.error("Failed to add permission to access role", Se), n == null || n("Failed to add permission to access role.");
        }
      }
    );
  }, [j, se, D, s, n]), oe = L(
    (V) => {
      const Se = (u ?? []).find((_r) => _r.id === V);
      O(Se ?? null);
    },
    [u]
  ), le = L(() => {
    ie && K.mutate(
      {
        resourceServerId: ie.resourceServerId,
        permissionId: ie.id
      },
      {
        onSuccess: () => {
          O(null), s == null || s("Permission removed from access role.");
        },
        onError: (V) => {
          console.error("Failed to remove permission from access role", V), O(null), n == null || n("Failed to remove permission from access role.");
        }
      }
    );
  }, [ie, K, s, n]), H = L(() => {
    M.mutate(r, {
      onSuccess: () => {
        Y(!1), s == null || s("Access role deleted successfully."), a == null || a();
      },
      onError: (V) => {
        Y(!1), console.error("Failed to delete access role", V), n == null || n("Failed to delete access role.");
      }
    });
  }, [r, M, a, s, n]), ze = L(() => {
    Promise.all([i(), g()]);
  }, [i, g]);
  return {
    role: d,
    isLoading: l,
    isError: m,
    error: v,
    refetch: ze,
    permissions: u ?? [],
    isLoadingPermissions: h,
    availablePermissions: se,
    isLoadingAvailable: A,
    isAvailableError: !!k,
    availableError: k,
    refetchAvailable: T,
    showAddDialog: ee,
    setShowAddDialog: Q,
    selectedPermissionId: j,
    setSelectedPermissionId: $,
    handleAddPermission: de,
    isAdding: D.isPending,
    handleRemovePermission: oe,
    isRemoving: K.isPending,
    permissionToRemove: ie,
    setPermissionToRemove: O,
    handleRemoveConfirm: le,
    showDeleteConfirm: ae,
    setShowDeleteConfirm: Y,
    handleDelete: H,
    isDeleting: M.isPending
  };
}
const mi = {
  name: "",
  description: "",
  resourceServerId: null
};
function pi(e) {
  const { onCreated: r, onError: a, onDismiss: s } = e ?? {}, {
    form: n,
    updateField: d,
    errors: l,
    setFieldError: m,
    clearErrors: v,
    submitError: i,
    setSubmitError: u,
    reset: h
  } = He(mi), g = on(), p = L(() => {
    const f = n.name.trim();
    let c = !1;
    const y = Ee(f, "Name") ?? Fe(f, 2, "Name");
    y && (m("name", y), c = !0), n.resourceServerId === null && (m("resourceServerId", "Resource server is required."), c = !0), !c && (v(), u(""), g.mutate(
      {
        resourceServerId: n.resourceServerId,
        data: {
          name: f,
          description: n.description.trim() || void 0
        }
      },
      {
        onSuccess: (b) => {
          r == null || r(b), s == null || s();
        },
        onError: (b) => {
          console.error("Failed to create permission", b);
          const q = Xe(b) !== 403 ? "Failed to create permission. Please try again." : ir({ message: lr(b) });
          u(q), a == null || a(q);
        }
      }
    ));
  }, [
    n,
    g,
    r,
    s,
    a,
    m,
    v,
    u
  ]);
  return {
    form: n,
    updateField: d,
    nameError: l.name ?? "",
    resourceServerError: l.resourceServerId ?? "",
    submitError: i,
    resetForm: h,
    handleSubmit: p,
    isPending: g.isPending
  };
}
function gi({
  visible: e,
  onHide: r,
  onCreated: a,
  className: s,
  style: n,
  pt: d
}) {
  const l = Ie(null), [m, v] = U(!1), i = Oe(), u = pi({
    onCreated: a,
    onDismiss: r
  }), {
    options: h,
    isLoading: g,
    isError: p,
    error: f,
    locked: c
  } = yr({ enabled: e }), {
    form: y,
    updateField: b,
    nameError: q,
    resourceServerError: C,
    submitError: N,
    resetForm: x,
    handleSubmit: w,
    isPending: I
  } = u, S = i.showSelector && !c, E = Jr({
    isPending: I,
    selectorInteractive: S,
    isResolving: i.isResolving,
    resolutionError: i.resolutionError,
    isLoadingOptions: g,
    isOptionsError: p,
    selectedId: y.resourceServerId,
    options: h
  });
  return ne(() => {
    e && (x(), setTimeout(() => {
      var R;
      return (R = l.current) == null ? void 0 : R.focus();
    }, 100));
  }, [e, x]), ne(() => {
    !e || i.resourceServerId == null || y.resourceServerId != null || b("resourceServerId", i.resourceServerId);
  }, [e, i.resourceServerId, y.resourceServerId, b]), /* @__PURE__ */ o(
    fe,
    {
      visible: e,
      onHide: r,
      header: "Create Permission",
      modal: !0,
      draggable: !1,
      resizable: !1,
      closable: !I,
      closeOnEscape: !I,
      className: s,
      style: { width: "32rem", ...n },
      pt: d,
      footer: /* @__PURE__ */ o("div", { className: "flex justify-end gap-3", children: [
        /* @__PURE__ */ t(
          G,
          {
            type: "button",
            label: "Cancel",
            onClick: r,
            severity: "secondary",
            outlined: !0,
            disabled: I
          }
        ),
        /* @__PURE__ */ t(
          G,
          {
            type: "button",
            label: "Create",
            icon: "pi pi-check",
            onClick: w,
            raised: !0,
            loading: I || (S ? g : i.isResolving),
            disabled: E
          }
        )
      ] }),
      children: [
        /* @__PURE__ */ o("div", { className: "flex flex-col gap-6", children: [
          /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
            /* @__PURE__ */ o(
              "label",
              {
                htmlFor: "permission-name",
                className: "text-sm font-semibold text-[var(--clique-fg)]",
                children: [
                  "Name ",
                  /* @__PURE__ */ t("span", { className: "text-[var(--clique-destructive)]", children: "*" })
                ]
              }
            ),
            /* @__PURE__ */ t(
              me,
              {
                id: "permission-name",
                ref: l,
                value: y.name,
                onChange: (R) => b("name", R.target.value),
                placeholder: "Enter permission name",
                className: `w-full ${q ? "p-invalid" : ""}`,
                "aria-invalid": !!q,
                "aria-describedby": q ? "permission-name-error" : void 0
              }
            ),
            q && /* @__PURE__ */ t("small", { id: "permission-name-error", className: "text-[var(--clique-destructive)] text-xs", children: q })
          ] }),
          /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
            /* @__PURE__ */ t(
              "label",
              {
                htmlFor: "permission-description",
                className: "text-sm font-semibold text-[var(--clique-fg)]",
                children: "Description"
              }
            ),
            /* @__PURE__ */ t(
              _e,
              {
                id: "permission-description",
                value: y.description,
                onChange: (R) => b("description", R.target.value),
                placeholder: "Optional description",
                className: "w-full",
                rows: 3,
                autoResize: !0
              }
            )
          ] }),
          i.showSelector && /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
            /* @__PURE__ */ o(
              "label",
              {
                htmlFor: "permission-resource-server",
                className: "text-sm font-semibold text-[var(--clique-fg)]",
                children: [
                  "Resource Server ",
                  /* @__PURE__ */ t("span", { className: "text-[var(--clique-destructive)]", children: "*" })
                ]
              }
            ),
            /* @__PURE__ */ o("div", { className: "flex gap-2 items-start", children: [
              /* @__PURE__ */ t(
                ge,
                {
                  inputId: "permission-resource-server",
                  value: y.resourceServerId,
                  options: h,
                  onChange: (R) => b("resourceServerId", R.value),
                  placeholder: "Select a resource server",
                  className: `flex-1 ${C ? "p-invalid" : ""}`,
                  loading: g,
                  disabled: c,
                  filter: !0,
                  "aria-invalid": !!C,
                  "aria-describedby": C ? "permission-resource-server-error" : void 0
                }
              ),
              !c && /* @__PURE__ */ t(
                G,
                {
                  type: "button",
                  icon: "pi pi-plus",
                  tooltip: "New Resource Server",
                  tooltipOptions: { position: "top" },
                  onClick: () => v(!0),
                  severity: "secondary",
                  outlined: !0,
                  "aria-label": "New Resource Server"
                }
              )
            ] }),
            C && /* @__PURE__ */ t(
              "small",
              {
                id: "permission-resource-server-error",
                className: "text-[var(--clique-destructive)] text-xs",
                children: C
              }
            ),
            p && /* @__PURE__ */ t("small", { className: "text-[var(--clique-destructive)] text-xs", children: f instanceof Error ? f.message : "Failed to load resource servers" })
          ] }),
          !S && i.resolutionError && /* @__PURE__ */ o(
            "div",
            {
              role: "alert",
              className: "text-[var(--clique-destructive-strong)] text-sm bg-[var(--clique-destructive-subtle)] border border-[var(--clique-destructive-border)] rounded-lg p-3",
              children: [
                /* @__PURE__ */ t("i", { "aria-hidden": "true", className: "pi pi-exclamation-circle mr-2" }),
                i.resolutionError
              ]
            }
          ),
          N && /* @__PURE__ */ o("div", { className: "text-[var(--clique-destructive-strong)] text-sm bg-[var(--clique-destructive-subtle)] border border-[var(--clique-destructive-border)] rounded-lg p-3", children: [
            /* @__PURE__ */ t("i", { "aria-hidden": "true", className: "pi pi-exclamation-circle mr-2" }),
            N
          ] })
        ] }),
        /* @__PURE__ */ t(
          rt,
          {
            visible: m,
            onHide: () => v(!1),
            onCreated: (R) => {
              b("resourceServerId", R.id), v(!1);
            }
          }
        )
      ]
    }
  );
}
function Ul({
  visible: e,
  onHide: r,
  roleId: a,
  onDeleted: s,
  onSuccess: n,
  onError: d,
  className: l,
  style: m,
  pt: v
}) {
  var ee, Q, j, $, ie;
  const i = ui({
    roleId: a,
    onDeleted: () => {
      setTimeout(() => {
        r(), s == null || s();
      }, 1e3);
    },
    onSuccess: n,
    onError: d
  }), u = Tt(), h = Oe(), {
    options: g,
    isLoading: p,
    isError: f,
    error: c,
    locked: y
  } = yr({
    enabled: e,
    currentId: (ee = i.role) == null ? void 0 : ee.resourceServerId
  }), [b, q] = U(!1), [C, N] = U(!1), [x, w] = U(""), [I, S] = U(""), [E, R] = U(null), [P, _] = U("");
  ne(() => {
    i.role && (w(i.role.name), S(i.role.description ?? ""), R(i.role.resourceServerId), _(""));
  }, [i.role]);
  const A = !!i.role && (x !== i.role.name || I !== (i.role.description ?? "") || E !== i.role.resourceServerId), k = L(() => {
    var Y;
    const O = x.trim();
    if (!O) {
      _("Name is required.");
      return;
    }
    if (O.length < 2) {
      _("Name must be at least 2 characters.");
      return;
    }
    _("");
    const ae = {
      name: O,
      description: I.trim() || void 0,
      ...E !== ((Y = i.role) == null ? void 0 : Y.resourceServerId) && E ? { resourceServerId: E } : {}
    };
    u.mutate(
      {
        accessRoleId: a,
        data: ae
      },
      {
        onSuccess: () => {
          n == null || n("Access role updated.");
        },
        onError: (ue) => {
          console.error("Failed to update access role", ue);
          const se = Xe(ue) !== 403 ? "Failed to update access role. Please try again." : ir({ message: lr(ue) });
          d == null || d(se);
        }
      }
    );
  }, [
    x,
    I,
    E,
    a,
    (Q = i.role) == null ? void 0 : Q.resourceServerId,
    u,
    n,
    d
  ]), T = !i.isAdding && !i.isRemoving && !i.isDeleting && !u.isPending, D = L(() => {
    T && r();
  }, [T, r]), K = i.availablePermissions.map((O) => ({
    label: O.name,
    value: O.id
  })), M = (O) => /* @__PURE__ */ t(
    G,
    {
      type: "button",
      icon: "pi pi-trash",
      className: "p-button-text p-button-danger p-button-sm",
      onClick: () => i.handleRemovePermission(O.id),
      disabled: i.isRemoving
    }
  );
  return /* @__PURE__ */ o(Ce, { children: [
    /* @__PURE__ */ o(
      fe,
      {
        header: ((j = i.role) == null ? void 0 : j.name) || "Access Role Details",
        visible: e,
        onHide: D,
        closable: T,
        closeOnEscape: T,
        maximizable: !0,
        className: l,
        style: { width: "800px", ...m },
        pt: v,
        breakpoints: { "960px": "95vw" },
        children: [
          i.isLoading && /* @__PURE__ */ t(xe, { message: "Loading access role..." }),
          i.isError && /* @__PURE__ */ t(
            he,
            {
              error: i.error,
              resourceLabel: "access role",
              onRetry: i.refetch
            }
          ),
          !i.isLoading && !i.isError && i.role && /* @__PURE__ */ o("div", { children: [
            /* @__PURE__ */ o("div", { className: "flex items-center justify-between mb-6", children: [
              /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: i.role.isPrivileged && /* @__PURE__ */ t(ce, { value: "Privileged", severity: "warning", icon: "pi pi-star" }) }),
              /* @__PURE__ */ t(
                G,
                {
                  type: "button",
                  label: "Delete",
                  icon: "pi pi-trash",
                  onClick: () => i.setShowDeleteConfirm(!0),
                  severity: "danger",
                  outlined: !0,
                  size: "small"
                }
              )
            ] }),
            /* @__PURE__ */ o(
              "div",
              {
                className: "rounded-lg border border-[var(--clique-border)] p-6 mb-6",
                style: { backgroundColor: "var(--clique-bg)" },
                children: [
                  /* @__PURE__ */ o("div", { className: "flex items-center justify-between mb-4", children: [
                    /* @__PURE__ */ t("h3", { className: "text-lg font-medium text-[var(--clique-fg)]", children: "Access Role Info" }),
                    A && /* @__PURE__ */ t(
                      G,
                      {
                        type: "button",
                        label: "Save Changes",
                        icon: "pi pi-check",
                        size: "small",
                        onClick: k,
                        loading: u.isPending
                      }
                    )
                  ] }),
                  /* @__PURE__ */ o("div", { className: "flex flex-col gap-4", children: [
                    /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
                      /* @__PURE__ */ t(
                        "label",
                        {
                          htmlFor: "role-edit-name",
                          className: "text-sm font-semibold text-[var(--clique-fg-secondary)]",
                          children: "Name"
                        }
                      ),
                      /* @__PURE__ */ t(
                        me,
                        {
                          id: "role-edit-name",
                          value: x,
                          onChange: (O) => {
                            w(O.target.value), _("");
                          },
                          className: `w-full ${P ? "p-invalid" : ""}`
                        }
                      ),
                      P && /* @__PURE__ */ t("small", { className: "text-[var(--clique-destructive)] text-xs", children: P })
                    ] }),
                    /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
                      /* @__PURE__ */ t(
                        "label",
                        {
                          htmlFor: "role-edit-description",
                          className: "text-sm font-semibold text-[var(--clique-fg-secondary)]",
                          children: "Description"
                        }
                      ),
                      /* @__PURE__ */ t(
                        _e,
                        {
                          id: "role-edit-description",
                          value: I,
                          onChange: (O) => S(O.target.value),
                          className: "w-full",
                          rows: 2,
                          autoResize: !0,
                          placeholder: "Optional description"
                        }
                      )
                    ] }),
                    h.showSelector && /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
                      /* @__PURE__ */ t(
                        "label",
                        {
                          htmlFor: "role-edit-resource-server",
                          className: "text-sm font-semibold text-[var(--clique-fg-secondary)]",
                          children: "Resource Server"
                        }
                      ),
                      /* @__PURE__ */ o("div", { className: "flex gap-2 items-start", children: [
                        /* @__PURE__ */ t(
                          ge,
                          {
                            inputId: "role-edit-resource-server",
                            value: E,
                            options: g,
                            onChange: (O) => R(O.value),
                            placeholder: "Select a resource server",
                            className: "flex-1",
                            loading: p,
                            disabled: y,
                            filter: !0
                          }
                        ),
                        !y && /* @__PURE__ */ t(
                          G,
                          {
                            type: "button",
                            icon: "pi pi-plus",
                            tooltip: "New Resource Server",
                            tooltipOptions: { position: "top" },
                            onClick: () => q(!0),
                            severity: "secondary",
                            outlined: !0,
                            "aria-label": "New Resource Server"
                          }
                        )
                      ] }),
                      f && /* @__PURE__ */ t("small", { className: "text-[var(--clique-destructive)] text-xs", children: c instanceof Error ? c.message : "Failed to load resource servers" })
                    ] })
                  ] })
                ]
              }
            ),
            /* @__PURE__ */ o("div", { className: "border-t border-[var(--clique-border)] pt-6", children: [
              /* @__PURE__ */ o("div", { className: "flex items-center justify-between mb-4", children: [
                /* @__PURE__ */ o("span", { className: "text-lg font-semibold text-[var(--clique-fg)]", children: [
                  "Permissions (",
                  i.permissions.length,
                  ")"
                ] }),
                /* @__PURE__ */ t(
                  G,
                  {
                    type: "button",
                    label: "Add Permission",
                    icon: "pi pi-plus",
                    size: "small",
                    onClick: () => i.setShowAddDialog(!0)
                  }
                )
              ] }),
              /* @__PURE__ */ o(
                Ae,
                {
                  value: i.permissions,
                  loading: i.isLoadingPermissions,
                  dataKey: "id",
                  stripedRows: !0,
                  emptyMessage: /* @__PURE__ */ o("div", { className: "text-center py-8", children: [
                    /* @__PURE__ */ t(
                      "i",
                      {
                        "aria-hidden": "true",
                        className: "pi pi-lock text-4xl text-[var(--clique-fg-tertiary)] mb-3"
                      }
                    ),
                    /* @__PURE__ */ t("p", { className: "text-[var(--clique-fg-secondary)]", children: 'No permissions assigned. Click "Add Permission" to assign one.' })
                  ] }),
                  children: [
                    /* @__PURE__ */ t(X, { field: "name", header: "Name", className: "font-medium" }),
                    /* @__PURE__ */ t(
                      X,
                      {
                        field: "description",
                        header: "Description",
                        body: (O) => /* @__PURE__ */ t("span", { className: "text-[var(--clique-fg-secondary)]", children: O.description || "—" })
                      }
                    ),
                    /* @__PURE__ */ t(
                      X,
                      {
                        field: "isPrivileged",
                        header: "Privileged",
                        body: (O) => O.isPrivileged ? /* @__PURE__ */ t(ce, { value: "Privileged", severity: "warning", icon: "pi pi-star" }) : null,
                        style: { width: "120px" }
                      }
                    ),
                    /* @__PURE__ */ t(
                      X,
                      {
                        header: "Actions",
                        body: M,
                        style: { width: "80px" },
                        bodyStyle: { textAlign: "center" },
                        headerStyle: { textAlign: "center" }
                      }
                    )
                  ]
                }
              )
            ] })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ t(
      fe,
      {
        header: "Add Permission to Access Role",
        visible: i.showAddDialog,
        onHide: () => i.setShowAddDialog(!1),
        closable: !i.isAdding,
        closeOnEscape: !i.isAdding,
        modal: !0,
        style: { width: "28rem" },
        footer: /* @__PURE__ */ o("div", { className: "flex justify-end gap-3", children: [
          /* @__PURE__ */ t(
            G,
            {
              type: "button",
              label: "Cancel",
              onClick: () => i.setShowAddDialog(!1),
              severity: "secondary",
              outlined: !0,
              disabled: i.isAdding
            }
          ),
          /* @__PURE__ */ t(
            G,
            {
              type: "button",
              label: "Add",
              icon: "pi pi-plus",
              onClick: i.handleAddPermission,
              raised: !0,
              loading: i.isAdding,
              disabled: i.isAvailableError || i.selectedPermissionId === null
            }
          )
        ] }),
        children: i.isAvailableError ? /* @__PURE__ */ t(
          he,
          {
            error: i.availableError,
            resourceLabel: "permissions",
            onRetry: i.refetchAvailable
          }
        ) : /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
          /* @__PURE__ */ t(
            "label",
            {
              htmlFor: "add-role-permission",
              className: "text-sm font-semibold text-[var(--clique-fg)]",
              children: "Permission"
            }
          ),
          /* @__PURE__ */ o("div", { className: "flex gap-2 items-start", children: [
            /* @__PURE__ */ t(
              ge,
              {
                inputId: "add-role-permission",
                value: i.selectedPermissionId,
                options: K,
                onChange: (O) => i.setSelectedPermissionId(O.value),
                placeholder: "Select a permission",
                className: "flex-1",
                filter: !0,
                loading: i.isLoadingAvailable,
                emptyMessage: "No available permissions"
              }
            ),
            /* @__PURE__ */ t(
              G,
              {
                type: "button",
                icon: "pi pi-plus",
                tooltip: "New Permission",
                tooltipOptions: { position: "top" },
                onClick: () => N(!0),
                severity: "secondary",
                outlined: !0,
                "aria-label": "New Permission"
              }
            )
          ] })
        ] })
      }
    ),
    /* @__PURE__ */ t(
      gi,
      {
        visible: C,
        onHide: () => N(!1),
        onCreated: (O) => {
          i.setSelectedPermissionId(O.id), N(!1);
        }
      }
    ),
    /* @__PURE__ */ t(
      Ge,
      {
        visible: i.permissionToRemove !== null,
        onHide: () => i.setPermissionToRemove(null),
        onConfirm: i.handleRemoveConfirm,
        header: "Remove Permission",
        message: `Are you sure you want to remove "${($ = i.permissionToRemove) == null ? void 0 : $.name}" from this access role?`,
        confirmLabel: "Remove",
        confirmIcon: "pi pi-trash",
        confirmSeverity: "danger",
        loading: i.isRemoving
      }
    ),
    /* @__PURE__ */ t(
      Ge,
      {
        visible: i.showDeleteConfirm,
        onHide: () => i.setShowDeleteConfirm(!1),
        onConfirm: i.handleDelete,
        header: "Delete Access Role",
        message: `Are you sure you want to delete "${(ie = i.role) == null ? void 0 : ie.name}"? This action cannot be undone.`,
        confirmLabel: "Delete",
        confirmIcon: "pi pi-trash",
        confirmSeverity: "danger",
        loading: i.isDeleting
      }
    ),
    /* @__PURE__ */ t(
      rt,
      {
        visible: b,
        onHide: () => q(!1),
        onCreated: (O) => {
          R(O.id), q(!1);
        }
      }
    )
  ] });
}
const vi = ["name", "description"];
function fi(e) {
  var A;
  const { canList: r, canCreate: a } = Ze("permissions"), s = vr(), n = s == null || ds(
    cs("resourceServers", "list"),
    s.hasScope
  ), { resourceServerId: d, isResolving: l, resolutionError: m, scopePermissions: v } = Oe(), i = je(e == null ? void 0 : e.namespaceId), u = !v && i != null, h = u && n, g = u && !n, p = un(i, {
    enabled: r && h
  }), f = v ? d : h ? p.ids : void 0, c = g && i != null ? us(i) : void 0, y = !h || p.ids !== void 0, b = h && y && (((A = p.ids) == null ? void 0 : A.length) ?? 0) === 0, q = r && (!v || d !== null) && y && !b && !(h && p.isError), { items: C, isInitialLoad: N, isError: x, error: w, filter: I, ...S } = xr({
    searchFields: vi,
    useList: (k) => Dt(
      {
        ...k,
        where: pr(k.where, f),
        ...c ? { include: c } : {}
      },
      { enabled: q }
    ),
    useCount: (k) => ln(pr(k, f), {
      enabled: q && !g
    }),
    pageSize: e == null ? void 0 : e.pageSize,
    defaultSortField: e == null ? void 0 : e.defaultSortField,
    defaultSortOrder: e == null ? void 0 : e.defaultSortOrder,
    resetKey: v ? `resource-server:${d}` : g ? `namespace-include:${i}` : u ? `namespace:${i}` : "tenant"
  }), { permission: E } = Re(), R = v ? m : null, P = R ? new Error(R) : null, _ = h && p.isError ? p.error : null;
  return {
    ...S,
    permissions: b ? [] : C,
    totalCount: b ? 0 : S.totalCount,
    isEmpty: b || S.isEmpty,
    filter: {
      ...I,
      where: pr(I.where, f),
      ...c ? { include: c } : {}
    },
    isInitialLoad: v && l || h && p.isLoading || N,
    isError: x || !!R || !!_,
    error: w ?? P ?? _,
    labels: E,
    canList: r,
    canCreate: a
  };
}
function hi(e) {
  return [
    { field: "name", header: "Name", sortable: !0, className: "font-medium" },
    {
      field: "description",
      header: "Description",
      sortable: !0,
      body: (r) => /* @__PURE__ */ t("span", { className: "text-[var(--clique-fg-secondary)]", children: r.description || "—" })
    },
    {
      field: "isPrivileged",
      header: "Privileged",
      sortable: !0,
      style: { width: "120px" },
      body: (r) => r.isPrivileged ? /* @__PURE__ */ t(ce, { value: "Privileged", severity: "warning", icon: "pi pi-star" }) : null
    },
    {
      field: "createdAt",
      header: "Created",
      sortable: !0,
      style: { width: "120px" },
      body: (r) => /* @__PURE__ */ t("span", { className: "text-[var(--clique-fg-tertiary)] text-xs", children: e.formatDate(r.createdAt) })
    }
  ];
}
function Ml({
  onPermissionSelect: e,
  onCreatePermission: r,
  pageSize: a = 20,
  namespaceId: s,
  columns: n,
  toolbarActions: d,
  renderLoading: l,
  renderEmpty: m,
  renderError: v,
  renderAccessDenied: i,
  className: u,
  style: h,
  pt: g
}) {
  const p = fr(), f = Fr(), {
    permissions: c,
    totalCount: y,
    search: b,
    setSearch: q,
    page: C,
    setPage: N,
    pageSize: x,
    sortField: w,
    sortOrder: I,
    setSortField: S,
    setSortOrder: E,
    isInitialLoad: R,
    isLoading: P,
    isError: _,
    error: A,
    refetch: k,
    labels: T,
    canList: D,
    canCreate: K
  } = fi({ pageSize: a, namespaceId: s }), M = n ?? hi(f), ee = L(
    ($) => {
      N($.page ?? 0);
    },
    [N]
  ), Q = L(
    ($) => {
      S($.sortField), E($.sortOrder === 1 ? 1 : -1), N(0);
    },
    [S, E, N]
  ), j = () => D ? R ? l ? l() : /* @__PURE__ */ t(xe, { message: `Loading ${T.plural}...` }) : _ ? v ? v(A, k) : /* @__PURE__ */ t(he, { error: A, resourceLabel: T.plural, onRetry: k }) : (c == null ? void 0 : c.length) === 0 && !b ? m ? m() : /* @__PURE__ */ t(
    Je,
    {
      icon: p.permission,
      title: `No ${T.plural} yet`,
      message: `Create ${T.withArticle} to start managing access controls.`,
      actionLabel: r && K ? `Create ${T.singularTitle}` : void 0,
      onAction: K ? r : void 0
    }
  ) : /* @__PURE__ */ t(
    Ae,
    {
      value: c ?? [],
      lazy: !0,
      paginator: !0,
      rows: x,
      totalRecords: y ?? 0,
      first: C * x,
      onPage: ee,
      sortField: w,
      sortOrder: I,
      onSort: Q,
      loading: P,
      dataKey: "id",
      emptyMessage: `No ${T.plural} match your search.`,
      selectionMode: "single",
      onSelectionChange: ($) => {
        $.value && (e == null || e($.value));
      },
      rowHover: !0,
      stripedRows: !0,
      className: "rounded-lg border border-[var(--clique-border)] overflow-hidden",
      pt: g,
      rowClassName: () => e ? "cursor-pointer" : "",
      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport",
      currentPageReportTemplate: `Showing {first} to {last} of {totalRecords} ${T.plural}`,
      children: M.map(($) => /* @__PURE__ */ t(
        X,
        {
          field: $.field,
          header: $.header,
          sortable: $.sortable,
          className: $.className,
          style: $.style,
          body: $.body
        },
        $.field
      ))
    }
  ) : i ? i() : /* @__PURE__ */ t(ur, { resourceLabel: T.plural });
  return /* @__PURE__ */ o("div", { className: be(u), style: h, children: [
    /* @__PURE__ */ o("div", { className: "flex items-center justify-between mb-4 gap-4", children: [
      /* @__PURE__ */ t(
        cr,
        {
          value: b,
          onChange: q,
          placeholder: `Search ${T.plural} by name or description...`,
          className: "flex-1 max-w-md"
        }
      ),
      /* @__PURE__ */ o("div", { className: "flex items-center gap-2", children: [
        d,
        r && /* @__PURE__ */ t(
          G,
          {
            type: "button",
            label: `New ${T.singularTitle}`,
            icon: p.create,
            onClick: K ? r : void 0,
            size: "small",
            ...mr(K, T.plural)
          }
        )
      ] })
    ] }),
    j()
  ] });
}
function bi(e) {
  const { permission: r, onUpdated: a, onDeleted: s, onError: n, onDismiss: d } = e, {
    form: l,
    updateField: m,
    errors: v,
    setFieldError: i,
    clearErrors: u,
    submitError: h,
    setSubmitError: g,
    hydrate: p
  } = He({ name: "", description: "" }), f = dn(), c = cn(), y = Ie(null);
  ne(() => {
    r && r.id !== y.current && (y.current = r.id, p({
      name: r.name,
      description: r.description ?? ""
    }));
  }, [r, p]);
  const b = !!r && (l.name !== r.name || l.description !== (r.description ?? "")), q = L(() => {
    if (!r) return;
    const N = l.name.trim(), x = Ee(N, "Name") ?? Fe(N, 2, "Name");
    if (x) {
      i("name", x);
      return;
    }
    u(), g(""), f.mutate(
      {
        resourceServerId: r.resourceServerId,
        permissionId: r.id,
        data: {
          name: N,
          description: l.description.trim() || void 0
        }
      },
      {
        onSuccess: (w) => {
          a == null || a(w), d == null || d();
        },
        onError: (w) => {
          console.error("Failed to update permission", w);
          const I = Xe(w) !== 403 ? "Failed to update permission. Please try again." : ir({ message: lr(w) });
          g(I), n == null || n(I);
        }
      }
    );
  }, [
    l,
    r,
    f,
    a,
    d,
    n,
    i,
    u,
    g
  ]), C = L(() => {
    r && c.mutate(
      {
        resourceServerId: r.resourceServerId,
        permissionId: r.id
      },
      {
        onSuccess: () => {
          s == null || s(), d == null || d();
        },
        onError: (N) => {
          console.error("Failed to delete permission", N);
          const x = "Failed to delete permission. Please try again.";
          g(x), n == null || n(x);
        }
      }
    );
  }, [r, c, s, d, n, g]);
  return {
    form: l,
    updateField: m,
    nameError: v.name ?? "",
    submitError: h,
    handleSubmit: q,
    handleDelete: C,
    isPending: f.isPending,
    isDeleting: c.isPending,
    isDirty: b
  };
}
function $l({
  visible: e,
  onHide: r,
  permission: a,
  onUpdated: s,
  onDeleted: n,
  className: d,
  style: l,
  pt: m
}) {
  var S;
  const [v, i] = U(!1), u = Oe(), h = (a == null ? void 0 : a.resourceServerId) === u.resourceServerId, { options: g } = yr({
    enabled: e && !h,
    currentId: a == null ? void 0 : a.resourceServerId
  }), p = h ? u.resourceServerName ?? u.resourceServerIdentifier : ((S = g.find((E) => E.value === (a == null ? void 0 : a.resourceServerId))) == null ? void 0 : S.label) ?? ((a == null ? void 0 : a.resourceServerId) != null ? `Resource server #${a.resourceServerId}` : "—"), {
    form: f,
    updateField: c,
    nameError: y,
    submitError: b,
    handleSubmit: q,
    handleDelete: C,
    isPending: N,
    isDeleting: x,
    isDirty: w
  } = bi({
    permission: a,
    onUpdated: s,
    onDeleted: n,
    onDismiss: r
  }), I = N || x;
  return /* @__PURE__ */ o(Ce, { children: [
    /* @__PURE__ */ t(
      fe,
      {
        visible: e,
        onHide: r,
        header: "Edit Permission",
        modal: !0,
        draggable: !1,
        resizable: !1,
        closable: !I,
        closeOnEscape: !I,
        className: d,
        style: { width: "32rem", ...l },
        pt: m,
        footer: /* @__PURE__ */ o("div", { className: "flex justify-between", children: [
          /* @__PURE__ */ t(
            G,
            {
              type: "button",
              label: "Delete",
              icon: "pi pi-trash",
              onClick: () => i(!0),
              severity: "danger",
              outlined: !0,
              disabled: I
            }
          ),
          /* @__PURE__ */ o("div", { className: "flex gap-3", children: [
            /* @__PURE__ */ t(
              G,
              {
                type: "button",
                label: "Cancel",
                onClick: r,
                severity: "secondary",
                outlined: !0,
                disabled: I
              }
            ),
            /* @__PURE__ */ t(
              G,
              {
                type: "button",
                label: "Save",
                icon: "pi pi-check",
                onClick: q,
                raised: !0,
                loading: N,
                disabled: !w || I
              }
            )
          ] })
        ] }),
        children: /* @__PURE__ */ o("div", { className: "flex flex-col gap-6", children: [
          /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
            /* @__PURE__ */ o(
              "label",
              {
                htmlFor: "edit-perm-name",
                className: "text-sm font-semibold text-[var(--clique-fg)]",
                children: [
                  "Name ",
                  /* @__PURE__ */ t("span", { className: "text-[var(--clique-destructive)]", children: "*" })
                ]
              }
            ),
            /* @__PURE__ */ t(
              me,
              {
                id: "edit-perm-name",
                value: f.name,
                onChange: (E) => c("name", E.target.value),
                placeholder: "Enter permission name",
                className: `w-full ${y ? "p-invalid" : ""}`,
                "aria-invalid": !!y,
                "aria-describedby": y ? "edit-perm-name-error" : void 0
              }
            ),
            y && /* @__PURE__ */ t("small", { id: "edit-perm-name-error", className: "text-[var(--clique-destructive)] text-xs", children: y })
          ] }),
          /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
            /* @__PURE__ */ t(
              "label",
              {
                htmlFor: "edit-perm-description",
                className: "text-sm font-semibold text-[var(--clique-fg)]",
                children: "Description"
              }
            ),
            /* @__PURE__ */ t(
              _e,
              {
                id: "edit-perm-description",
                value: f.description,
                onChange: (E) => c("description", E.target.value),
                placeholder: "Optional description",
                className: "w-full",
                rows: 3,
                autoResize: !0
              }
            )
          ] }),
          /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
            /* @__PURE__ */ t("span", { className: "text-sm font-semibold text-[var(--clique-fg)]", children: "Resource Server" }),
            /* @__PURE__ */ o("div", { className: "flex items-center gap-2 text-sm text-[var(--clique-fg-secondary)] bg-[var(--clique-bg)] border border-[var(--clique-border)] rounded-lg px-3 py-2.5", children: [
              /* @__PURE__ */ t("i", { "aria-hidden": "true", className: "pi pi-server text-xs" }),
              p
            ] }),
            /* @__PURE__ */ t("small", { className: "text-[var(--clique-fg-tertiary)] text-xs", children: "The resource server cannot be changed after creation." })
          ] }),
          b && /* @__PURE__ */ o("div", { className: "text-[var(--clique-destructive-strong)] text-sm bg-[var(--clique-destructive-subtle)] border border-[var(--clique-destructive-border)] rounded-lg p-3", children: [
            /* @__PURE__ */ t("i", { "aria-hidden": "true", className: "pi pi-exclamation-circle mr-2" }),
            b
          ] })
        ] })
      }
    ),
    /* @__PURE__ */ t(
      Ge,
      {
        visible: v,
        onHide: () => i(!1),
        header: "Delete Permission",
        message: `Are you sure you want to delete "${a == null ? void 0 : a.name}"? This action cannot be undone.`,
        confirmLabel: "Delete",
        rejectLabel: "Cancel",
        confirmSeverity: "danger",
        onConfirm: () => {
          i(!1), C();
        },
        loading: x
      }
    )
  ] });
}
const yi = ["name", "identifier"];
function xi(e) {
  const { canList: r, canCreate: a } = Ze("resourceServers"), s = je(e == null ? void 0 : e.namespaceId), { items: n, ...d } = xr({
    searchFields: yi,
    useList: (m) => Xr(m, { enabled: r }),
    useCount: (m) => mn(m, { enabled: r }),
    pageSize: e == null ? void 0 : e.pageSize,
    defaultSortField: e == null ? void 0 : e.defaultSortField,
    defaultSortOrder: e == null ? void 0 : e.defaultSortOrder,
    namespaceId: s
  }), { resourceServer: l } = Re();
  return { ...d, resourceServers: n, labels: l, canList: r, canCreate: a };
}
function Ni(e) {
  return [
    { field: "name", header: "Name", sortable: !0, className: "font-medium" },
    {
      field: "identifier",
      header: "Identifier",
      sortable: !0,
      body: (r) => /* @__PURE__ */ t("code", { className: "text-sm text-[var(--clique-fg-secondary)] bg-[var(--clique-bg)] px-2 py-0.5 rounded", children: r.identifier })
    },
    {
      field: "createdOn",
      header: "Created",
      sortable: !0,
      style: { width: "120px" },
      body: (r) => /* @__PURE__ */ t("span", { className: "text-[var(--clique-fg-tertiary)] text-xs", children: e.formatDate(r.createdOn) })
    }
  ];
}
function Ol({
  onResourceServerSelect: e,
  onCreateResourceServer: r,
  pageSize: a = 20,
  namespaceId: s,
  columns: n,
  toolbarActions: d,
  renderLoading: l,
  renderEmpty: m,
  renderError: v,
  renderAccessDenied: i,
  className: u,
  style: h,
  pt: g
}) {
  const p = fr(), f = Fr(), {
    resourceServers: c,
    totalCount: y,
    search: b,
    setSearch: q,
    page: C,
    setPage: N,
    pageSize: x,
    sortField: w,
    sortOrder: I,
    setSortField: S,
    setSortOrder: E,
    isInitialLoad: R,
    isLoading: P,
    isError: _,
    error: A,
    refetch: k,
    labels: T,
    canList: D,
    canCreate: K
  } = xi({ pageSize: a, namespaceId: s }), M = n ?? Ni(f), ee = L(
    ($) => {
      N($.page ?? 0);
    },
    [N]
  ), Q = L(
    ($) => {
      S($.sortField), E($.sortOrder === 1 ? 1 : -1), N(0);
    },
    [S, E, N]
  ), j = () => D ? R ? l ? l() : /* @__PURE__ */ t(xe, { message: `Loading ${T.plural}...` }) : _ ? v ? v(A, k) : /* @__PURE__ */ t(he, { error: A, resourceLabel: T.plural, onRetry: k }) : (c == null ? void 0 : c.length) === 0 && !b ? m ? m() : /* @__PURE__ */ t(
    Je,
    {
      icon: p.resourceServer,
      title: `No ${T.plural} yet`,
      message: `Create ${T.withArticle} to organize permissions and access roles.`,
      actionLabel: r && K ? `Create ${T.singularTitle}` : void 0,
      onAction: K ? r : void 0
    }
  ) : /* @__PURE__ */ t(
    Ae,
    {
      value: c ?? [],
      lazy: !0,
      paginator: !0,
      rows: x,
      totalRecords: y ?? 0,
      first: C * x,
      onPage: ee,
      sortField: w,
      sortOrder: I,
      onSort: Q,
      loading: P,
      dataKey: "id",
      emptyMessage: `No ${T.plural} match your search.`,
      selectionMode: "single",
      onSelectionChange: ($) => {
        $.value && (e == null || e($.value));
      },
      rowHover: !0,
      stripedRows: !0,
      className: "rounded-lg border border-[var(--clique-border)] overflow-hidden",
      pt: g,
      rowClassName: () => e ? "cursor-pointer" : "",
      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport",
      currentPageReportTemplate: `Showing {first} to {last} of {totalRecords} ${T.plural}`,
      children: M.map(($) => /* @__PURE__ */ t(
        X,
        {
          field: $.field,
          header: $.header,
          sortable: $.sortable,
          className: $.className,
          style: $.style,
          body: $.body
        },
        $.field
      ))
    }
  ) : i ? i() : /* @__PURE__ */ t(ur, { resourceLabel: T.plural });
  return /* @__PURE__ */ o("div", { className: be(u), style: h, children: [
    /* @__PURE__ */ o("div", { className: "flex items-center justify-between mb-4 gap-4", children: [
      /* @__PURE__ */ t(
        cr,
        {
          value: b,
          onChange: q,
          placeholder: `Search ${T.plural} by name or identifier...`,
          className: "flex-1 max-w-md"
        }
      ),
      /* @__PURE__ */ o("div", { className: "flex items-center gap-2", children: [
        d,
        r && /* @__PURE__ */ t(
          G,
          {
            type: "button",
            label: `New ${T.singularTitle}`,
            icon: p.create,
            onClick: K ? r : void 0,
            size: "small",
            ...mr(K, T.plural)
          }
        )
      ] })
    ] }),
    j()
  ] });
}
function Ii(e) {
  const { resourceServer: r, onUpdated: a, onDeleted: s, onError: n, onDismiss: d } = e, l = je(), {
    form: m,
    updateField: v,
    errors: i,
    setFieldError: u,
    clearErrors: h,
    submitError: g,
    setSubmitError: p,
    hydrate: f
  } = He({ name: "", identifier: "", namespaceId: null }), c = gn(), y = vn(), b = Ie(null);
  ne(() => {
    r && r.id !== b.current && (b.current = r.id, f({
      name: r.name,
      identifier: r.identifier,
      namespaceId: r.namespaceId ?? null
    }));
  }, [r, f]);
  const q = !!r && (m.name !== r.name || m.identifier !== r.identifier || m.namespaceId !== (r.namespaceId ?? null)), C = L(() => {
    if (!r) return;
    const x = m.name.trim(), w = m.identifier.trim();
    let I = !1;
    const S = Ee(x, "Name") ?? Fe(x, 2, "Name");
    S && (u("name", S), I = !0);
    const E = Ee(w, "Identifier") ?? Fe(w, 2, "Identifier");
    E && (u("identifier", E), I = !0), !I && (h(), p(""), c.mutate(
      {
        resourceServerId: r.id,
        data: { name: x, identifier: w, namespaceId: m.namespaceId }
      },
      {
        onSuccess: () => {
          a == null || a({
            ...r,
            name: x,
            identifier: w,
            namespaceId: m.namespaceId
          }), d == null || d();
        },
        onError: (R) => {
          console.error("Failed to update resource server", R);
          const P = "Failed to update resource server. Please try again.";
          p(P), n == null || n(P);
        }
      }
    ));
  }, [
    m,
    r,
    c,
    a,
    d,
    n,
    u,
    h,
    p
  ]), N = L(() => {
    r && y.mutate(r.id, {
      onSuccess: () => {
        s == null || s(), d == null || d();
      },
      onError: (x) => {
        console.error("Failed to delete resource server", x);
        const w = "Failed to delete resource server. Please try again.";
        p(w), n == null || n(w);
      }
    });
  }, [r, y, s, d, n, p]);
  return {
    form: m,
    updateField: v,
    nameError: i.name ?? "",
    identifierError: i.identifier ?? "",
    submitError: g,
    handleSubmit: C,
    handleDelete: N,
    isPending: c.isPending,
    isDeleting: y.isPending,
    isDirty: q,
    namespaceLocked: l != null
  };
}
function _l({
  visible: e,
  onHide: r,
  resourceServer: a,
  onUpdated: s,
  onDeleted: n,
  className: d,
  style: l,
  pt: m
}) {
  const [v, i] = U(!1), {
    form: u,
    updateField: h,
    nameError: g,
    identifierError: p,
    submitError: f,
    handleSubmit: c,
    handleDelete: y,
    isPending: b,
    isDeleting: q,
    isDirty: C,
    namespaceLocked: N
  } = Ii({
    resourceServer: a,
    onUpdated: s,
    onDeleted: n,
    onDismiss: r
  }), x = b || q;
  return /* @__PURE__ */ o(Ce, { children: [
    /* @__PURE__ */ t(
      fe,
      {
        visible: e,
        onHide: r,
        header: "Edit Resource Server",
        modal: !0,
        draggable: !1,
        resizable: !1,
        closable: !x,
        closeOnEscape: !x,
        className: d,
        style: { width: "32rem", ...l },
        pt: m,
        footer: /* @__PURE__ */ o("div", { className: "flex justify-between", children: [
          /* @__PURE__ */ t(
            G,
            {
              type: "button",
              label: "Delete",
              icon: "pi pi-trash",
              onClick: () => i(!0),
              severity: "danger",
              outlined: !0,
              disabled: x
            }
          ),
          /* @__PURE__ */ o("div", { className: "flex gap-3", children: [
            /* @__PURE__ */ t(
              G,
              {
                type: "button",
                label: "Cancel",
                onClick: r,
                severity: "secondary",
                outlined: !0,
                disabled: x
              }
            ),
            /* @__PURE__ */ t(
              G,
              {
                type: "button",
                label: "Save",
                icon: "pi pi-check",
                onClick: c,
                raised: !0,
                loading: b,
                disabled: !C || x
              }
            )
          ] })
        ] }),
        children: /* @__PURE__ */ o("div", { className: "flex flex-col gap-6", children: [
          /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
            /* @__PURE__ */ o("label", { htmlFor: "edit-rs-name", className: "text-sm font-semibold text-[var(--clique-fg)]", children: [
              "Name ",
              /* @__PURE__ */ t("span", { className: "text-[var(--clique-destructive)]", children: "*" })
            ] }),
            /* @__PURE__ */ t(
              me,
              {
                id: "edit-rs-name",
                value: u.name,
                onChange: (w) => h("name", w.target.value),
                placeholder: "Enter resource server name",
                className: `w-full ${g ? "p-invalid" : ""}`,
                "aria-invalid": !!g,
                "aria-describedby": g ? "edit-rs-name-error" : void 0
              }
            ),
            g && /* @__PURE__ */ t("small", { id: "edit-rs-name-error", className: "text-[var(--clique-destructive)] text-xs", children: g })
          ] }),
          /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
            /* @__PURE__ */ o(
              "label",
              {
                htmlFor: "edit-rs-identifier",
                className: "text-sm font-semibold text-[var(--clique-fg)]",
                children: [
                  "Identifier ",
                  /* @__PURE__ */ t("span", { className: "text-[var(--clique-destructive)]", children: "*" })
                ]
              }
            ),
            /* @__PURE__ */ t(
              me,
              {
                id: "edit-rs-identifier",
                value: u.identifier,
                onChange: (w) => h("identifier", w.target.value),
                placeholder: "Enter identifier",
                className: `w-full ${p ? "p-invalid" : ""}`,
                "aria-invalid": !!p,
                "aria-describedby": p ? "edit-rs-identifier-error" : void 0
              }
            ),
            p && /* @__PURE__ */ t(
              "small",
              {
                id: "edit-rs-identifier-error",
                className: "text-[var(--clique-destructive)] text-xs",
                children: p
              }
            )
          ] }),
          /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
            /* @__PURE__ */ t(
              "label",
              {
                htmlFor: "edit-rs-namespace",
                className: "text-sm font-semibold text-[var(--clique-fg)]",
                children: "Namespace"
              }
            ),
            /* @__PURE__ */ t(
              Pr,
              {
                id: "edit-rs-namespace",
                value: u.namespaceId,
                onChange: (w) => h("namespaceId", w),
                disabled: N || x,
                enabled: e
              }
            )
          ] }),
          f && /* @__PURE__ */ o("div", { className: "text-[var(--clique-destructive-strong)] text-sm bg-[var(--clique-destructive-subtle)] border border-[var(--clique-destructive-border)] rounded-lg p-3", children: [
            /* @__PURE__ */ t("i", { "aria-hidden": "true", className: "pi pi-exclamation-circle mr-2" }),
            f
          ] })
        ] })
      }
    ),
    /* @__PURE__ */ t(
      Ge,
      {
        visible: v,
        onHide: () => i(!1),
        header: "Delete Resource Server",
        message: `Are you sure you want to delete "${a == null ? void 0 : a.name}"? This will also remove all associated permissions and roles. This action cannot be undone.`,
        confirmLabel: "Delete",
        rejectLabel: "Cancel",
        confirmSeverity: "danger",
        onConfirm: () => {
          i(!1), y();
        },
        loading: q
      }
    )
  ] });
}
const Si = ["name", "description"];
function qi(e) {
  const { canList: r, canCreate: a } = Ze("umrsRoles"), { items: s, ...n } = xr({
    searchFields: Si,
    useList: (l) => Gt(l, { enabled: r }),
    useCount: (l) => fn(l, { enabled: r }),
    pageSize: e == null ? void 0 : e.pageSize,
    defaultSortField: e == null ? void 0 : e.defaultSortField,
    defaultSortOrder: e == null ? void 0 : e.defaultSortOrder
  }), { umrsRole: d } = Re();
  return { ...n, umrsRoles: s, labels: d, canList: r, canCreate: a };
}
function Ci(e) {
  return [
    { field: "name", header: "Name", sortable: !0, className: "font-medium" },
    {
      field: "description",
      header: "Description",
      sortable: !0,
      body: (r) => /* @__PURE__ */ t("span", { className: "text-[var(--clique-fg-secondary)]", children: r.description || "—" })
    },
    {
      field: "allowExtensionRequest",
      header: "Extension Requests",
      style: { width: "160px" },
      body: (r) => r.allowExtensionRequest ? /* @__PURE__ */ t(ce, { value: "Allowed", severity: "success", icon: "pi pi-check" }) : null
    },
    {
      field: "createdOn",
      header: "Created",
      sortable: !0,
      style: { width: "120px" },
      body: (r) => /* @__PURE__ */ t("span", { className: "text-[var(--clique-fg-tertiary)] text-xs", children: e.formatDate(r.createdOn) })
    }
  ];
}
function zl({
  onUmrsRoleSelect: e,
  onCreateUmrsRole: r,
  pageSize: a = 20,
  columns: s,
  toolbarActions: n,
  renderLoading: d,
  renderEmpty: l,
  renderError: m,
  renderAccessDenied: v,
  className: i,
  style: u,
  pt: h
}) {
  const g = fr(), p = Fr(), {
    umrsRoles: f,
    totalCount: c,
    search: y,
    setSearch: b,
    page: q,
    setPage: C,
    pageSize: N,
    sortField: x,
    sortOrder: w,
    setSortField: I,
    setSortOrder: S,
    isInitialLoad: E,
    isLoading: R,
    isError: P,
    error: _,
    refetch: A,
    labels: k,
    canList: T,
    canCreate: D
  } = qi({ pageSize: a }), K = s ?? Ci(p), M = L(
    (j) => {
      C(j.page ?? 0);
    },
    [C]
  ), ee = L(
    (j) => {
      I(j.sortField), S(j.sortOrder === 1 ? 1 : -1), C(0);
    },
    [I, S, C]
  ), Q = () => T ? E ? d ? d() : /* @__PURE__ */ t(xe, { message: `Loading ${k.plural}...` }) : P ? m ? m(_, A) : /* @__PURE__ */ t(he, { error: _, resourceLabel: k.plural, onRetry: A }) : (f == null ? void 0 : f.length) === 0 && !y ? l ? l() : /* @__PURE__ */ t(
    Je,
    {
      icon: g.umrsRole,
      title: `No ${k.plural} yet`,
      message: `Create ${k.withArticle} to start managing access.`,
      actionLabel: r && D ? `Create ${k.singularTitle}` : void 0,
      onAction: D ? r : void 0
    }
  ) : /* @__PURE__ */ t(
    Ae,
    {
      value: f ?? [],
      lazy: !0,
      paginator: !0,
      rows: N,
      totalRecords: c ?? 0,
      first: q * N,
      onPage: M,
      sortField: x,
      sortOrder: w,
      onSort: ee,
      loading: R,
      dataKey: "id",
      emptyMessage: `No ${k.plural} match your search.`,
      selectionMode: "single",
      onSelectionChange: (j) => {
        j.value && (e == null || e(j.value));
      },
      rowHover: !0,
      stripedRows: !0,
      className: "rounded-lg border border-[var(--clique-border)] overflow-hidden",
      pt: h,
      rowClassName: () => e ? "cursor-pointer" : "",
      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport",
      currentPageReportTemplate: `Showing {first} to {last} of {totalRecords} ${k.plural}`,
      children: K.map((j) => /* @__PURE__ */ t(
        X,
        {
          field: j.field,
          header: j.header,
          sortable: j.sortable,
          className: j.className,
          style: j.style,
          body: j.body
        },
        j.field
      ))
    }
  ) : v ? v() : /* @__PURE__ */ t(ur, { resourceLabel: k.plural });
  return /* @__PURE__ */ o("div", { className: be(i), style: u, children: [
    /* @__PURE__ */ o("div", { className: "flex items-center justify-between mb-4 gap-4", children: [
      /* @__PURE__ */ t(
        cr,
        {
          value: y,
          onChange: b,
          placeholder: `Search ${k.plural} by name or description...`,
          className: "flex-1 max-w-md"
        }
      ),
      /* @__PURE__ */ o("div", { className: "flex items-center gap-2", children: [
        n,
        r && /* @__PURE__ */ t(
          G,
          {
            type: "button",
            label: `New ${k.singularTitle}`,
            icon: g.create,
            onClick: D ? r : void 0,
            size: "small",
            ...mr(D, k.plural)
          }
        )
      ] })
    ] }),
    Q()
  ] });
}
const wi = {
  name: "",
  description: "",
  resourceServerId: null,
  managersGroupId: null,
  allowExtensionRequest: !1
};
function Ri(e) {
  const { onCreated: r, onError: a, onDismiss: s } = e ?? {}, {
    form: n,
    updateField: d,
    errors: l,
    setFieldError: m,
    clearErrors: v,
    submitError: i,
    setSubmitError: u,
    reset: h
  } = He(wi), g = hn(), p = L(() => {
    const f = n.name.trim();
    let c = !1;
    const y = Ee(f, "Name") ?? Fe(f, 2, "Name");
    y && (m("name", y), c = !0), n.resourceServerId === null && (m("resourceServerId", "Resource server is required."), c = !0), !c && (v(), u(""), g.mutate(
      {
        name: f,
        description: n.description.trim() || void 0,
        resourceServerId: n.resourceServerId,
        ...n.managersGroupId !== null ? { managersGroupId: n.managersGroupId } : {},
        allowExtensionRequest: n.allowExtensionRequest
      },
      {
        onSuccess: (b) => {
          r == null || r(b), s == null || s();
        },
        onError: (b) => {
          console.error("Failed to create UMRS role", b);
          const q = "Failed to create UMRS role. Please try again.";
          u(q), a == null || a(q);
        }
      }
    ));
  }, [
    n,
    g,
    r,
    s,
    a,
    m,
    v,
    u
  ]);
  return {
    form: n,
    updateField: d,
    nameError: l.name ?? "",
    resourceServerError: l.resourceServerId ?? "",
    submitError: i,
    resetForm: h,
    handleSubmit: p,
    isPending: g.isPending
  };
}
function Kl({
  visible: e,
  onHide: r,
  onCreated: a,
  className: s,
  style: n,
  pt: d
}) {
  const l = Ie(null), m = Oe(), {
    options: v,
    isLoading: i,
    isError: u,
    error: h,
    locked: g
  } = yr({ enabled: e }), { data: p, isLoading: f } = dr(
    { limit: 500, order: "name ASC" },
    { enabled: e }
  ), c = Ri({
    onCreated: a,
    onDismiss: r
  }), {
    form: y,
    updateField: b,
    nameError: q,
    resourceServerError: C,
    submitError: N,
    resetForm: x,
    handleSubmit: w,
    isPending: I
  } = c, S = m.showSelector && !g, E = Jr({
    isPending: I,
    selectorInteractive: S,
    isResolving: m.isResolving,
    resolutionError: m.resolutionError,
    isLoadingOptions: i,
    isOptionsError: u,
    selectedId: y.resourceServerId,
    options: v
  }), R = (p ?? []).map((P) => ({
    label: P.name,
    value: P.id
  }));
  return ne(() => {
    e && (x(), setTimeout(() => {
      var P;
      return (P = l.current) == null ? void 0 : P.focus();
    }, 100));
  }, [e, x]), ne(() => {
    !e || m.resourceServerId == null || y.resourceServerId != null || b("resourceServerId", m.resourceServerId);
  }, [e, m.resourceServerId, y.resourceServerId, b]), /* @__PURE__ */ t(
    fe,
    {
      visible: e,
      onHide: r,
      header: "Create UMRS Role",
      modal: !0,
      draggable: !1,
      resizable: !1,
      closable: !I,
      closeOnEscape: !I,
      className: s,
      style: { width: "32rem", ...n },
      pt: d,
      footer: /* @__PURE__ */ o("div", { className: "flex justify-end gap-3", children: [
        /* @__PURE__ */ t(
          G,
          {
            type: "button",
            label: "Cancel",
            onClick: r,
            severity: "secondary",
            outlined: !0,
            disabled: I
          }
        ),
        /* @__PURE__ */ t(
          G,
          {
            type: "button",
            label: "Create",
            icon: "pi pi-check",
            onClick: w,
            raised: !0,
            loading: I || (S ? i : m.isResolving),
            disabled: E
          }
        )
      ] }),
      children: /* @__PURE__ */ o("div", { className: "flex flex-col gap-6", children: [
        /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
          /* @__PURE__ */ o("label", { htmlFor: "umrs-role-name", className: "text-sm font-semibold text-[var(--clique-fg)]", children: [
            "Name ",
            /* @__PURE__ */ t("span", { className: "text-[var(--clique-destructive)]", children: "*" })
          ] }),
          /* @__PURE__ */ t(
            me,
            {
              id: "umrs-role-name",
              ref: l,
              value: y.name,
              onChange: (P) => b("name", P.target.value),
              placeholder: "Enter UMRS role name",
              className: `w-full ${q ? "p-invalid" : ""}`,
              "aria-invalid": !!q,
              "aria-describedby": q ? "umrs-role-name-error" : void 0
            }
          ),
          q && /* @__PURE__ */ t("small", { id: "umrs-role-name-error", className: "text-[var(--clique-destructive)] text-xs", children: q })
        ] }),
        /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
          /* @__PURE__ */ t(
            "label",
            {
              htmlFor: "umrs-role-description",
              className: "text-sm font-semibold text-[var(--clique-fg)]",
              children: "Description"
            }
          ),
          /* @__PURE__ */ t(
            _e,
            {
              id: "umrs-role-description",
              value: y.description,
              onChange: (P) => b("description", P.target.value),
              placeholder: "Optional description",
              className: "w-full",
              rows: 3,
              autoResize: !0
            }
          )
        ] }),
        m.showSelector && /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
          /* @__PURE__ */ o(
            "label",
            {
              htmlFor: "umrs-role-resource-server",
              className: "text-sm font-semibold text-[var(--clique-fg)]",
              children: [
                "Resource Server ",
                /* @__PURE__ */ t("span", { className: "text-[var(--clique-destructive)]", children: "*" })
              ]
            }
          ),
          /* @__PURE__ */ t(
            ge,
            {
              inputId: "umrs-role-resource-server",
              value: y.resourceServerId,
              options: v,
              onChange: (P) => b("resourceServerId", P.value),
              placeholder: "Select a resource server",
              className: `w-full ${C ? "p-invalid" : ""}`,
              loading: i,
              disabled: g,
              filter: !0,
              emptyMessage: "No resource servers available"
            }
          ),
          C && /* @__PURE__ */ t("small", { className: "text-[var(--clique-destructive)] text-xs", children: C }),
          u && /* @__PURE__ */ t("small", { className: "text-[var(--clique-destructive)] text-xs", children: h instanceof Error ? h.message : "Failed to load resource servers" })
        ] }),
        /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
          /* @__PURE__ */ t(
            "label",
            {
              htmlFor: "umrs-role-managers-group",
              className: "text-sm font-semibold text-[var(--clique-fg)]",
              children: "Managers Group"
            }
          ),
          /* @__PURE__ */ t(
            ge,
            {
              inputId: "umrs-role-managers-group",
              value: y.managersGroupId,
              options: R,
              onChange: (P) => b("managersGroupId", P.value),
              placeholder: "Select a managers group",
              className: "w-full",
              loading: f,
              filter: !0,
              showClear: !0,
              emptyMessage: "No groups available"
            }
          )
        ] }),
        /* @__PURE__ */ o("fieldset", { className: "border-t border-[var(--clique-border)] pt-5 flex flex-col gap-4", children: [
          /* @__PURE__ */ t("legend", { className: "text-sm font-semibold text-[var(--clique-fg)] pr-2", children: "Options" }),
          /* @__PURE__ */ o("div", { className: "flex items-center gap-3", children: [
            /* @__PURE__ */ t(
              Ye,
              {
                inputId: "umrs-role-extension",
                checked: y.allowExtensionRequest,
                onChange: (P) => b("allowExtensionRequest", P.checked ?? !1)
              }
            ),
            /* @__PURE__ */ t(
              "label",
              {
                htmlFor: "umrs-role-extension",
                className: "text-sm text-[var(--clique-fg)] cursor-pointer",
                children: "Allow extension requests"
              }
            )
          ] })
        ] }),
        !S && m.resolutionError && /* @__PURE__ */ o(
          "div",
          {
            role: "alert",
            className: "text-[var(--clique-destructive-strong)] text-sm bg-[var(--clique-destructive-subtle)] border border-[var(--clique-destructive-border)] rounded-lg p-3",
            children: [
              /* @__PURE__ */ t("i", { "aria-hidden": "true", className: "pi pi-exclamation-circle mr-2" }),
              m.resolutionError
            ]
          }
        ),
        N && /* @__PURE__ */ o("div", { className: "text-[var(--clique-destructive-strong)] text-sm bg-[var(--clique-destructive-subtle)] border border-[var(--clique-destructive-border)] rounded-lg p-3", children: [
          /* @__PURE__ */ t("i", { "aria-hidden": "true", className: "pi pi-exclamation-circle mr-2" }),
          N
        ] })
      ] })
    }
  );
}
function Ei(e) {
  const { umrsRoleId: r, onSuccess: a, onError: s } = e, {
    data: n,
    isLoading: d,
    isError: l,
    error: m,
    refetch: v
  } = In(), {
    data: i,
    isLoading: u,
    isError: h,
    error: g,
    refetch: p
  } = Sn(), f = Ut(), c = Mt(), [y, b] = U(!1), [q, C] = U(!1), [N, x] = U(null), w = re(() => !n || r === null ? [] : n.filter((R) => R.umrsRoleId === r), [n, r]), I = re(() => !i || r === null ? [] : i.filter((R) => R.umrsRoleId === r), [i, r]), S = L(() => {
    v(), p();
  }, [v, p]), E = L(() => {
    if (!N) return;
    (N.type === "user" ? f : c).mutate(N.id, {
      onSuccess: () => {
        a == null || a(`Grant revoked for ${N.name}.`), x(null);
      },
      onError: (P) => {
        console.error("Failed to revoke grant", P), s == null || s("Failed to revoke grant. Please try again.");
      }
    });
  }, [N, f, c, a, s]);
  return {
    userGrants: w,
    groupGrants: I,
    isLoading: d || u,
    isError: l || h,
    error: m ?? g,
    refetch: S,
    showAssignUserDialog: y,
    setShowAssignUserDialog: b,
    showAssignGroupDialog: q,
    setShowAssignGroupDialog: C,
    grantToRevoke: N,
    setGrantToRevoke: x,
    handleRevoke: E,
    isRevoking: f.isPending || c.isPending
  };
}
function mt(e) {
  return e ? new Date(e).toLocaleDateString(void 0, {
    year: "numeric",
    month: "short",
    day: "numeric"
  }) : "—";
}
function Fi({
  umrsRoleId: e,
  onSuccess: r,
  onError: a,
  className: s,
  style: n,
  pt: d
}) {
  var f;
  const l = Ei({ umrsRoleId: e, onSuccess: r, onError: a });
  if (!e) return null;
  const m = (c) => c.userEmail || `User #${c.userId}`, v = (c) => c.userEmail ?? "—", i = (c) => c.groupName ?? `Group #${c.groupId}`, u = (c) => mt(c.expiresAt ?? void 0), h = (c) => mt(c.expiresAt ?? void 0), g = (c) => /* @__PURE__ */ t(
    G,
    {
      type: "button",
      icon: "pi pi-trash",
      onClick: () => l.setGrantToRevoke({
        id: c.id,
        type: "user",
        name: c.userEmail || `User #${c.userId}`
      }),
      severity: "danger",
      text: !0,
      rounded: !0,
      size: "small",
      "aria-label": "Revoke grant"
    }
  ), p = (c) => /* @__PURE__ */ t(
    G,
    {
      type: "button",
      icon: "pi pi-trash",
      onClick: () => l.setGrantToRevoke({
        id: c.id,
        type: "group",
        name: c.groupName || `Group #${c.groupId}`
      }),
      severity: "danger",
      text: !0,
      rounded: !0,
      size: "small",
      "aria-label": "Revoke grant"
    }
  );
  return /* @__PURE__ */ o("div", { className: be("mt-6", s), style: n, children: [
    /* @__PURE__ */ o("div", { className: "border-t border-[var(--clique-border)] pt-5", children: [
      /* @__PURE__ */ o("div", { className: "flex items-center justify-between mb-4", children: [
        /* @__PURE__ */ t("h4", { className: "text-base font-semibold text-[var(--clique-fg)]", children: "Assigned Users" }),
        /* @__PURE__ */ t(
          G,
          {
            type: "button",
            label: "Assign to User",
            icon: "pi pi-plus",
            onClick: () => l.setShowAssignUserDialog(!0),
            size: "small",
            outlined: !0
          }
        )
      ] }),
      l.isLoading ? /* @__PURE__ */ t(xe, { message: "Loading grants..." }) : l.isError ? /* @__PURE__ */ t(
        he,
        {
          error: l.error,
          resourceLabel: "grants",
          onRetry: l.refetch
        }
      ) : l.userGrants.length === 0 ? /* @__PURE__ */ t("p", { className: "text-sm text-[var(--clique-fg-secondary)] py-3", children: "No users have been assigned this role." }) : /* @__PURE__ */ o(
        Ae,
        {
          value: l.userGrants,
          size: "small",
          stripedRows: !0,
          pt: d,
          emptyMessage: "No user grants found.",
          children: [
            /* @__PURE__ */ t(X, { header: "User", body: m }),
            /* @__PURE__ */ t(X, { header: "Email", body: v }),
            /* @__PURE__ */ t(X, { header: "Expires", body: u, style: { width: "8rem" } }),
            /* @__PURE__ */ t(X, { body: g, style: { width: "4rem" } })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ o("div", { className: "border-t border-[var(--clique-border)] pt-5 mt-5", children: [
      /* @__PURE__ */ o("div", { className: "flex items-center justify-between mb-4", children: [
        /* @__PURE__ */ t("h4", { className: "text-base font-semibold text-[var(--clique-fg)]", children: "Assigned Groups" }),
        /* @__PURE__ */ t(
          G,
          {
            type: "button",
            label: "Assign to Group",
            icon: "pi pi-plus",
            onClick: () => l.setShowAssignGroupDialog(!0),
            size: "small",
            outlined: !0
          }
        )
      ] }),
      !l.isLoading && !l.isError && l.groupGrants.length === 0 ? /* @__PURE__ */ t("p", { className: "text-sm text-[var(--clique-fg-secondary)] py-3", children: "No groups have been assigned this role." }) : !l.isLoading && !l.isError ? /* @__PURE__ */ o(
        Ae,
        {
          value: l.groupGrants,
          size: "small",
          stripedRows: !0,
          pt: d,
          emptyMessage: "No group grants found.",
          children: [
            /* @__PURE__ */ t(X, { header: "Group", body: i }),
            /* @__PURE__ */ t(X, { header: "Expires", body: h, style: { width: "8rem" } }),
            /* @__PURE__ */ t(X, { body: p, style: { width: "4rem" } })
          ]
        }
      ) : null
    ] }),
    /* @__PURE__ */ t(
      Or,
      {
        visible: l.showAssignUserDialog,
        onHide: () => l.setShowAssignUserDialog(!1),
        assignTo: "user",
        preselectedRoleId: e,
        onAssigned: l.refetch,
        onSuccess: r,
        onError: a
      }
    ),
    /* @__PURE__ */ t(
      Or,
      {
        visible: l.showAssignGroupDialog,
        onHide: () => l.setShowAssignGroupDialog(!1),
        assignTo: "group",
        preselectedRoleId: e,
        onAssigned: l.refetch,
        onSuccess: r,
        onError: a
      }
    ),
    /* @__PURE__ */ t(
      Ge,
      {
        visible: l.grantToRevoke !== null,
        onHide: () => l.setGrantToRevoke(null),
        onConfirm: l.handleRevoke,
        header: "Revoke Grant",
        message: `Are you sure you want to revoke the grant for "${(f = l.grantToRevoke) == null ? void 0 : f.name}"?`,
        confirmLabel: "Revoke",
        confirmSeverity: "danger",
        loading: l.isRevoking
      }
    )
  ] });
}
function Ai(e) {
  const { umrsRole: r, onUpdated: a, onDeleted: s, onError: n, onDismiss: d } = e, {
    form: l,
    updateField: m,
    errors: v,
    setFieldError: i,
    clearErrors: u,
    submitError: h,
    setSubmitError: g,
    hydrate: p
  } = He({
    name: "",
    description: "",
    resourceServerId: null,
    managersGroupId: null,
    allowExtensionRequest: !1
  }), f = bn(), c = yn(), y = Ie(null);
  ne(() => {
    r && r.id !== y.current && (y.current = r.id, p({
      name: r.name,
      description: r.description ?? "",
      resourceServerId: r.resourceServerId,
      managersGroupId: r.managersGroupId,
      allowExtensionRequest: r.allowExtensionRequest
    }));
  }, [r, p]);
  const b = !!r && (l.name !== r.name || l.description !== (r.description ?? "") || l.resourceServerId !== r.resourceServerId || l.managersGroupId !== r.managersGroupId || l.allowExtensionRequest !== r.allowExtensionRequest), q = L(() => {
    if (!r) return;
    const N = l.name.trim();
    let x = !1;
    const w = Ee(N, "Name") ?? Fe(N, 2, "Name");
    if (w && (i("name", w), x = !0), l.resourceServerId === null && (i("resourceServerId", "Resource server is required."), x = !0), x || l.resourceServerId === null) return;
    const I = l.resourceServerId, S = l.description.trim(), E = l.managersGroupId;
    u(), g(""), f.mutate(
      {
        umrsRoleId: r.id,
        data: {
          name: N,
          description: S,
          resourceServerId: I,
          managersGroupId: E,
          allowExtensionRequest: l.allowExtensionRequest
        }
      },
      {
        onSuccess: () => {
          a == null || a({
            ...r,
            name: N,
            description: S,
            resourceServerId: I,
            managersGroupId: E,
            allowExtensionRequest: l.allowExtensionRequest
          }), d == null || d();
        },
        onError: (R) => {
          console.error("Failed to update UMRS role", R);
          const P = "Failed to update UMRS role. Please try again.";
          g(P), n == null || n(P);
        }
      }
    );
  }, [
    l,
    r,
    f,
    a,
    d,
    n,
    i,
    u,
    g
  ]), C = L(() => {
    r && c.mutate(r.id, {
      onSuccess: () => {
        s == null || s(), d == null || d();
      },
      onError: (N) => {
        console.error("Failed to delete UMRS role", N);
        const x = "Failed to delete UMRS role. Please try again.";
        g(x), n == null || n(x);
      }
    });
  }, [r, c, s, d, n, g]);
  return {
    form: l,
    updateField: m,
    nameError: v.name ?? "",
    resourceServerError: v.resourceServerId ?? "",
    submitError: h,
    handleSubmit: q,
    handleDelete: C,
    isPending: f.isPending,
    isDeleting: c.isPending,
    isDirty: b
  };
}
function Ql({
  visible: e,
  onHide: r,
  umrsRole: a,
  onUpdated: s,
  onDeleted: n,
  onSuccess: d,
  onError: l,
  className: m,
  style: v,
  pt: i
}) {
  const [u, h] = U(!1), g = Oe(), {
    options: p,
    isLoading: f,
    isError: c,
    error: y,
    locked: b
  } = yr({
    enabled: e,
    currentId: a == null ? void 0 : a.resourceServerId
  }), { data: q, isLoading: C } = dr(
    { limit: 500, order: "name ASC" },
    { enabled: e }
  ), {
    form: N,
    updateField: x,
    nameError: w,
    resourceServerError: I,
    submitError: S,
    handleSubmit: E,
    handleDelete: R,
    isPending: P,
    isDeleting: _,
    isDirty: A
  } = Ai({
    umrsRole: a,
    onUpdated: s,
    onDeleted: n,
    onDismiss: r
  }), k = P || _, T = (q ?? []).map((D) => ({
    label: D.name,
    value: D.id
  }));
  return /* @__PURE__ */ o(Ce, { children: [
    /* @__PURE__ */ t(
      fe,
      {
        visible: e,
        onHide: r,
        header: "Edit UMRS Role",
        modal: !0,
        draggable: !1,
        resizable: !1,
        closable: !k,
        closeOnEscape: !k,
        maximizable: !0,
        className: m,
        style: { width: "48rem", ...v },
        pt: i,
        footer: /* @__PURE__ */ o("div", { className: "flex justify-between", children: [
          /* @__PURE__ */ t(
            G,
            {
              type: "button",
              label: "Delete",
              icon: "pi pi-trash",
              onClick: () => h(!0),
              severity: "danger",
              outlined: !0,
              disabled: k
            }
          ),
          /* @__PURE__ */ o("div", { className: "flex gap-3", children: [
            /* @__PURE__ */ t(
              G,
              {
                type: "button",
                label: "Cancel",
                onClick: r,
                severity: "secondary",
                outlined: !0,
                disabled: k
              }
            ),
            /* @__PURE__ */ t(
              G,
              {
                type: "button",
                label: "Save",
                icon: "pi pi-check",
                onClick: E,
                raised: !0,
                loading: P,
                disabled: !A || k
              }
            )
          ] })
        ] }),
        children: /* @__PURE__ */ o("div", { className: "flex flex-col gap-6", children: [
          /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
            /* @__PURE__ */ o(
              "label",
              {
                htmlFor: "edit-umrs-role-name",
                className: "text-sm font-semibold text-[var(--clique-fg)]",
                children: [
                  "Name ",
                  /* @__PURE__ */ t("span", { className: "text-[var(--clique-destructive)]", children: "*" })
                ]
              }
            ),
            /* @__PURE__ */ t(
              me,
              {
                id: "edit-umrs-role-name",
                value: N.name,
                onChange: (D) => x("name", D.target.value),
                placeholder: "Enter UMRS role name",
                className: `w-full ${w ? "p-invalid" : ""}`,
                "aria-invalid": !!w,
                "aria-describedby": w ? "edit-umrs-role-name-error" : void 0
              }
            ),
            w && /* @__PURE__ */ t(
              "small",
              {
                id: "edit-umrs-role-name-error",
                className: "text-[var(--clique-destructive)] text-xs",
                children: w
              }
            )
          ] }),
          /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
            /* @__PURE__ */ t(
              "label",
              {
                htmlFor: "edit-umrs-role-description",
                className: "text-sm font-semibold text-[var(--clique-fg)]",
                children: "Description"
              }
            ),
            /* @__PURE__ */ t(
              _e,
              {
                id: "edit-umrs-role-description",
                value: N.description,
                onChange: (D) => x("description", D.target.value),
                placeholder: "Optional description",
                className: "w-full",
                rows: 3,
                autoResize: !0
              }
            )
          ] }),
          g.showSelector && /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
            /* @__PURE__ */ o(
              "label",
              {
                htmlFor: "edit-umrs-role-resource-server",
                className: "text-sm font-semibold text-[var(--clique-fg)]",
                children: [
                  "Resource Server ",
                  /* @__PURE__ */ t("span", { className: "text-[var(--clique-destructive)]", children: "*" })
                ]
              }
            ),
            /* @__PURE__ */ t(
              ge,
              {
                inputId: "edit-umrs-role-resource-server",
                value: N.resourceServerId,
                options: p,
                onChange: (D) => x("resourceServerId", D.value),
                placeholder: "Select a resource server",
                className: `w-full ${I ? "p-invalid" : ""}`,
                loading: f,
                disabled: b,
                filter: !0,
                emptyMessage: "No resource servers available"
              }
            ),
            I && /* @__PURE__ */ t("small", { className: "text-[var(--clique-destructive)] text-xs", children: I }),
            c && /* @__PURE__ */ t("small", { className: "text-[var(--clique-destructive)] text-xs", children: y instanceof Error ? y.message : "Failed to load resource servers" })
          ] }),
          /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5", children: [
            /* @__PURE__ */ t(
              "label",
              {
                htmlFor: "edit-umrs-role-managers-group",
                className: "text-sm font-semibold text-[var(--clique-fg)]",
                children: "Managers Group"
              }
            ),
            /* @__PURE__ */ t(
              ge,
              {
                inputId: "edit-umrs-role-managers-group",
                value: N.managersGroupId,
                options: T,
                onChange: (D) => x("managersGroupId", D.value ?? null),
                placeholder: "Select a managers group",
                className: "w-full",
                loading: C,
                filter: !0,
                showClear: !0,
                emptyMessage: "No groups available"
              }
            )
          ] }),
          /* @__PURE__ */ o("fieldset", { className: "border-t border-[var(--clique-border)] pt-5 flex flex-col gap-4", children: [
            /* @__PURE__ */ t("legend", { className: "text-sm font-semibold text-[var(--clique-fg)] pr-2", children: "Options" }),
            /* @__PURE__ */ o("div", { className: "flex items-center gap-3", children: [
              /* @__PURE__ */ t(
                Ye,
                {
                  inputId: "edit-umrs-role-extension",
                  checked: N.allowExtensionRequest,
                  onChange: (D) => x("allowExtensionRequest", D.checked ?? !1)
                }
              ),
              /* @__PURE__ */ t(
                "label",
                {
                  htmlFor: "edit-umrs-role-extension",
                  className: "text-sm text-[var(--clique-fg)] cursor-pointer",
                  children: "Allow extension requests"
                }
              )
            ] })
          ] }),
          S && /* @__PURE__ */ o("div", { className: "text-[var(--clique-destructive-strong)] text-sm bg-[var(--clique-destructive-subtle)] border border-[var(--clique-destructive-border)] rounded-lg p-3", children: [
            /* @__PURE__ */ t("i", { "aria-hidden": "true", className: "pi pi-exclamation-circle mr-2" }),
            S
          ] }),
          e && a ? /* @__PURE__ */ t(
            Fi,
            {
              umrsRoleId: a.id,
              onSuccess: d,
              onError: l
            }
          ) : null
        ] })
      }
    ),
    /* @__PURE__ */ t(
      Ge,
      {
        visible: u,
        onHide: () => h(!1),
        header: "Delete UMRS Role",
        message: `Are you sure you want to delete "${a == null ? void 0 : a.name}"? This action cannot be undone.`,
        confirmLabel: "Delete",
        rejectLabel: "Cancel",
        confirmSeverity: "danger",
        onConfirm: () => {
          h(!1), R();
        },
        loading: _
      }
    )
  ] });
}
const Pi = ["displayName", "email", "username"];
function Li(e) {
  const { canList: r, canCreate: a } = Ze("users"), { items: s, ...n } = xr({
    searchFields: Pi,
    useList: (l) => Yr(l, { enabled: r }),
    useCount: (l) => zs(l, { enabled: r }),
    pageSize: e == null ? void 0 : e.pageSize,
    defaultSortField: (e == null ? void 0 : e.defaultSortField) ?? "displayName",
    defaultSortOrder: e == null ? void 0 : e.defaultSortOrder
  }), { user: d } = Re();
  return { ...n, users: s, labels: d, canList: r, canCreate: a };
}
const Ti = ["displayName", "email", "username"];
function ki(e, r) {
  return (a, s) => {
    const n = a[e], d = s[e], l = n == null ? "" : String(n), m = d == null ? "" : String(d), v = l.localeCompare(m, void 0, { sensitivity: "base" });
    return r === 1 ? v : -v;
  };
}
function Di(e, r) {
  const a = (r == null ? void 0 : r.pageSize) ?? 20, [s, n] = U(""), [d, l] = U(0), [m, v] = U((r == null ? void 0 : r.defaultSortField) ?? "displayName"), [i, u] = U(
    ((r == null ? void 0 : r.defaultSortOrder) ?? "ASC") === "ASC" ? 1 : -1
  ), { canList: h, canCreate: g } = Ze("users"), p = vr(), f = !p || !p.gateComponents || p.hasScope("auth.groups.list"), c = h && f, {
    users: y,
    isLoading: b,
    isError: q,
    error: C,
    refetch: N,
    groupCount: x
  } = Ys(e, { enabled: c }), { user: w } = Re(), I = e.join(",");
  ne(() => {
    l(0);
  }, [I]);
  const S = L((T) => {
    n(T), l(0);
  }, []), E = re(() => {
    const T = s.trim().toLowerCase();
    return T ? y.filter(
      (D) => Ti.some((K) => {
        const M = D[K];
        return typeof M == "string" && M.toLowerCase().includes(T);
      })
    ) : y;
  }, [y, s]), R = re(() => [...E].sort(ki(m, i)), [E, m, i]), P = re(
    () => R.slice(d * a, d * a + a),
    [R, d, a]
  ), _ = b && y.length === 0, A = !b && R.length === 0 && !s, k = R.length === 0 && !!s;
  return {
    users: P,
    totalCount: R.length,
    search: s,
    setSearch: S,
    page: d,
    setPage: l,
    pageSize: a,
    sortField: m,
    sortOrder: i,
    setSortField: v,
    setSortOrder: u,
    isInitialLoad: _,
    isLoading: b,
    isError: q,
    error: C,
    isEmpty: A,
    isEmptySearch: k,
    refetch: N,
    groupCount: x,
    labels: w,
    canList: c,
    canCreate: g
  };
}
const Gi = [
  "auth.groups.update",
  "auth.groups.assigned.update",
  "auth.groups.manageAssignedNamespaces"
], Ui = "Enter a valid email address (for example, name@example.com).", Te = {
  emailFormat: Ui,
  duplicateTenant: "A user with this email and issuer already exists.",
  existingLookupFailed: "This account already exists, but we couldn't finish adding them right now. Please try again later or contact your Authifi administrator.",
  groupGone: "The selected group no longer exists. Choose another group.",
  cannotAssignGroup: "Your account can't add users to this group. Contact your Authifi administrator.",
  addFailedCreated: (e) => `The account was created, but we couldn't add them to ${e}. Please try again.`,
  addFailedExisting: (e) => `We couldn't add them to ${e}. Please try again.`,
  addFailedUnexpected: "The account was created, but we could not complete group assignment. Please try again.",
  existingAddedSummary: (e) => `Added to ${e}`,
  existingAddedDetail: (e, r, a) => `An account for ${e} (${r}) already exists, so they were added to ${a}.`
}, Mi = {
  email: "",
  identityIssuer: "",
  givenName: "",
  familyName: "",
  username: "",
  groupId: null
};
function Qr(e) {
  if (e.length === 0 || /\s/.test(e)) return !1;
  const r = e.indexOf("@");
  if (r < 1 || e.indexOf("@", r + 1) !== -1) return !1;
  const a = e.slice(r + 1), s = a.indexOf(".");
  return s > 0 && a.length > s + 1;
}
const Mr = {
  "missing-list-scope": "Your account can't view groups for this application. Contact your Authifi administrator.",
  error: "Could not load groups. Try again later.",
  "no-groups": "This application requires at least one group. Reach out to an Authifi admin or create a group for this application."
};
function pt(e, r, a = 0, s = !1) {
  return e === "unavailable" && r ? Mr[r] : e === "error" ? Mr.error : s && e === "resolved" && a === 0 ? Mr["no-groups"] : "";
}
function gt(e) {
  return e.map((r) => r.name).join(", ");
}
function $i(e, r, a, s) {
  var d;
  const n = e.identityIssuer || r || a || "";
  return ((d = s.find((l) => l.issuer === n)) == null ? void 0 : d.name) ?? n;
}
function Oi(e) {
  return e.failures ? e.failures : e.failed.map((r) => ({ group: r, status: void 0 }));
}
function _i(e) {
  const {
    onCreated: r,
    onExistingUserAdded: a,
    onError: s,
    onDismiss: n,
    namespaceId: d,
    enabled: l = !0
  } = e ?? {}, m = d != null, {
    form: v,
    setForm: i,
    errors: u,
    setFieldError: h,
    clearError: g,
    clearErrors: p,
    submitError: f,
    setSubmitError: c,
    reset: y
  } = He(Mi), b = Pt(), q = Vs(), C = W(), { numericTenantId: N } = z(), { user: x } = Re(), w = ms(), I = vr(), S = ps(), E = !I || !I.gateComponents || I.hasScope("auth.groups.list"), R = !I || !I.gateComponents || I.hasAnyScope(...Gi), P = !I || !I.gateComponents || I.hasScope("auth.users.list"), _ = E && R, {
    options: A,
    defaultGroupId: k,
    isLoading: T,
    status: D,
    unavailableReason: K
  } = Ft(d, w, { enabled: l && _ }), M = m && !R ? Te.cannotAssignGroup : _ ? pt(D, K, A.length, m) : m ? pt(D, K, A.length, !0) : "", { issuers: ee, isLoadingIssuers: Q, issuersError: j, resolvedDefaultIssuer: $, isIssuerLocked: ie } = _t(l), O = re(
    () => ee.map((J) => ({ issuer: J.issuer, name: J.name })),
    [ee]
  ), [ae, Y] = U(null), [ue, se] = U(null), [de, oe] = U([]), [le, H] = U(""), [ze, V] = U(!1), Se = Ie(!1), _r = v.email.trim().toLowerCase(), Bt = Qr(_r);
  ne(() => {
    !$ || v.identityIssuer || i((J) => ({ ...J, identityIssuer: $ }));
  }, [$, v.identityIssuer, i]), ne(() => {
    Se.current || v.groupId != null || k == null || (Se.current = !0, i((J) => ({ ...J, groupId: k })));
  }, [k, v.groupId, i]);
  const Ht = L(
    (J, pe) => {
      i((Ne) => ({ ...Ne, [J]: pe })), g(J);
    },
    [i, g]
  ), Vt = L(() => {
    y(), Y(null), se(null), oe([]), H(""), V(!1), Se.current = !1;
  }, [y]), Wt = L(() => {
    ae && (r == null || r(ae)), n == null || n();
  }, [ae, r, n]), Ve = L(
    async (J, pe, Ne) => {
      Ne === "existing" && se(J);
      let rr;
      try {
        rr = await q.mutateAsync({ userId: J.id, groups: pe });
      } catch (Le) {
        console.error("Failed to assign user to groups", Le), Ne === "created" ? (Y(J), oe(pe), H(Te.addFailedUnexpected)) : c(Te.addFailedExisting(gt(pe)));
        return;
      }
      const Me = Oi(rr);
      if (Me.length === 0) {
        if (oe([]), H(""), c(""), Ne === "existing") {
          se(null);
          const Le = pe[0];
          if (Le) {
            const Lr = $i(
              J,
              v.identityIssuer,
              $,
              O
            );
            S == null || S.notify({
              severity: "success",
              summary: Te.existingAddedSummary(Le.name),
              detail: Te.existingAddedDetail(J.email, Lr, Le.name)
            }), a == null || a(J, Le);
          }
        } else
          r == null || r(J);
        n == null || n();
        return;
      }
      const ke = Me[0], tr = Me.map((Le) => Le.group), Ir = gt(tr);
      if ((ke == null ? void 0 : ke.status) === 404) {
        c(Te.groupGone), H(""), i((Le) => ({ ...Le, groupId: null })), Ne === "created" ? (Y(J), oe(tr)) : oe([]), N !== null && C.invalidateQueries({ queryKey: ve.all(N) });
        return;
      }
      if ((ke == null ? void 0 : ke.status) === 403) {
        c(Te.cannotAssignGroup), H(""), Ne === "created" ? (Y(J), oe(tr)) : oe([]);
        return;
      }
      if (Ne === "created") {
        Y(J), oe(tr), H(Te.addFailedCreated(Ir));
        return;
      }
      c(Te.addFailedExisting(Ir));
    },
    [
      q,
      v.identityIssuer,
      O,
      S,
      N,
      r,
      n,
      a,
      C,
      $,
      i,
      c
    ]
  ), zr = L(
    async (J, pe) => {
      if (N === null || !P) return { kind: "unavailable" };
      try {
        const Ne = F(N), Me = ((await or.list(Ne, {
          where: { email: { ilike: gs(J) } },
          limit: 50
        })).data ?? []).find(
          (ke) => ke.email.toLowerCase() === J && ke.identityIssuer === pe
        );
        return Me ? { kind: "found", user: Me } : { kind: "none" };
      } catch {
        return { kind: "unavailable" };
      }
    },
    [N, P]
  ), Nr = L(
    (J) => J == null ? null : A.find((pe) => pe.id === J) ?? null,
    [A]
  ), Yt = L(() => {
    const J = v.email.trim().toLowerCase(), pe = Ee(J, "Email");
    if (pe) {
      h("email", pe);
      return;
    }
    Qr(J) || h("email", Te.emailFormat);
  }, [v.email, h]), Jt = L(async () => {
    if (T) return;
    const J = v.email.trim().toLowerCase(), pe = v.givenName.trim(), Ne = v.familyName.trim(), rr = v.username.trim(), Me = v.identityIssuer, ke = v.groupId, tr = Ee(J, "Email") ?? (Qr(J) ? void 0 : Te.emailFormat);
    if (tr) {
      h("email", tr);
      return;
    }
    const Ir = Ee(Me, "Identity issuer");
    if (Ir) {
      h("identityIssuer", Ir);
      return;
    }
    const Le = pe ? Fe(pe, 2, "Given name") : void 0;
    if (Le) {
      h("givenName", Le);
      return;
    }
    const Lr = Ne ? Fe(Ne, 2, "Family name") : void 0;
    if (Lr) {
      h("familyName", Lr);
      return;
    }
    const tt = rr ? Fe(rr, 2, "Username") : void 0;
    if (tt) {
      h("username", tt);
      return;
    }
    if (m && D !== "resolved") {
      const kr = M || Mr.error;
      c(kr);
      return;
    }
    if (m && ke == null) {
      h("groupId", "Group is required.");
      return;
    }
    const $e = Nr(ke);
    if (m && !$e) {
      h("groupId", "Group is required.");
      return;
    }
    if (p(), c(""), ue && $e) {
      await Ve(ue, [$e], "existing");
      return;
    }
    if (ae && $e) {
      await Ve(ae, [$e], "created");
      return;
    }
    V(!0);
    const at = await zr(J, Me);
    if (V(!1), at.kind === "found") {
      if (m) {
        if (!$e) {
          h("groupId", "Group is required.");
          return;
        }
        await Ve(at.user, [$e], "existing");
        return;
      }
      h("email", Te.duplicateTenant);
      return;
    }
    let Tr;
    try {
      Tr = await b.mutateAsync({
        email: J,
        identityIssuer: Me,
        givenName: pe || void 0,
        familyName: Ne || void 0,
        username: rr || void 0
      });
    } catch (kr) {
      if (console.error("Failed to create user", kr), m && vs(kr)) {
        V(!0);
        const nt = await zr(J, Me);
        if (V(!1), nt.kind === "found") {
          if (!$e) {
            h("groupId", "Group is required.");
            return;
          }
          await Ve(nt.user, [$e], "existing");
          return;
        }
        const it = Te.existingLookupFailed;
        c(it), s == null || s(it);
        return;
      }
      const st = `Failed to create ${x.singular}. Please try again.`;
      c(st), s == null || s(st);
      return;
    }
    if (Y(Tr), !$e) {
      r == null || r(Tr), n == null || n();
      return;
    }
    await Ve(Tr, [$e], "created");
  }, [
    v,
    b,
    r,
    n,
    s,
    x.singular,
    zr,
    h,
    p,
    c,
    T,
    m,
    D,
    M,
    Ve,
    ae,
    ue,
    Nr
  ]), Xt = L(async () => {
    if (ue) {
      const Ne = Nr(v.groupId);
      if (!Ne) return;
      await Ve(ue, [Ne], "existing");
      return;
    }
    if (!ae) return;
    const J = Nr(v.groupId), pe = J ? [J] : de;
    pe.length !== 0 && await Ve(ae, pe, "created");
  }, [
    ae,
    de,
    v.groupId,
    ue,
    Nr,
    Ve
  ]);
  return {
    form: v,
    updateField: Ht,
    emailError: u.email ?? "",
    issuerError: u.identityIssuer ?? "",
    givenNameError: u.givenName ?? "",
    familyNameError: u.familyName ?? "",
    usernameError: u.username ?? "",
    groupError: u.groupId ?? "",
    submitError: f,
    resetForm: Vt,
    handleSubmit: Jt,
    isPending: b.isPending || q.isPending || ze,
    issuers: O,
    isLoadingIssuers: Q,
    issuersError: j,
    isIssuerLocked: ie,
    labels: x,
    groupOptions: A,
    defaultGroupId: k,
    isGroupRequired: m,
    canSelectGroup: _,
    isLoadingGroups: T,
    groupsError: M,
    createdUser: ae,
    failedGroups: de,
    groupWarning: le,
    retryGroupAdds: Xt,
    finishWithWarnings: Wt,
    isEmailValid: Bt,
    markEmailTouched: Yt,
    pendingExistingUser: ue
  };
}
const Sr = "min-w-0 break-words [overflow-wrap:anywhere]";
function zi({
  visible: e,
  onHide: r,
  onCreated: a,
  onExistingUserAdded: s,
  namespaceId: n,
  className: d,
  style: l,
  pt: m
}) {
  const v = Ie(null), i = Ie(e), u = _i({
    onCreated: a,
    onExistingUserAdded: s,
    onDismiss: r,
    namespaceId: n,
    enabled: e
  }), {
    form: h,
    updateField: g,
    emailError: p,
    issuerError: f,
    givenNameError: c,
    familyNameError: y,
    usernameError: b,
    groupError: q,
    submitError: C,
    resetForm: N,
    handleSubmit: x,
    isPending: w,
    issuers: I,
    isLoadingIssuers: S,
    issuersError: E,
    isIssuerLocked: R,
    labels: P,
    groupOptions: _,
    defaultGroupId: A,
    isGroupRequired: k,
    canSelectGroup: T,
    isLoadingGroups: D,
    groupsError: K,
    createdUser: M,
    failedGroups: ee,
    groupWarning: Q,
    retryGroupAdds: j,
    finishWithWarnings: $,
    isEmailValid: ie,
    markEmailTouched: O,
    pendingExistingUser: ae
  } = u, Y = M != null, ue = Y && ee.length > 0, se = ae != null, de = w || Y || se;
  ne(() => {
    e && (i.current || N(), setTimeout(() => {
      var H;
      return (H = v.current) == null ? void 0 : H.focus();
    }, 100)), i.current = e;
  }, [e, N]);
  const oe = () => {
    if (!w) {
      if (Y) {
        $();
        return;
      }
      r();
    }
  }, le = ue || se ? /* @__PURE__ */ o("div", { className: "flex justify-end gap-3", children: [
    /* @__PURE__ */ t(
      G,
      {
        type: "button",
        label: "Close",
        onClick: $,
        severity: "secondary",
        outlined: !0,
        disabled: w
      }
    ),
    /* @__PURE__ */ t(
      G,
      {
        type: "button",
        label: "Retry group assignment",
        icon: "pi pi-refresh",
        onClick: () => void j(),
        raised: !0,
        loading: w,
        disabled: w || h.groupId == null
      }
    )
  ] }) : /* @__PURE__ */ o("div", { className: "flex justify-end gap-3", children: [
    /* @__PURE__ */ t(
      G,
      {
        type: "button",
        label: "Cancel",
        onClick: r,
        severity: "secondary",
        outlined: !0,
        disabled: w
      }
    ),
    /* @__PURE__ */ t(
      G,
      {
        type: "button",
        label: "Create",
        icon: "pi pi-check",
        onClick: () => void x(),
        raised: !0,
        loading: w,
        disabled: D || !!K || !h.identityIssuer || k && h.groupId == null || !ie
      }
    )
  ] });
  return /* @__PURE__ */ t(
    fe,
    {
      visible: e,
      onHide: oe,
      header: `Create ${P.singularTitle}`,
      modal: !0,
      draggable: !1,
      resizable: !1,
      closable: !w,
      closeOnEscape: !w,
      className: d,
      style: { width: "32rem", ...l },
      pt: m,
      footer: le,
      children: /* @__PURE__ */ o("div", { className: `flex flex-col gap-6 ${Sr}`, children: [
        /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5 min-w-0", children: [
          /* @__PURE__ */ o("label", { htmlFor: "user-email", className: "text-sm font-semibold text-[var(--clique-fg)]", children: [
            "Email ",
            /* @__PURE__ */ t("span", { className: "text-[var(--clique-destructive)]", children: "*" })
          ] }),
          /* @__PURE__ */ t(
            me,
            {
              id: "user-email",
              ref: v,
              value: h.email,
              onChange: (H) => g("email", H.target.value),
              onBlur: O,
              placeholder: "Enter email address",
              className: `w-full ${p ? "p-invalid" : ""}`,
              "aria-invalid": !!p,
              "aria-describedby": p ? "user-email-error" : void 0,
              disabled: de
            }
          ),
          p && /* @__PURE__ */ t(
            "small",
            {
              id: "user-email-error",
              className: `text-[var(--clique-destructive)] text-xs ${Sr}`,
              children: p
            }
          )
        ] }),
        !R && /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5 min-w-0", children: [
          /* @__PURE__ */ o("label", { htmlFor: "user-issuer", className: "text-sm font-semibold text-[var(--clique-fg)]", children: [
            "Identity issuer ",
            /* @__PURE__ */ t("span", { className: "text-[var(--clique-destructive)]", children: "*" })
          ] }),
          /* @__PURE__ */ t(
            ge,
            {
              id: "user-issuer",
              value: h.identityIssuer || null,
              options: I.map((H) => ({ label: H.name, value: H.issuer })),
              onChange: (H) => g("identityIssuer", H.value ?? ""),
              placeholder: !S && I.length === 0 ? "No identity issuers available" : "Select identity issuer",
              className: `w-full ${f ? "p-invalid" : ""}`,
              pt: {
                input: {
                  className: h.identityIssuer ? void 0 : "text-[var(--clique-fg-muted)]"
                }
              },
              loading: S,
              disabled: de || !S && I.length === 0,
              "aria-invalid": !!f,
              "aria-describedby": f ? "user-issuer-error" : void 0
            }
          ),
          f && /* @__PURE__ */ t("small", { id: "user-issuer-error", className: "text-[var(--clique-destructive)] text-xs", children: f }),
          E && /* @__PURE__ */ t("small", { className: "text-[var(--clique-fg-secondary)] text-xs", children: "Could not load identity issuers. Try again later." })
        ] }),
        T && /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5 min-w-0", children: [
          /* @__PURE__ */ t("label", { htmlFor: "user-group", className: "text-sm font-semibold text-[var(--clique-fg)]", children: k ? /* @__PURE__ */ o(Ce, { children: [
            "Group ",
            /* @__PURE__ */ t("span", { className: "text-[var(--clique-destructive)]", children: "*" })
          ] }) : "Group (optional)" }),
          /* @__PURE__ */ t(
            ge,
            {
              id: "user-group",
              value: h.groupId,
              options: _,
              optionLabel: "name",
              optionValue: "id",
              onChange: (H) => g("groupId", H.value ?? null),
              placeholder: !D && _.length === 0 ? "No groups available" : "Select group",
              itemTemplate: (H) => /* @__PURE__ */ o("span", { className: "flex items-center justify-between gap-2 min-w-0", children: [
                /* @__PURE__ */ t("span", { className: "truncate", title: H.name, children: H.name }),
                H.id === A && /* @__PURE__ */ t(ce, { value: "Default" })
              ] }),
              valueTemplate: (H) => H ? /* @__PURE__ */ o("span", { className: "flex items-center gap-2 min-w-0", children: [
                /* @__PURE__ */ t("span", { className: "truncate", title: H.name, children: H.name }),
                H.id === A && /* @__PURE__ */ t(ce, { value: "Default" })
              ] }) : !D && _.length === 0 ? "No groups available" : "Select group",
              filter: !0,
              showClear: !k,
              className: `w-full ${q ? "p-invalid" : ""}`,
              pt: {
                input: {
                  className: h.groupId != null ? void 0 : "text-[var(--clique-fg-muted)]"
                }
              },
              loading: D,
              disabled: w || !D && _.length === 0,
              "aria-invalid": !!q,
              "aria-describedby": q ? "user-group-error" : void 0
            }
          ),
          q && /* @__PURE__ */ t(
            "small",
            {
              id: "user-group-error",
              className: `text-[var(--clique-destructive)] text-xs ${Sr}`,
              children: q
            }
          ),
          k && !K && !ue && /* @__PURE__ */ o("small", { className: "text-[var(--clique-fg-secondary)] text-xs", children: [
            /* @__PURE__ */ t("i", { "aria-hidden": "true", className: "pi pi-info-circle mr-1" }),
            "This application requires a group to be selected.",
            A != null && " The application's default group is preselected; you can choose a different group."
          ] })
        ] }),
        /* @__PURE__ */ o("div", { className: "flex gap-4", children: [
          /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5 flex-1 min-w-0", children: [
            /* @__PURE__ */ t(
              "label",
              {
                htmlFor: "user-given-name",
                className: "text-sm font-semibold text-[var(--clique-fg)]",
                children: "Given name"
              }
            ),
            /* @__PURE__ */ t(
              me,
              {
                id: "user-given-name",
                value: h.givenName,
                onChange: (H) => g("givenName", H.target.value),
                placeholder: "Optional",
                className: `w-full ${c ? "p-invalid" : ""}`,
                "aria-invalid": !!c,
                "aria-describedby": c ? "user-given-name-error" : void 0,
                disabled: de
              }
            ),
            c && /* @__PURE__ */ t(
              "small",
              {
                id: "user-given-name-error",
                className: "text-[var(--clique-destructive)] text-xs",
                children: c
              }
            )
          ] }),
          /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5 flex-1 min-w-0", children: [
            /* @__PURE__ */ t(
              "label",
              {
                htmlFor: "user-family-name",
                className: "text-sm font-semibold text-[var(--clique-fg)]",
                children: "Family name"
              }
            ),
            /* @__PURE__ */ t(
              me,
              {
                id: "user-family-name",
                value: h.familyName,
                onChange: (H) => g("familyName", H.target.value),
                placeholder: "Optional",
                className: `w-full ${y ? "p-invalid" : ""}`,
                "aria-invalid": !!y,
                "aria-describedby": y ? "user-family-name-error" : void 0,
                disabled: de
              }
            ),
            y && /* @__PURE__ */ t(
              "small",
              {
                id: "user-family-name-error",
                className: "text-[var(--clique-destructive)] text-xs",
                children: y
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ o("div", { className: "flex flex-col gap-1.5 min-w-0", children: [
          /* @__PURE__ */ t("label", { htmlFor: "user-username", className: "text-sm font-semibold text-[var(--clique-fg)]", children: "Username" }),
          /* @__PURE__ */ t(
            me,
            {
              id: "user-username",
              value: h.username,
              onChange: (H) => g("username", H.target.value),
              placeholder: "Optional",
              className: `w-full ${b ? "p-invalid" : ""}`,
              "aria-invalid": !!b,
              "aria-describedby": b ? "user-username-error" : void 0,
              disabled: de
            }
          ),
          b && /* @__PURE__ */ t("small", { id: "user-username-error", className: "text-[var(--clique-destructive)] text-xs", children: b })
        ] }),
        Q && /* @__PURE__ */ o(
          "div",
          {
            className: `text-[var(--clique-fg)] text-sm bg-[var(--clique-surface)] border border-[var(--clique-border)] rounded-lg p-3 ${Sr}`,
            children: [
              /* @__PURE__ */ t("i", { "aria-hidden": "true", className: "pi pi-exclamation-triangle mr-2" }),
              Q
            ]
          }
        ),
        (C || K) && /* @__PURE__ */ o(
          "div",
          {
            className: `text-[var(--clique-destructive-strong)] text-sm bg-[var(--clique-destructive-subtle)] border border-[var(--clique-destructive-border)] rounded-lg p-3 ${Sr}`,
            children: [
              /* @__PURE__ */ t("i", { "aria-hidden": "true", className: "pi pi-exclamation-circle mr-2" }),
              C || K
            ]
          }
        )
      ] })
    }
  );
}
function Ki(e) {
  return [
    {
      field: "displayName",
      header: "Name",
      sortable: !0,
      className: "font-medium",
      body: (r) => r.displayName || r.name || "—"
    },
    { field: "email", header: "Email", sortable: !0 },
    {
      field: "provider",
      header: "Provider",
      sortable: !0,
      style: { width: "140px" },
      body: (r) => r.provider ? /* @__PURE__ */ t(ce, { value: r.provider, severity: "info" }) : "—"
    },
    {
      field: "lastLogin",
      header: "Last Login",
      sortable: !0,
      style: { width: "140px" },
      body: (r) => /* @__PURE__ */ t("span", { className: "text-[var(--clique-fg-secondary)]", children: e.formatDate(r.lastLogin) })
    },
    {
      field: "created",
      header: "Created",
      sortable: !0,
      style: { width: "140px" },
      body: (r) => /* @__PURE__ */ t("span", { className: "text-[var(--clique-fg-secondary)]", children: e.formatDate(r.created) })
    }
  ];
}
function Qt({
  users: e,
  totalCount: r,
  search: a,
  setSearch: s,
  page: n,
  setPage: d,
  pageSize: l,
  sortField: m,
  sortOrder: v,
  setSortField: i,
  setSortOrder: u,
  isInitialLoad: h,
  isLoading: g,
  isError: p,
  error: f,
  refetch: c,
  labels: y,
  canList: b = !0,
  onUserSelect: q,
  columns: C,
  toolbarActions: N,
  renderLoading: x,
  renderEmpty: w,
  renderError: I,
  renderAccessDenied: S,
  className: E,
  style: R,
  pt: P
}) {
  const _ = fr(), A = Fr(), k = C ?? Ki(A), T = L(
    (M) => {
      d(M.page ?? 0);
    },
    [d]
  ), D = L(
    (M) => {
      i(M.sortField), u(M.sortOrder === 1 ? 1 : -1), d(0);
    },
    [i, u, d]
  ), K = () => b ? h ? x ? x() : /* @__PURE__ */ t(xe, { message: `Loading ${y.plural}...` }) : p ? I ? I(f, c) : /* @__PURE__ */ t(he, { error: f, resourceLabel: y.plural, onRetry: c }) : (e == null ? void 0 : e.length) === 0 && !a ? w ? w() : /* @__PURE__ */ t(
    Je,
    {
      icon: _.user,
      title: `No ${y.plural} yet`,
      message: `No ${y.plural} have been added to this tenant.`
    }
  ) : /* @__PURE__ */ t(
    Ae,
    {
      value: e ?? [],
      lazy: !0,
      paginator: !0,
      rows: l,
      totalRecords: r ?? 0,
      first: n * l,
      onPage: T,
      sortField: m,
      sortOrder: v,
      onSort: D,
      loading: g,
      dataKey: "id",
      emptyMessage: `No ${y.plural} match your search.`,
      selectionMode: "single",
      onSelectionChange: (M) => {
        M.value && (q == null || q(M.value));
      },
      rowHover: !0,
      stripedRows: !0,
      className: "rounded-lg border border-[var(--clique-border)] overflow-hidden",
      pt: P,
      rowClassName: () => q ? "cursor-pointer" : "",
      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport",
      currentPageReportTemplate: `Showing {first} to {last} of {totalRecords} ${y.plural}`,
      children: k.map((M) => /* @__PURE__ */ t(
        X,
        {
          field: M.field,
          header: M.header,
          sortable: M.sortable,
          className: M.className,
          style: M.style,
          body: M.body
        },
        M.field
      ))
    }
  ) : S ? S() : /* @__PURE__ */ t(ur, { resourceLabel: y.plural });
  return /* @__PURE__ */ o("div", { className: be(E), style: R, children: [
    /* @__PURE__ */ o("div", { className: "flex items-center justify-between mb-4 gap-4", children: [
      /* @__PURE__ */ t(
        cr,
        {
          value: a,
          onChange: s,
          placeholder: `Search ${y.plural} by name, email, or username...`,
          className: "flex-1 max-w-md"
        }
      ),
      N && /* @__PURE__ */ t("div", { className: "flex items-center gap-2", children: N })
    ] }),
    K()
  ] });
}
const Qi = [
  "auth.groups.update",
  "auth.groups.assigned.update",
  "auth.groups.manageAssignedNamespaces"
];
function ji() {
  const e = vr();
  return e != null && e.gateComponents ? e.hasAnyScope(...Qi) : !0;
}
function jt({
  canCreate: e,
  labels: r,
  namespaceId: a,
  onExistingUserAdded: s
}) {
  const n = fs(), d = ji(), l = a != null ? e && d : e, [m, v] = U(!1);
  return { button: n ? /* @__PURE__ */ t(
    G,
    {
      type: "button",
      label: `Create ${r.singular}`,
      icon: "pi pi-user-plus",
      outlined: !0,
      onClick: l ? () => v(!0) : void 0,
      ...mr(
        l,
        r.plural,
        a != null ? `You don't have permission to create ${r.plural} or add them to groups.` : void 0
      )
    }
  ) : null, dialog: n ? /* @__PURE__ */ t(
    zi,
    {
      visible: m,
      onHide: () => v(!1),
      namespaceId: a,
      onExistingUserAdded: s
    }
  ) : null };
}
function Bi({ pageSize: e = 20, ...r }) {
  const a = Li({ pageSize: e }), { button: s, dialog: n } = jt({
    canCreate: a.canCreate,
    labels: a.labels
  }), d = /* @__PURE__ */ o(Ce, { children: [
    s,
    r.toolbarActions
  ] });
  return /* @__PURE__ */ o(Ce, { children: [
    /* @__PURE__ */ t(Qt, { ...a, ...r, toolbarActions: d }),
    n
  ] });
}
function Hi({
  namespaceId: e,
  pageSize: r = 20,
  ...a
}) {
  const s = Di([e], { pageSize: r }), n = s.refetch, d = L(() => {
    n();
  }, [n]), { button: l, dialog: m } = jt({
    canCreate: s.canCreate,
    labels: s.labels,
    namespaceId: e,
    onExistingUserAdded: d
  }), v = /* @__PURE__ */ o(Ce, { children: [
    l,
    a.toolbarActions
  ] });
  return /* @__PURE__ */ o(Ce, { children: [
    /* @__PURE__ */ t(Qt, { ...s, ...a, toolbarActions: v }),
    m
  ] });
}
function jl({ namespaceId: e, ...r }) {
  const a = je(e);
  return a != null ? /* @__PURE__ */ t(
    Hi,
    {
      namespaceId: a,
      ...r
    },
    a
  ) : /* @__PURE__ */ t(Bi, { ...r });
}
function jr(e) {
  return e ? new Date(e).toLocaleDateString(void 0, {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  }) : "—";
}
function Vi(e) {
  return e.givenName && e.familyName ? `${e.givenName[0]}${e.familyName[0]}`.toUpperCase() : e.displayName ? e.displayName.split(" ").map((r) => r[0]).join("").slice(0, 2).toUpperCase() : e.email ? e.email[0].toUpperCase() : "?";
}
function vt(e) {
  return e.displayName || e.name || e.username || e.email || "—";
}
const Wi = {
  owner: "warning",
  manager: "info",
  member: "secondary"
};
function Bl({
  user: e,
  groups: r,
  groupsLoading: a,
  groupsError: s,
  onGroupsRetry: n,
  className: d,
  style: l
}) {
  const { group: m } = Re(), v = r !== void 0 || a || s != null;
  return /* @__PURE__ */ o("div", { className: d, style: l, children: [
    /* @__PURE__ */ t(
      "div",
      {
        className: "rounded-lg border border-[var(--clique-border)] p-6 mb-6",
        style: { backgroundColor: "var(--clique-bg)" },
        children: /* @__PURE__ */ o("div", { className: "flex items-center gap-5", children: [
          e.picture ? /* @__PURE__ */ t(
            "img",
            {
              src: e.picture,
              alt: vt(e),
              className: "w-16 h-16 rounded-full object-cover border-2 border-[var(--clique-border)]"
            }
          ) : /* @__PURE__ */ t("div", { className: "w-16 h-16 rounded-full bg-[var(--clique-primary-muted)] text-[var(--clique-primary-strong)] flex items-center justify-center text-xl font-semibold border-2 border-[var(--clique-primary-muted)]", children: Vi(e) }),
          /* @__PURE__ */ o("div", { className: "flex-1 min-w-0", children: [
            /* @__PURE__ */ t("h3", { className: "text-xl font-semibold text-[var(--clique-fg)] truncate", children: vt(e) }),
            /* @__PURE__ */ t("p", { className: "text-[var(--clique-fg-secondary)] text-sm truncate", children: e.email }),
            /* @__PURE__ */ o("div", { className: "flex items-center gap-2 mt-2", children: [
              /* @__PURE__ */ t(ce, { value: e.providerName || e.provider, icon: "pi pi-link" }),
              e.username && /* @__PURE__ */ o("span", { className: "text-xs text-[var(--clique-fg-tertiary)]", children: [
                "@",
                e.username
              ] })
            ] })
          ] })
        ] })
      }
    ),
    /* @__PURE__ */ o(
      "div",
      {
        className: "rounded-lg border border-[var(--clique-border)] p-6 mb-6",
        style: { backgroundColor: "var(--clique-bg)" },
        children: [
          /* @__PURE__ */ t("h3", { className: "text-lg font-medium text-[var(--clique-fg)] mb-4", children: "Profile Details" }),
          /* @__PURE__ */ o("dl", { className: "grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4 text-sm", children: [
            /* @__PURE__ */ t(we, { label: "Username", value: e.username }),
            /* @__PURE__ */ t(we, { label: "Email", value: e.email }),
            /* @__PURE__ */ t(we, { label: "Given Name", value: e.givenName }),
            /* @__PURE__ */ t(we, { label: "Family Name", value: e.familyName }),
            /* @__PURE__ */ t(we, { label: "Middle Name", value: e.middleName }),
            /* @__PURE__ */ t(we, { label: "Nickname", value: e.nickname }),
            /* @__PURE__ */ t(we, { label: "Display Name", value: e.displayName }),
            /* @__PURE__ */ t(we, { label: "Alternate Email", value: e.alternateEmail }),
            /* @__PURE__ */ t(we, { label: "Provider", value: e.providerName || e.provider }),
            /* @__PURE__ */ t(we, { label: "Timezone", value: e.timeZone }),
            /* @__PURE__ */ t(we, { label: "ORCID iD", value: e.orcidId }),
            /* @__PURE__ */ t(we, { label: "User ID", value: e.id != null ? String(e.id) : null }),
            /* @__PURE__ */ t(we, { label: "Created", value: jr(e.created) }),
            /* @__PURE__ */ t(we, { label: "Last Login", value: jr(e.lastLogin) }),
            /* @__PURE__ */ t(we, { label: "Last Updated", value: jr(e.updatedAt) })
          ] })
        ]
      }
    ),
    v && /* @__PURE__ */ o(
      "div",
      {
        className: "rounded-lg border border-[var(--clique-border)] p-6",
        style: { backgroundColor: "var(--clique-bg)" },
        children: [
          /* @__PURE__ */ t("h3", { className: "text-lg font-medium text-[var(--clique-fg)] mb-4", children: m.pluralTitle }),
          s != null ? /* @__PURE__ */ o("div", { className: "flex flex-col items-center py-6 text-center", children: [
            /* @__PURE__ */ t(
              "i",
              {
                "aria-hidden": "true",
                className: "pi pi-exclamation-triangle text-2xl text-[var(--clique-destructive)] mb-2"
              }
            ),
            /* @__PURE__ */ o("p", { className: "text-sm text-[var(--clique-fg-muted)] mb-3", children: [
              "Failed to load ",
              m.plural,
              "."
            ] }),
            n && /* @__PURE__ */ t(
              G,
              {
                label: "Retry",
                icon: "pi pi-refresh",
                onClick: n,
                size: "small",
                severity: "secondary"
              }
            )
          ] }) : a ? /* @__PURE__ */ t("div", { className: "flex items-center justify-center py-6", children: /* @__PURE__ */ t(
            It,
            {
              "aria-hidden": "true",
              style: { width: "32px", height: "32px" },
              strokeWidth: "4"
            }
          ) }) : r && r.length > 0 ? /* @__PURE__ */ t("div", { className: "flex flex-col gap-3", children: r.map((i) => /* @__PURE__ */ o(
            "div",
            {
              className: "flex items-center justify-between gap-4 rounded-lg border border-[var(--clique-border-subtle)] bg-[var(--clique-bg-subtle)] px-4 py-3",
              children: [
                /* @__PURE__ */ o("div", { className: "min-w-0 flex-1", children: [
                  /* @__PURE__ */ o("div", { className: "flex items-center gap-2", children: [
                    /* @__PURE__ */ t("span", { className: "text-sm font-medium text-[var(--clique-fg)]", children: i.group.name }),
                    i.group.isPrivileged && /* @__PURE__ */ t(ce, { value: "Privileged", severity: "warning", icon: "pi pi-star" })
                  ] }),
                  i.group.description && /* @__PURE__ */ t("p", { className: "text-xs text-[var(--clique-fg-secondary)] mt-0.5 truncate", children: i.group.description })
                ] }),
                /* @__PURE__ */ t(
                  ce,
                  {
                    value: i.role,
                    severity: Wi[i.role] ?? "secondary"
                  }
                )
              ]
            },
            i.id
          )) }) : /* @__PURE__ */ o("p", { className: "text-sm text-[var(--clique-fg-secondary)]", children: [
            "Not a member of any ",
            m.plural,
            "."
          ] })
        ]
      }
    )
  ] });
}
function we({ label: e, value: r }) {
  return /* @__PURE__ */ o("div", { children: [
    /* @__PURE__ */ t("dt", { className: "text-[var(--clique-fg-secondary)]", children: e }),
    /* @__PURE__ */ t("dd", { className: "text-[var(--clique-fg)] font-medium", children: r || "—" })
  ] });
}
function Yi(e) {
  const { userId: r, onSuccess: a, onError: s } = e, { data: n, isLoading: d, isError: l, error: m, refetch: v } = xn(r), i = Ut(), [u, h] = U(!1), [g, p] = U(null), f = L(() => {
    g && i.mutate(g.grantId, {
      onSuccess: () => {
        a == null || a(`Grant for "${g.roleName}" revoked.`), p(null);
      },
      onError: (c) => {
        console.error("Failed to revoke grant", c), s == null || s("Failed to revoke grant. Please try again.");
      }
    });
  }, [g, i, a, s]);
  return {
    grants: n ?? [],
    isLoading: d,
    isError: l,
    error: m,
    refetch: v,
    showAssignDialog: u,
    setShowAssignDialog: h,
    grantToRevoke: g,
    setGrantToRevoke: p,
    handleRevoke: f,
    isRevoking: i.isPending
  };
}
function Ji(e) {
  return e ? new Date(e).toLocaleDateString(void 0, {
    year: "numeric",
    month: "short",
    day: "numeric"
  }) : "—";
}
function Hl({
  userId: e,
  onSuccess: r,
  onError: a,
  className: s,
  style: n,
  pt: d
}) {
  var g;
  const l = Yi({ userId: e, onSuccess: r, onError: a }), m = (p) => /* @__PURE__ */ t("span", { className: "font-medium text-[var(--clique-fg)]", children: p.roleName }), v = (p) => /* @__PURE__ */ t(ce, { value: p.resourceServer, severity: "info" }), i = (p) => {
    const f = Ji(p.expiresAt);
    return p.expiringSoon ? /* @__PURE__ */ t(ce, { value: f, severity: "warning", icon: "pi pi-clock" }) : f;
  }, u = (p) => p.grantSource || "—", h = (p) => /* @__PURE__ */ t(
    G,
    {
      type: "button",
      icon: "pi pi-trash",
      onClick: () => l.setGrantToRevoke(p),
      severity: "danger",
      text: !0,
      rounded: !0,
      size: "small",
      "aria-label": "Revoke grant"
    }
  );
  return /* @__PURE__ */ o(
    "div",
    {
      className: be("rounded-lg border border-[var(--clique-border)] p-6 mt-6", s),
      style: { backgroundColor: "var(--clique-bg)", ...n },
      children: [
        /* @__PURE__ */ o("div", { className: "flex items-center justify-between mb-4", children: [
          /* @__PURE__ */ t("h3", { className: "text-lg font-medium text-[var(--clique-fg)]", children: "UMRS Roles" }),
          /* @__PURE__ */ t(
            G,
            {
              type: "button",
              label: "Assign Role",
              icon: "pi pi-plus",
              onClick: () => l.setShowAssignDialog(!0),
              size: "small",
              outlined: !0
            }
          )
        ] }),
        l.isLoading ? /* @__PURE__ */ t(xe, { message: "Loading UMRS grants..." }) : l.isError ? /* @__PURE__ */ t(
          he,
          {
            error: l.error,
            resourceLabel: "UMRS grants",
            onRetry: l.refetch
          }
        ) : l.grants.length === 0 ? /* @__PURE__ */ t("p", { className: "text-sm text-[var(--clique-fg-secondary)]", children: "No UMRS roles assigned to this user." }) : /* @__PURE__ */ o(
          Ae,
          {
            value: l.grants,
            size: "small",
            stripedRows: !0,
            pt: d,
            emptyMessage: "No UMRS grants found.",
            children: [
              /* @__PURE__ */ t(X, { header: "Role", body: m }),
              /* @__PURE__ */ t(X, { header: "Resource Server", body: v }),
              /* @__PURE__ */ t(X, { header: "Source", body: u }),
              /* @__PURE__ */ t(X, { header: "Expires", body: i, style: { width: "8rem" } }),
              /* @__PURE__ */ t(X, { body: h, style: { width: "4rem" } })
            ]
          }
        ),
        /* @__PURE__ */ t(
          Or,
          {
            visible: l.showAssignDialog,
            onHide: () => l.setShowAssignDialog(!1),
            assignTo: "user",
            preselectedUserId: e,
            onAssigned: l.refetch,
            onSuccess: r,
            onError: a
          }
        ),
        /* @__PURE__ */ t(
          Ge,
          {
            visible: l.grantToRevoke !== null,
            onHide: () => l.setGrantToRevoke(null),
            onConfirm: l.handleRevoke,
            header: "Revoke UMRS Grant",
            message: `Are you sure you want to revoke the "${(g = l.grantToRevoke) == null ? void 0 : g.roleName}" role from this user?`,
            confirmLabel: "Revoke",
            confirmSeverity: "danger",
            loading: l.isRevoking
          }
        )
      ]
    }
  );
}
class Vl extends ys {
  constructor(a) {
    super(a);
    lt(this, "handleRetry", () => {
      this.setState({ hasError: !1 });
    });
    this.state = { hasError: !1 };
  }
  static getDerivedStateFromError() {
    return { hasError: !0 };
  }
  componentDidCatch(a, s) {
    console.error("ErrorBoundary caught:", a, s.componentStack);
  }
  render() {
    return this.state.hasError ? this.props.fallback ? this.props.fallback : /* @__PURE__ */ o(
      "div",
      {
        className: be(
          "flex flex-col items-center justify-center py-12 text-center",
          this.props.className
        ),
        style: this.props.style,
        children: [
          /* @__PURE__ */ t(
            "i",
            {
              "aria-hidden": "true",
              className: "pi pi-exclamation-triangle text-4xl text-[var(--clique-destructive)] mb-4"
            }
          ),
          /* @__PURE__ */ t("h3", { className: "text-lg font-medium text-[var(--clique-fg)] mb-1", children: "Something went wrong" }),
          /* @__PURE__ */ t("p", { className: "text-sm text-[var(--clique-fg-secondary)] mb-4 max-w-md", children: "An unexpected error occurred. Please try again or contact support if the problem persists." }),
          /* @__PURE__ */ t(
            G,
            {
              label: "Try Again",
              icon: "pi pi-refresh",
              onClick: this.handleRetry,
              size: "small",
              severity: "secondary"
            }
          )
        ]
      }
    ) : this.props.children;
  }
}
function Xi(e) {
  const r = /* @__PURE__ */ new Map();
  for (const a of e) {
    const s = r.get(a.family);
    s ? s.push(a) : r.set(a.family, [a]);
  }
  return Array.from(r, ([a, s]) => ({ label: a, items: s }));
}
function Wl({ className: e }) {
  const { currentTheme: r, setTheme: a, themes: s, isDark: n, canSelectTheme: d } = hs(), l = Xi(s);
  if (!d)
    return null;
  const m = (h) => {
    h.value && a(h.value);
  }, v = s.find((h) => h.name === r), i = (h) => /* @__PURE__ */ o("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ t("span", { "aria-hidden": "true", className: `pi ${h.dark ? "pi-moon" : "pi-sun"} text-xs` }),
    /* @__PURE__ */ t("span", { children: h.label })
  ] }), u = (h) => h ? /* @__PURE__ */ o("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ t("i", { "aria-hidden": "true", className: `pi ${n ? "pi-moon" : "pi-sun"} text-xs` }),
    /* @__PURE__ */ t("span", { children: h.label })
  ] }) : /* @__PURE__ */ t("span", { children: "Select Theme" });
  return /* @__PURE__ */ t(
    ge,
    {
      value: r,
      options: l,
      optionLabel: "label",
      optionValue: "name",
      optionGroupLabel: "label",
      optionGroupChildren: "items",
      onChange: m,
      valueTemplate: () => u(v),
      itemTemplate: i,
      className: e,
      panelClassName: "text-sm",
      placeholder: "Select Theme",
      "aria-label": "Select PrimeReact theme"
    }
  );
}
function Zi(e) {
  return /* @__PURE__ */ t("code", { className: "text-sm bg-[var(--clique-bg-subtle)] px-2 py-0.5 rounded", children: `{{${e.name}}}` });
}
function Yl({
  variables: e,
  isLoading: r,
  isError: a,
  error: s,
  onRetry: n
}) {
  return r ? /* @__PURE__ */ t(xe, { message: "Loading variables..." }) : a ? /* @__PURE__ */ t(he, { error: s, resourceLabel: "template variables", onRetry: n }) : e != null && e.length ? /* @__PURE__ */ o(Ae, { value: e, size: "small", stripedRows: !0, children: [
    /* @__PURE__ */ t(X, { field: "name", header: "Name", body: Zi }),
    /* @__PURE__ */ t(X, { field: "description", header: "Description" })
  ] }) : /* @__PURE__ */ t("p", { className: "text-sm text-[var(--clique-fg-secondary)] py-2", children: "No expansion variables available." });
}
function Jl({
  visible: e,
  onHide: r,
  header: a,
  src: s,
  srcDoc: n,
  width: d = "60rem",
  height: l = "85vh",
  sandbox: m = ""
}) {
  const v = s !== void 0, [i, u] = U(!0);
  ne(() => {
    e && v && u(!0);
  }, [e, s, v]);
  const h = L(() => {
    u(!0), r();
  }, [r]), g = L(() => u(!1), []);
  return /* @__PURE__ */ t(
    fe,
    {
      visible: e,
      onHide: h,
      header: a,
      modal: !0,
      draggable: !1,
      resizable: !1,
      maximizable: !0,
      style: { width: d, height: l },
      breakpoints: { "960px": "95vw" },
      contentClassName: "!p-0",
      children: /* @__PURE__ */ o("div", { className: "relative w-full bg-white", style: { height: `calc(${l} - 6rem)` }, children: [
        v && i && /* @__PURE__ */ t("div", { className: "absolute inset-0 flex items-center justify-center bg-white z-10", children: /* @__PURE__ */ t(xe, { message: "Loading preview..." }) }),
        /* @__PURE__ */ t(
          "iframe",
          {
            src: s,
            srcDoc: n,
            title: a,
            className: "w-full h-full border-0",
            onLoad: v ? g : void 0,
            sandbox: m
          }
        )
      ] })
    }
  );
}
function Xl({ isSystem: e }) {
  return e ? /* @__PURE__ */ t(
    ce,
    {
      severity: "info",
      value: /* @__PURE__ */ o("span", { className: "inline-flex items-center gap-1", children: [
        /* @__PURE__ */ t("i", { "aria-hidden": "true", className: "pi pi-lock" }),
        /* @__PURE__ */ t("span", { children: "System" })
      ] })
    }
  ) : null;
}
function Zl({
  className: e,
  style: r,
  title: a = "Customize theme",
  showAdvanced: s = !0,
  showRadius: n = !0,
  showReset: d = !0,
  resetLabel: l = "Reset to default"
}) {
  const { palette: m, curated: v, overrides: i, setToken: u, resetToken: h, resetAll: g, isCustomized: p, radiusVar: f } = bs(), [c, y] = U(!1);
  if (!m)
    return /* @__PURE__ */ t("div", { className: e, style: r, children: /* @__PURE__ */ t("p", { className: "text-sm", style: { color: "var(--clique-fg-muted)" }, children: "Loading theme…" }) });
  const b = i[f] ?? m.borderRadius ?? "", q = Number.parseInt(b, 10), C = Number.isFinite(q) ? q : 6;
  return /* @__PURE__ */ o("div", { className: be("text-sm", e), style: r, children: [
    (a || d) && /* @__PURE__ */ o("div", { className: "mb-3 flex items-center gap-2", children: [
      a && /* @__PURE__ */ t("span", { className: "font-semibold", style: { color: "var(--clique-fg)" }, children: a }),
      p && /* @__PURE__ */ t(
        "span",
        {
          className: "rounded px-2 py-0.5 text-xs",
          style: {
            backgroundColor: "var(--clique-primary-subtle)",
            color: "var(--clique-primary-strong)"
          },
          children: "customized"
        }
      ),
      d && /* @__PURE__ */ o(
        "button",
        {
          type: "button",
          onClick: g,
          className: "ml-auto inline-flex items-center gap-1.5 px-2.5 py-1 text-xs",
          style: {
            color: "var(--clique-fg-secondary)",
            border: "1px solid var(--clique-border)",
            borderRadius: "var(--clique-radius)",
            backgroundColor: "var(--clique-bg)",
            cursor: "pointer"
          },
          children: [
            /* @__PURE__ */ t("i", { "aria-hidden": "true", className: "pi pi-refresh", style: { fontSize: "0.7rem" } }),
            l
          ]
        }
      )
    ] }),
    /* @__PURE__ */ o("div", { className: "flex flex-wrap gap-5", children: [
      v.map((N) => /* @__PURE__ */ o(
        "label",
        {
          className: "flex items-center gap-2",
          style: { color: "var(--clique-fg)" },
          children: [
            N.label,
            /* @__PURE__ */ t(
              "input",
              {
                type: "color",
                "aria-label": N.label,
                value: i[N.slot] ?? N.base,
                onChange: (x) => u(N.slot, x.target.value)
              }
            )
          ]
        },
        N.slot
      )),
      n && m.borderRadius && /* @__PURE__ */ o("label", { className: "flex items-center gap-2", style: { color: "var(--clique-fg)" }, children: [
        "Radius ",
        C,
        "px",
        /* @__PURE__ */ t(
          "input",
          {
            type: "range",
            min: 0,
            max: 24,
            value: C,
            "aria-label": "Border radius",
            onChange: (N) => u(f, `${N.target.value}px`)
          }
        )
      ] })
    ] }),
    s && /* @__PURE__ */ o(Ce, { children: [
      /* @__PURE__ */ o(
        "button",
        {
          type: "button",
          className: "mt-3 text-xs underline",
          style: { color: "var(--clique-primary)", cursor: "pointer" },
          onClick: () => y((N) => !N),
          children: [
            c ? "Hide" : "Show",
            " all ",
            m.slots.length,
            " palette colors"
          ]
        }
      ),
      c && /* @__PURE__ */ t("div", { className: "mt-3 flex flex-wrap gap-3", children: m.slots.map((N) => {
        const x = N.slot in i;
        return /* @__PURE__ */ o("div", { className: "flex flex-col items-center gap-1", children: [
          /* @__PURE__ */ t(
            "input",
            {
              type: "color",
              "aria-label": N.names[0] ?? N.base,
              title: N.names.join(", ") || N.base,
              value: i[N.slot] ?? N.base,
              onChange: (w) => u(N.slot, w.target.value)
            }
          ),
          /* @__PURE__ */ t(
            "button",
            {
              type: "button",
              className: "text-[10px]",
              style: {
                color: x ? "var(--clique-primary)" : "var(--clique-fg-tertiary)",
                cursor: x ? "pointer" : "default"
              },
              onClick: () => h(N.slot),
              disabled: !x,
              children: x ? "reset" : N.base
            }
          )
        ] }, N.slot);
      }) })
    ] })
  ] });
}
function eo(e) {
  const { role: r, onUpdated: a, onDeleted: s, onError: n, onDismiss: d } = e, {
    form: l,
    updateField: m,
    errors: v,
    setFieldError: i,
    clearErrors: u,
    submitError: h,
    setSubmitError: g,
    hydrate: p
  } = He({ name: "", description: "" }), f = Tt(), c = kt(), y = Ie(null);
  ne(() => {
    r && r.id !== y.current && (y.current = r.id, p({
      name: r.name,
      description: r.description ?? ""
    }));
  }, [r, p]);
  const b = !!r && (l.name !== r.name || l.description !== (r.description ?? "")), q = L(() => {
    if (!r) return;
    const N = l.name.trim(), x = Ee(N, "Name") ?? Fe(N, 2, "Name");
    if (x) {
      i("name", x);
      return;
    }
    u(), g("");
    const w = l.description.trim();
    f.mutate(
      {
        accessRoleId: r.id,
        data: { name: N, description: w }
      },
      {
        onSuccess: () => {
          a == null || a({
            ...r,
            name: N,
            description: w
          }), d == null || d();
        },
        onError: (I) => {
          console.error("Failed to update access role", I);
          const S = Xe(I) !== 403 ? "Failed to update access role. Please try again." : ir({ message: lr(I) });
          g(S), n == null || n(S);
        }
      }
    );
  }, [
    l,
    r,
    f,
    a,
    d,
    n,
    i,
    u,
    g
  ]), C = L(() => {
    r && c.mutate(r.id, {
      onSuccess: () => {
        s == null || s(), d == null || d();
      },
      onError: (N) => {
        console.error("Failed to delete access role", N);
        const x = "Failed to delete access role. Please try again.";
        g(x), n == null || n(x);
      }
    });
  }, [r, c, s, d, n, g]);
  return {
    form: l,
    updateField: m,
    nameError: v.name ?? "",
    submitError: h,
    handleSubmit: q,
    handleDelete: C,
    isPending: f.isPending,
    isDeleting: c.isPending,
    isDirty: b
  };
}
export {
  ao as ACR_MULTIFACTOR,
  so as ACR_PHISHING_RESISTANT,
  no as ADMIN_PERMISSIONS_UPDATE_SCOPE,
  Mn as AddMemberDialog,
  io as ApiClientProvider,
  he as ApiErrorDisplay,
  lo as BrandingProvider,
  oo as CLIQUE_BASE_SCOPES,
  co as CLIQUE_SCOPES,
  uo as CLIQUE_SCOPE_NAMES,
  mo as CliqueProvider,
  po as CliqueThemeProvider,
  Ge as ConfirmDialog,
  Mr as DEFAULT_GROUPS_RESOLUTION_ERRORS,
  go as DEFAULT_ICONS,
  xt as DEFAULT_INVITATION_APPROVE_IN,
  yt as DEFAULT_INVITATION_APPROVE_IN_UNIT,
  ns as DefaultIdentityIssuerMode,
  Je as EmptyState,
  Vl as ErrorBoundary,
  vo as FormatProvider,
  Ll as GroupCardGrid,
  Tl as GroupCreateDialog,
  kl as GroupDetail,
  Zn as GroupDetailDialog,
  Pl as GroupList,
  zt as GroupMembersSection,
  Ot as GroupRolesSection,
  Kt as GroupUmrsGrantsSection,
  Jl as HtmlPreviewDialog,
  fo as IconsProvider,
  ho as InvitationApproveInUnit,
  bo as InviteConfigProvider,
  Bn as InviteMemberDialog,
  yo as LARA_BLUE_PRIMARY_PALETTE,
  xo as LabelsProvider,
  xe as LoadingSpinner,
  No as NAMESPACE_LIST_SCOPE_REQUIREMENT,
  Pr as NamespaceDropdown,
  Io as NamespaceScopeProvider,
  So as NotificationProvider,
  qo as PRIMEREACT_THEMES,
  Co as PRIME_TOKEN_TO_CSS_VAR,
  gi as PermissionCreateDialog,
  $l as PermissionEditDialog,
  Ml as PermissionList,
  wo as PermissionsProvider,
  rt as ResourceServerCreateDialog,
  _l as ResourceServerEditDialog,
  Ol as ResourceServerList,
  Gl as RoleCreateDialog,
  Dl as RoleList,
  Ul as RolePermissionsDialog,
  Ro as STEP_UP_AUTH_CHALLENGE_ERROR,
  Eo as STEP_UP_AUTH_ERROR_CODE,
  cr as SearchInput,
  Fo as SessionManagementProvider,
  Ao as SessionTimeoutDialog,
  Po as StepUpResumeHandler,
  Xl as SystemBadge,
  Lo as THEME_RADIUS_OVERRIDE_VAR,
  To as TOKEN_TO_CSS_VAR,
  Yl as TemplateVariablesTable,
  ko as TenantProvider,
  Zl as ThemeCustomizer,
  Do as ThemeProvider,
  Wl as ThemeSelector,
  Te as USER_CREATE_MESSAGES,
  Or as UmrsGrantAssignDialog,
  Kl as UmrsRoleCreateDialog,
  Ql as UmrsRoleEditDialog,
  Fi as UmrsRoleGrantsSection,
  zl as UmrsRoleList,
  Go as UserCreateConfigProvider,
  zi as UserCreateDialog,
  jl as UserList,
  Qt as UserListView,
  Bl as UserProfileCard,
  Hl as UserUmrsGrantsSection,
  Fs as accessInvitationApi,
  wt as accessRequestKeys,
  Es as accessRequestsApi,
  ye as accessRoleKeys,
  Ue as accessRolesApi,
  as as allowsNamespaceList,
  Uo as buildReplayConfig,
  Vr as buildSearchWhere,
  gr as clientKeys,
  Br as clientsApi,
  Mo as cliqueFeatureScope,
  cs as cliqueFeatureScopes,
  $o as cliqueScopes,
  Oo as createApiClient,
  _o as curatedTokens,
  be as cx,
  ls as domainIdpKeys,
  is as domainIdpMappingApi,
  gs as escapeLikePattern,
  xa as getApiClient,
  ve as groupKeys,
  Qe as groupMemberKeys,
  er as groupMembersApi,
  hr as groupsApi,
  zo as isCssVariableName,
  Ko as isStepUpAuthError,
  $r as issuerKeys,
  qt as issuersApi,
  Zr as namespaceKeys,
  Ct as namespacesApi,
  Qo as paletteOverridesToCss,
  jo as parseScopeClaim,
  Bo as parseStepUpChallenge,
  Ho as parseThemePalette,
  Vo as primaryColorToSlotOverrides,
  Wo as primaryPaletteToCss,
  Yo as primeTokensToCss,
  Jo as readConnectionFromUrl,
  ar as requestableAccessKeys,
  Ar as requestableAccessesApi,
  F as requireTenantId,
  nr as resourceServerKeys,
  sr as resourceServerPermissionKeys,
  Er as resourceServerPermissionsApi,
  Rr as resourceServersApi,
  Xo as resumeStepUpRequest,
  ds as satisfiesScopeRequirement,
  Zo as stripConnectionParam,
  ed as tenantsApi,
  rd as tokenizePrimaryPalette,
  td as tokenizeThemeCss,
  ad as tokensToCss,
  qe as umrsGrantKeys,
  Be as umrsGrantsApi,
  Ke as umrsRoleKeys,
  br as umrsRolesApi,
  Js as useAccessRole,
  Xs as useAccessRoleCount,
  en as useAccessRolePermissions,
  Lt as useAccessRoles,
  rn as useAddAccessRolePermission,
  Bs as useAddBulkGroupMember,
  sn as useAddGroupAccessRole,
  ql as useAddGroupMember,
  Gn as useAddMembersController,
  Vs as useAddUserToGroups,
  Sn as useAllGroupGrants,
  In as useAllUserGrants,
  sd as useApiClient,
  Cn as useAssignUmrsGrantToGroup,
  qn as useAssignUmrsGrantToUser,
  nd as useBranding,
  id as useCanAccess,
  wl as useClientByClientId,
  Cl as useClients,
  Al as useColorScheme,
  Ze as useComponentAccess,
  Us as useCreateAccessInvitation,
  xl as useCreateAccessRequest,
  Zs as useCreateAccessRole,
  $s as useCreateGroup,
  En as useCreateNamespace,
  ks as useCreateRequestableAccess,
  pn as useCreateResourceServer,
  on as useCreateResourceServerPermission,
  hn as useCreateUmrsRole,
  Pt as useCreateUser,
  Ft as useCreateUserGroupOptions,
  kt as useDeleteAccessRole,
  _s as useDeleteGroup,
  Gs as useDeleteRequestableAccess,
  vn as useDeleteResourceServer,
  cn as useDeleteResourceServerPermission,
  yn as useDeleteUmrsRole,
  ld as useDomainIdpMapping,
  od as useFeatureAccess,
  Fr as useFormat,
  At as useGroup,
  an as useGroupAccessRoles,
  ei as useGroupCardGridController,
  Et as useGroupCount,
  ti as useGroupCreateController,
  $t as useGroupDetailController,
  An as useGroupListController,
  Sl as useGroupMemberCount,
  js as useGroupMembers,
  Hn as useGroupMembersController,
  Dn as useGroupRolesController,
  Jn as useGroupUmrsGrantsController,
  dr as useGroups,
  dd as useHasScope,
  fr as useIcons,
  Hr as useInviteConfig,
  zn as useInviteMembersController,
  wn as useIssuers,
  Re as useLabels,
  Nl as useNamespaceDefaultGroups,
  un as useNamespaceResourceServerIds,
  Di as useNamespaceUsersController,
  et as useNamespaces,
  cd as useNotifications,
  os as useOptionalNamespaceScope,
  ps as useOptionalNotifications,
  vr as useOptionalPermissions,
  ms as useOptionalUserCreateClientId,
  fs as useOptionalUserCreateConfig,
  pi as usePermissionCreateController,
  bi as usePermissionEditController,
  fi as usePermissionListController,
  ud as usePermissions,
  tn as useRemoveAccessRolePermission,
  nn as useRemoveGroupAccessRole,
  Ws as useRemoveGroupMember,
  Rt as useRequestableAccessForGroup,
  je as useResolvedNamespaceId,
  Oe as useResourceServerConfig,
  mn as useResourceServerCount,
  di as useResourceServerCreateController,
  Ii as useResourceServerEditController,
  xi as useResourceServerListController,
  yr as useResourceServerOptions,
  ln as useResourceServerPermissionCount,
  Dt as useResourceServerPermissions,
  Xr as useResourceServers,
  Mt as useRevokeGroupGrant,
  Ut as useRevokeUserGrant,
  li as useRoleCreateController,
  eo as useRoleEditController,
  si as useRoleListController,
  ui as useRolePermissionsController,
  Qs as useSearchUsers,
  md as useSessionManagement,
  z as useTenant,
  pd as useTenantId,
  Rn as useTenantProviders,
  hs as useTheme,
  bs as useThemeCustomization,
  Nn as useUmrsGrantsForGroup,
  xn as useUmrsGrantsForUser,
  Rl as useUmrsRole,
  fn as useUmrsRoleCount,
  Ri as useUmrsRoleCreateController,
  Ai as useUmrsRoleEditController,
  Ei as useUmrsRoleGrantsController,
  qi as useUmrsRoleListController,
  Gt as useUmrsRoles,
  Tt as useUpdateAccessRole,
  Os as useUpdateGroup,
  Fl as useUpdateGroupGrant,
  Hs as useUpdateGroupMember,
  Ds as useUpdateRequestableAccess,
  gn as useUpdateResourceServer,
  dn as useUpdateResourceServerPermission,
  bn as useUpdateUmrsRole,
  El as useUpdateUserGrant,
  Ks as useUser,
  zs as useUserCount,
  gd as useUserCreateConfig,
  _i as useUserCreateController,
  Il as useUserGroupMemberships,
  vd as useUserGroups,
  Li as useUserListController,
  fd as useUserProfile,
  Yi as useUserUmrsGrantsController,
  Yr as useUsers,
  Ys as useUsersInNamespaces,
  De as userKeys,
  hd as userProfileApi,
  bd as userProfileKeys,
  or as usersApi,
  Fe as validateMinLength,
  Ee as validateRequired
};
//# sourceMappingURL=index.js.map
